const enMessages = {
  "rules.override.session": "Reemplazo de sesión",
  "rules.override.active.session": "Permitir reemplazo de sesión activa",
  "common.api.key.message": "Por favor, configure su clave de API en la configuración",
  "common.api.key.missing": "API Key is missing",
  "common.delete.error": "Error al eliminar",
  "apis.google.maps.description": "Google Maps ofrece mapas precisos y rutas de navegación en tiempo real",
  "google.maps": "Google Maps",
  "common.long": "Longitud",
  "common.lat": "Latitud",
  "common.api.config": "Configuración de API",
  "common.api.configs": "Configuraciones de API",
  "common.api.configs.add": "Agregar Configuración de API",
  "common.api.configs.edit": "Editar Configuración de API",
  "common.api.configs.delete": "Eliminar Configuración de API",
  "common.api.configs.delete.multiple": "Eliminar Configuraciones de API",
  "common.api.configs.delete.multiple.confirm": "¿Está seguro de que desea eliminar las configuraciones de API seleccionadas?",
  "common.api.configs.delete.multiple.success": "Configuraciones de API eliminadas con éxito",
  "common.api.key": "Clave de API",
  "common.maps": "Mapas",
  "common.maps.satellite": "Satélite",
  "common.maps.terrain": "Terreno",
  "common.maps.hybrid": "Híbrido",
  "common.master": "Sede",
  "common.filial": "Subsidiaria",
  "common.error.invalid.format.core.max": "Valor por encima del límite, máximo permitido",
  "common.error.invalid.format.core.min": "Valor por debajo del límite, mínimo permitido",
  "common.id": "ID",
  "common.portuguese": "Portugués",
  "common.english": "Inglés",
  "common.sync": "Sincronización",
  "common.next": "Siguiente",
  "common.prev": "Previo",
  "common.none": "Ningún",
  "common.user": "Usuario",
  "common.password": "Contraseña",
  "common.security": "Seguridad",
  "common.malware": "Malware",
  "common.site": "Sitio",
  "common.threat": "Amenaza",
  "common.malicious": "Dirección IP Malicioso",
  "common.server": "Servidor",
  "common.servers": "Servidores",
  "common.port": "Puerta",
  "common.hostname": "Nombre del Host",
  "common.force.safe.search": "Forzar Búsqueda Segura",
  "common.host": "Host",
  "common.domain": "Dominio",
  "common.timezone": "Zona horaria",
  "common.language": "Idioma",
  "common.cancel": "Cancelar",
  "common.yes": "Sí",
  "common.no": "No",
  "common.close": "Cerrar",
  "common.save": "Salvar",
  "common.backup": "Copia de seguridad",
  "common.backups": "Copia de seguridad",
  "common.restore": "Restaurar",
  "common.used": "Uso",
  "common.uptime": "Tiempo de Funcionamiento",
  "common.disc": "Disco",
  "common.idle": "Inactivo",
  "common.time.system": "Hora del Sistema",
  "common.add.to.list": "Añadir a la lista",
  "common.add.to.filter": "Añadir al filtro",
  "common.del.to.list": "Quitar de la lista",
  "common.group": "Grupo",
  "common.devicesWithoutGroup": "Dispositivos sin Grupo",
  "common.create": "Crear",
  "common.delete": "Eliminar",
  "common.create.name": "Crear {name}",
  "common.delete.name": "Eliminar {name}",
  "common.system.updates": "Updates",
  "common.update": "Atualizar",
  "common.updates": "Actualizaciones",
  "common.edit": "Editar",
  "common.configure": "Configurar",
  "common.view": "Previsualizar",
  "common.name": "Nombre",
  "common.description": "Descripción",
  "common.workers": "Workers",
  "common.Lease": "Leases",

  "common.version": "Versión",
  "common.mode": "Modo",
  "common.protocol": "Protocolo",
  "common.protocols": "Protocolos",
  "common.position": "Posición",
  "common.enabled": "Activado",
  "common.disabled": "Desactivado",
  "common.disableds": "Desactivado",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "common.any": "Cualquier",
  "common.always": "Siempre",
  "common.total": "Total",
  "common.back": "Volver",
  "common.clear": "Limpiar",
  "common.template": "Plantilla",
  "common.template.name": "Nombre del Plantilla",
  "common.confirm":
    "Estas seguro que quieres {action} lo(s) siguiente(s) {type}{len, plural, one {} other {s}}{value}?",
  "common.confirm.group":
    "¿Estás seguro de que quieres eliminar lo(s) siguiente(s) grupo(s)?",
  "common.confirm.policy":
    "¿Estás seguro de que quieres eliminar la(s) siguiente(s) política(s)?",
  "common.confirm.delete": "¿Estas seguro?",
  "common.select_all": "Seleccionar Todos",
  "common.allow_all": "Permitir Todos",
  "common.deny_all": "Rechazar Todos",
  "common.block_all": "Bloquee Todos",
  "common.disable_all": "Desactivar Todos",
  "common.warning_all": "Alertar Todos",
  "common.deselect_all": "Deseleccionar Todos",
  "common.noGroup": "Ningún Grupo",
  "common.invalid.value": "¡Valor ilegal!",
  "common.invalid.form": "¡Por favor, revise este formulario!",
  "common.required.field": "Campo Requerido",
  "common.text.too.long": "Cantidad máxima de caracteres alcanzado",
  "common.text.too.long.70c": "El valor no deberá ser superior a 70 caracteres",
  "common.perSecond": "por segundo",
  "common.perMinute": "por minuto",
  "common.perHour": "por hora",
  "common.passive": "Pasivo",
  "common.informations": "Informaciones",
  "common.conditions": "Requisitos",
  "common.inspection": "Inspección",
  "common.controls": "Controles",
  "common.rule": "Regla",
  "common.reason": "Razón",
  "common.user.agent": "Plataforma",
  "common.allow": "Permitir",
  "common.allowed": "Permitido",
  "common.alloweds": "Permitidos",
  "common.deny": "Rehusar",
  "common.declined": "Rechazado",
  "common.decline": "Rechazar",
  "common.denied": "Negado",
  "common.warning": "Atención",
  "common.reject": "Rechazar",
  "common.all": "Todos",
  "common.allDevices": "Todos los Dispositivos",
  "common.selected": "Seleccionado",
  "common.selected.objects": "{count} seleccionados",
  "common.general": "General",
  "common.config": "Configuración",
  "common.type": "Tipo",
  "common.logtype": "Tipo de log",
  "common.logs": "Logs",
  "common.groups": "Grupos",
  "common.sources": "Origenes",
  "common.clone": "Clonar",
  "common.working": "Procesando...",
  "common.actions": "Acciones",
  "common.action": "Acción",
  "common.client": "Cliente",
  "common.system": "Sistema",
  "common.license": "Licencia",
  "common.sessions": "Sesiones",
  "common.services": "Servicios",
  "common.interfaces": "Interfaces",
  "common.interface": "Interfaz",
  "common.email": "Correo Electrónico",
  "common.email.report": "Enviar informe por correo electrónico",
  "common.email.group.report": "Enviar informe al grupo de correo electrónico",
  "common.error.email.group.report": "Algunos correos electrónicos no son válidos",
  "common.placeholder.email.group.report": "Agregar correos electrónicos",
  "common.users": "Usuarios",
  "common.profiles": "Perfiles",
  "common.audit": "Auditoría",
  "common.save.success": "Guardado con éxito",
  "common.save.error": "¡Error al guardar!",
  "common.processes": "Procesos",
  "common.remove": "Eliminar",
  "common.device": "Dispositivo",
  "common.deviceLogger": "Dispositivo/Logger",
  "common.status": "Estatus",
  "common.block": "Bloquear",
  "common.quarantine": "Cuarentena",
  "common.pcap": "PCAP",
  "common.packetLogger": "Packet Logger",
  "common.prefixPcap": "Prefijo de archivo",
  "common.minFile": "Tamaño mínimo de archivo (MB)",
  "common.profile_filesize": "Tamaño máximo do arquivo (MB)",
  "common.quantity": "Cantidad",
  "common.risk": "Riesgo",
  "common.high": "Elevado",
  "common.medium": "Medio",
  "common.low": "Bajo",
  "common.category": "Categoría",
  "common.sid": "SID",
  "common.blocked": "Bloqueado",
  "common.blockeds": "Bloqueados",
  "common.unblocked": "Desbloqueado",
  "common.source": "Origen",
  "common.destination": "Destino",
  "common.enable": "Activar",
  "common.disable": "Desactivar",
  "common.unblock": "Desbloquear",
  "common.profile": "Perfil",
  "common.custom": "Personalizar",
  "common.deleted": "{name} eliminado correctamente",
  "common.date": "Fecha",
  "common.archive": "Archivo",
  "common.service": "Servicio",
  "common.search": "Búsqueda",
  "common.filters": "Filtros",
  "common.filter": "Filtro",
  "common.task": "Task",
  "common.auditor": "Auditor",
  "common.created": "Creado",
  "common.accept": "Aceptar",
  "common.activity": "Actividad",
  "common.logger": "Logger",
  "common.error": "Error",
  "common.error.network": "¡Error de red!",
  "common.error.required": "{name} es obligatorio",
  "common.error.required.ip.forwarding": "IP es obligatorio",
  "common.error.alphanumeric":
    "Campo alfa-numérico en minúscula es obligatorio (a-z0-9_-)",
  "common.error.invalid": "{name} no es válido",
  "common.error.invalid.value": "Valor no es válido",
  "common.error.invalid.format": "Formato no es válido",
  "common.error.fetch": "Error al buscar os datos",
  "common.error.character": "Carácter no es válido",
  "common.error.min.character":
    "El campo debe tener al menos {number} caracteres",
  "common.authentication.required": "El campo MFA es obligatorio",
  "common.error.version": "versión no compatible",
  "common.error.file.notFound": "Archivo no encontrado",
  "common.error.url": "{name} debe ser una url válida",
  "common.error.url.fail": "Url inválida",
  "common.error.url.https": "Esta URL debe ser del tipo https",
  "common.error.email": "{name} debe ser un e-mail válido",
  "common.error.saml.service.name":
    "Solo texto alfa-numérico y minúsculo. ([a-z0-9_-])",
  "common.error.snap.version":
    "Snapshot incompatible - Versión del servidor: {serverVersion} - Versión del snapshot: {snapVersion}",
  "common.error.dont.permition": "Su login no permite el acceso a esta área.",
  "common.top": "Top",
  "common.hits": "Hits",
  "common.traffic": "Tráfico",
  "common.select": "Seleccionar",
  "common.page": "Página",
  "common.done": "Concluído",
  "common.provisioning": "Aprovisionamiento",
  "common.connect": "Conectado",
  "common.identification": "Identificación",
  "common.model": "Modelo",
  "common.scheduled": "Previsto",
  "common.firewall": "Firewall",
  "common.default": "Por defecto",
  "common.dhcp": "DHCP",
  "common.confirm.ok": "Confirmar",
  "common.uuid": "UUID",
  "common.add": "Agregar",
  "common.company": "Compañía",
  "common.devTemplate": "Modelo de Dispositivo",
  "common.polPackage": "Paquete de Política",
  "common.devComm": "Comunidad de Dispositivo",
  "common.alreadyExists": "Ya hay",
  "common.dns": "DNS",
  "common.dns_server": "Servidor DNS",
  "common.progress": "Progreso",
  "common.import": "Importar {name}",
  "common.list": "Lista",
  "common.templates": "Modelo de Dispositivo",
  "common.templates.combo": "Modelo de Dispositivo",
  "common.community": "Comunidad de Dispositivo",
  "common.certificate": "Certificado",
  "common.certificate.remote": "CA Remota",
  "common.certificates": "Certificados",
  "common.years": "Años",
  "common.country": "País",
  "common.state": "Estado",
  "common.city": "Ciudad",
  "common.organization": "Empresa",
  "common.unit": "Unidad Organizativa",
  "common.expires": "Expira en (años)",
  "common.license.expires.at": "La licencia expira en:",
  "common.show.all": "Ver todo",
  "common.items.not.found": "Ningún objeto encontrado",
  "common.apply": "Aplicar",
  "common.values": "Valores",
  "common.time": "Tiempo",
  "common.ip": "Dirección IP",
  "common.ips": "Dirección es IPs",
  "common.network": "Red",
  "common.simultaneous.transfers": "Transferencias Concurrentes",
  "common.whitelist": "Direcciones Permitidas",
  "common.blacklist": "Direcciones Bloqueadas",
  "common.invalid.fields": "Campos no válidos",
  "common.dnsServer": "Servidor DNS",
  "common.domain1": "Dominio.com",
  "common.dns1": "DNS Primario",
  "common.dns2": "DNS Secundario",
  "common.dnssuffix": "Sufijo DNS",
  "common.gateway": "Gateway",
  "common.ntpserver": "Servidor NTP",
  "common.ipExample": "1.1.1.1",
  "common.maskExample": "255.255.255.255",
  "common.object.address": "Dirección",
  "common.object.service": "Servicio",
  "common.object.time": "Tiempo",
  "common.object.schedule": "Programación",
  "common.object.dictionary": "Diccionario",
  "common.object.content": "Contenido",
  "common.profile.webfilter": "Perfil de Web Filter",
  "common.profile.webfilter.inUse":
    "¡No se pudo eliminar lo perfil! Perfil en uso",
  "common.profile.appcontrol": "Perfil de Application Control",
  "common.profile.atp": "Perfil de Threat Protection",
  "common.profile.ips": "Perfil de Intrusion Prevention",
  "common.profile.ssl": "Perfil de Inspección SSL",
  "common.profile.sdwan": "Perfil de SD-WAN",
  "common.profile.sdwan.space.error": "Nombre del perfil con espacio",
  "common.manager.delete.group.message.withdevice":
    "¡Hay un dispositivo asociado al grupo {name}! ¿Estás seguro de que desea eliminarlo?",
  "common.manager.delete.group.message":
    "¿Estás seguro de que desea eliminar lo grupo {name}?",
  "common.wizard.network.dns1": "Servidor DNS 1",
  "common.wizard.network.dns2": "Servidor DNS 2",
  "common.wizard.network.dns1.error": "Servidor DNS 1 es obligatorio",
  "common.policy": "Política",
  "common.established": "Establecido",
  "common.new": "Nuevo",
  "common.import-file": "Importar Archivo",
  "common.start": "Iniciar",
  "common.paste.here": "Pega Aquí",
  "common.stop": "Parar",
  "common.zone": "Zona",
  "common.bytes": "Bytes",
  "common.bytes.received": "Bytes Recibidos",
  "common.bytes.sent": "Bytes Enviados",
  "common.bytes.total": "Bytes Total",
  "common.packages": "Paquetes",
  "common.packages.combo": "Paquetes de Políticas",
  "common.packages.received": "Paquetes Recibidos",
  "common.packages.sent": "Paquetes Enviados",
  "common.packages.total": "Paquetes Total",
  "common.connection": "Conexión",
  "common.connections": "Conexiones",
  "commom.confirm.delete": "¿Estás seguro de que desea eliminar?",
  "common.application": "Aplicaciones",
  "common.attack": "Ataque",
  "common.latency": "Latencia",
  "common.jitter": "Jitter",
  "common.packetLoss": "Pérdida de Paquetes",
  "common.bandwidth": "Bandwidth",
  "common.balancing": "Equilibrio",
  "common.traffic.distribution": "Distribución del Tráfico",
  "common.deploy": "Deploy",
  "common.custom-signature": "Firma Personalizada",
  "common.wizard.admin.repass.mismatch":
    "La contraseña en el campo de confirmación no coincide con la contraseña escrita anteriormente",
  "common.authentication": "Autentificación",
  "common.routes": "Rutas",
  "common.dont.permission": "No tienes permiso para realizar esta acción",
  "common.dont.permission.page": "No tienes permiso para acceder a esta página",
  "common.dont.permission.delete":
    "No tienes permiso para eliminar este registro",
  "common.dont.permission.clone": "No tienes permiso para clonar este registro",
  "common.dont.permission.edit": "No tienes permiso para editar este registro",
  "common.blocked.ha": "High Availability Habilitado - Estado: Backup - Acceso Bloqueado.",
  "common.server.error":
    "Error en el servidor, por favor contacte el administrador del sistema",
  "common.login.form": "Accede a tu cuenta",
  "common.login.form.email": "Correo Electrónico",
  "common.login.form.email.required": "Correo Electrónico es obligatorio",
  "common.login.form.password": "Contraseña",
  "common.login.form.password.required": "La contraseña es obligatoria",
  "common.login.form.forgot": "Se te olvidó tu contraseña?",
  "common.devin": "Dispositivo",
  "common.mask": "Máscara",
  "common.mac": "MAC",
  "common.sso": "SSO",
  "common.read": "Lectura",
  "common.write": "Escritura",
  "common.settings": "Configuraciones",
  "common.exception": "Excepción",
  "common.transparent": "Transparente",
  "common.select.time.ini": "Seleccione la hora de inicio",
  "common.select.time.end": "Seleccione la hora final",
  "common.records": "registros",
  "common.first": "Primero",
  "common.record": "registro",
  "common.limit.profile": "Limite de perfiles creados",
  "common.src": "Origen",
  "common.dst": "Destino",
  "common.virtualAddress": "Dirección Virtual",
  "common.duration": "Duración",
  "common.packets": "Paquetes",
  "common.event": "Evento",
  "common.storages": "Almacenamientos",
  "common.storage": "Almacenamiento",
  "common.virtualDomain": "Dominio Virtual",
  "common.logging": "Logging",
  "common.notifications": "Notificaciones",
  "common.highAvailability": "Alta Disponibilidad",
  "common.vdom": "Dominios Virtuales",
  "common.days": "Días",
  "common.months": "Meses",
  "common.unlimited": "Ilimitado",
  "common.disk": "disco",
  "common.ipAddress": "Dirección IP",
  "common.reload": "Recargar",
  "common.time.conection": "Tiempo de Conexión",
  "common.secret": "Secreto",
  "common.seconds": "segundo(s)",
  "common.size": "Tamaño",
  "common.login": "Acceso",
  "common.logout": "Cierre de sesión",
  "common.share": "Intercambio",
  "common.directory": "Directorio",
  "common.copied": "Copiado",
  "common.max": "Max",
  "common.authenticated": "Autenticado",
  "common.auth": "Autenticado",
  "common.modules": "Módulos",
  "common.delete.success": "Eliminado con éxito",
  "common.clone.success": "Clonado con éxito",
  "common.clone.error": "Error al clonar",
  "common.nothing.delete": "Ningún objeto para eliminar",
  "common.disclaimer": "Descargo de responsabilidad",
  "common.minutes": "Minutos",
  "common.hours": "Horas",
  "common.at.hours": "a las",
  "common.at.day": "Día",
  "common.completed": "Completo",
  "common.administrators": "Administradores",
  "common.users.profiles": "Perfiles de Usuario",
  "common.auth.servers": "Servidores de Autenticación",
  "common.identity.provider": "Proveedor de Identidad",
  "common.audit.log": "Registros de auditoría",
  "common.high.availability": "Alta Disponibilidad",
  "common.standalone": "Remoto",
  "common.integrated": "Incorporado",
  "common.disclaimer.login.title": "Descargo de responsabilidad de Acceso",
  "common.initial.space.error": "Espacio inicial no está permitido",
  "common.remote": "Remoto",
  "common.complete": "Completo",
  "common.diff": "Diferencial",
  "common.name.already.exists": "¡Nombre de perfil ya existe!",
  "common.access.control": "Control de acceso",
  "common.select.device.logger": "Seleccione Device/Logger",
  "common.vpn": "VPN",
  "common.static.routing": "Enrutamiento Estatico",
  "common.relevance": "Relevancia",
  "common.local": "Local",
  "common.maintenance": "Mantenimiento",
  "common.all.files": "Todos los archivos",
  "common.temporary": "Temporal",
  "common.reports": "Informes",
  "common.statistics": "Estadísticas",
  "common.invalid.form.risk.item": "No se permite elegir más de dos ítems por riesgo",
  "common.copy": "Copiar",
  "common.access.multifactor": "MFA",
  "common.access.multifactor.active": "Identificación de dos factores",
  "common.access.multifactor.validate": "Usuario con clave registrada",
  "device.config.success": "Dispositivo configurado",
  "common.waiting": "Esperando",
  "common.waiting.approval": "Esperando aprobación",
  "common.in_progress": "Aplicando configuraciones iniciales",
  "common.registry": "Registrando",
  "common.license.expired": "Licencia expirada",
  "provisioning.batch": "Verificando lote",
  "provisioning.error.batch": "Error en el lote",
  "common.config.device": "Configurando dispositivo",
  "common.waiting.key.exchange": "Esperando intercambio de claves",
  "common.connecting": "Conectando dispositivo",
  "common.confirmSignatures": "¿Confirmar el cambio en {value} firmas?",
  "deploy.sending": "Enviando despliegue",
  "deploy.applying": "Aplicando despliegue",
  "administration.profiles.datagrid.name": "Nombre",
  "administration.profiles.datagrid.email": "Correo Electrónico",
  "administration.profiles.datagrid.key": "Generar Clave",
  "country.local": "Red Local",
  "country.AD": "Andorra",
  "country.AE": "Emiratos Árabes Unidos",
  "country.AF": "Afganistán",
  "country.AG": "Antigua y Barbuda",
  "country.AI": "Anguilla",
  "country.AL": "Albania",
  "country.AM": "Arménia",
  "country.AO": "Angola",
  "country.AP": "Asía/Región del Pacífico",
  "country.AQ": "Antártida",
  "country.AR": "Argentina",
  "country.AS": "Samoa Americana",
  "country.AT": "Austria",
  "country.AU": "Australia",
  "country.AW": "Aruba",
  "country.AX": "Islas Aland",
  "country.AZ": "Azerbaiyán",
  "country.BA": "Bosnia y Herzegovina",
  "country.BB": "Barbados",
  "country.BD": "Bangladesh",
  "country.BE": "Bélgica",
  "country.BF": "Burkina Faso",
  "country.BG": "Bulgaria",
  "country.BH": "Bahréin",
  "country.BI": "Burundi",
  "country.BJ": "Benín",
  "country.BL": "San Bartolomé",
  "country.BM": "Bermudas",
  "country.BN": "Brunei Darussalam",
  "country.BO": "Bolivia",
  "country.BQ": "Bonaire, Saint Eustatius y Saba",
  "country.BR": "Brasil",
  "country.BS": "Bahamas",
  "country.BT": "Bután",
  "country.BV": "isla Bouvet",
  "country.BW": "Botsuana",
  "country.BY": "Belarús",
  "country.BZ": "Belice",
  "country.CA": "Canadá",
  "country.CC": "Islas Cocos (Keeling)",
  "country.CD": "República Democrática del Congo",
  "country.CF": "República Centroafricana",
  "country.CG": "Congo",
  "country.CH": "Suiza",
  "country.CI": "Costa de Marfil",
  "country.CK": "Islas Cook",
  "country.CL": "Chile",
  "country.CM": "Camerún",
  "country.CN": "China",
  "country.CO": "Colombia",
  "country.CR": "Costa Rica",
  "country.CU": "Cuba",
  "country.CV": "Cabo Verde",
  "country.CW": "Curasao",
  "country.CX": "Isla de Navidad",
  "country.CY": "Chipre",
  "country.CZ": "República Checa",
  "country.DE": "Alemania",
  "country.DJ": "Yibuti",
  "country.DK": "Dinamarca",
  "country.DM": "Dominica",
  "country.DO": "República Dominicana",
  "country.DZ": "Argelia",
  "country.EC": "Ecuador",
  "country.EE": "Estonia",
  "country.EG": "Egipto",
  "country.EH": "Sahara Occidental",
  "country.ER": "Eritrea",
  "country.ES": "España",
  "country.ET": "Etiopía",
  "country.EU": "Europa",
  "country.FI": "Finlandia",
  "country.FJ": "Fiyi",
  "country.FK": "Islas Malvinas (Falkland)",
  "country.FM": "Estados Federados de Micronesia",
  "country.FO": "Islas Faroe",
  "country.FR": "Francia",
  "country.GA": "Gabón",
  "country.GB": "Reino Unido",
  "country.GD": "Granada",
  "country.GE": "Georgia",
  "country.GF": "Guyana Francesa",
  "country.GG": "Guernesey",
  "country.GH": "Ghana",
  "country.GI": "Gibraltar",
  "country.GL": "Groenlandia",
  "country.GM": "Gambia",
  "country.GN": "Guinea",
  "country.GP": "Guadalupe",
  "country.GQ": "Guinea Ecuatorial",
  "country.GR": "Grecia",
  "country.GS": "Islas Georgias del Sur y Sándwich del Sur",
  "country.GT": "Guatemala",
  "country.GU": "Guam",
  "country.GW": "Guinea-Bissau",
  "country.GY": "Guyana",
  "country.HK": "Hong Kong",
  "country.HM": "Islas Heard y McDonald",
  "country.HN": "Honduras",
  "country.HR": "Croacia",
  "country.HT": "Haití",
  "country.HU": "Hungría",
  "country.ID": "Indonesia",
  "country.IE": "Irlanda",
  "country.IL": "Israel",
  "country.IM": "Isla de Man",
  "country.IN": "India",
  "country.IO": "Territorio Británico del Océano Índico",
  "country.IQ": "Iraq",
  "country.IR": "República Islámica de Irán",
  "country.IS": "Islandia",
  "country.IT": "Italia",
  "country.JE": "Jersey",
  "country.JM": "Jamaica",
  "country.JO": "Jordania",
  "country.JP": "Japón",
  "country.KE": "Kenia",
  "country.KG": "Kirguistán",
  "country.KH": "Camboya",
  "country.KI": "Kiribati",
  "country.KM": "Comoras",
  "country.KN": "San Cristóbal y Nieves",
  "country.KP": "República Popular Democrática de Corea",
  "country.KR": "República de Corea",
  "country.KW": "Kuwait",
  "country.KY": "Islas Caimán",
  "country.KZ": "Kazajstán",
  "country.LA": "República Democrática Popular Lao",
  "country.LB": "Líbano",
  "country.LC": "Santa Lucía",
  "country.LI": "Liechtenstein",
  "country.LK": "Sri Lanka",
  "country.LR": "Liberia",
  "country.LS": "Lesoto",
  "country.LT": "Lituania",
  "country.LU": "Luxemburgo",
  "country.LV": "Letonia",
  "country.LY": "Jamahiriya Arabe Libia",
  "country.MA": "Marruecos",
  "country.MC": "Mónaco",
  "country.MD": "República de Moldova",
  "country.ME": "Montenegro",
  "country.MF": "San Martín",
  "country.MG": "Madagascar",
  "country.MH": "Islas Marshall",
  "country.MK": "Macedonia",
  "country.ML": "Malí",
  "country.MM": "Myanmar",
  "country.MN": "Mongolia",
  "country.MO": "Macao",
  "country.MP": "Islas Marianas del Norte",
  "country.MQ": "Martinica",
  "country.MR": "Mauritania",
  "country.MS": "Montserrat",
  "country.MT": "Malta",
  "country.MU": "Mauricio",
  "country.MV": "Maldivas",
  "country.MW": "Malawi",
  "country.MX": "México",
  "country.MY": "Malasia",
  "country.MZ": "Mozambique",
  "country.NA": "Namibia",
  "country.NC": "Nueva Caledonia",
  "country.NE": "Níger",
  "country.NF": "Isla Norfolk",
  "country.NG": "Nigeria",
  "country.NI": "Nicaragua",
  "country.NL": "Holanda",
  "country.NO": "Noruega",
  "country.NP": "Nepal",
  "country.NR": "Nauru",
  "country.NU": "Niue",
  "country.NZ": "Nueva Zelanda",
  "country.OM": "Omán",
  "country.PA": "Panamá",
  "country.PE": "Perú",
  "country.PF": "Polinesia Francesa",
  "country.PG": "Papua Nueva Guinea",
  "country.PH": "Filipinas",
  "country.PK": "Pakistán",
  "country.PL": "Polonia",
  "country.PM": "San Pedro y Miquelón",
  "country.PN": "Pitcairn",
  "country.PR": "Puerto Rico",
  "country.PS": "Territorio Palestino",
  "country.PT": "Portugal",
  "country.PW": "Palau",
  "country.PY": "Paraguay",
  "country.QA": "Catar",
  "country.RE": "Reunión",
  "country.RO": "Rumania",
  "country.RS": "Serbia",
  "country.RU": "Federación Rusa",
  "country.RW": "Ruanda",
  "country.SA": "Arabia Saudita",
  "country.SB": "Islas Salomón",
  "country.SC": "Seychelles",
  "country.SD": "Sudán",
  "country.SE": "Suecia",
  "country.SG": "Singapur",
  "country.SH": "Santa Elena",
  "country.SI": "Eslovenia",
  "country.SJ": "Svalbard y Jan Mayen",
  "country.SK": "Eslovaquia",
  "country.SL": "Sierra Leona",
  "country.SM": "San Marino",
  "country.SN": "Senegal",
  "country.SO": "Somalia",
  "country.SR": "Surinam",
  "country.SS": "Sudán del Sur",
  "country.ST": "Santo Tomé y Príncipe",
  "country.SV": "El Salvador",
  "country.SX": "San Martín",
  "country.SY": "República Árabe Siria",
  "country.SZ": "Swazilandia",
  "country.TC": "Islas Turcas y Caicos",
  "country.TD": "Chad",
  "country.TF": "Territorios Australes Franceses",
  "country.TG": "Togo",
  "country.TH": "Tailandia",
  "country.TJ": "Tayikistán",
  "country.TK": "Tokelau",
  "country.TL": "Timor-Leste",
  "country.TM": "Turkmenistán",
  "country.TN": "Túnez",
  "country.TO": "Tonga",
  "country.TR": "Turquía",
  "country.TT": "Trinidad y Tobago",
  "country.TV": "Tuvalu",
  "country.TW": "Taiwán",
  "country.TZ": "República Unida de Tanzania",
  "country.UA": "Ucrania",
  "country.UG": "Uganda",
  "country.UM": "Islas Ultramarinas de Estados Unidos",
  "country.US": "Estados Unidos",
  "country.UY": "Uruguay",
  "country.UZ": "Uzbekistán",
  "country.VA": "Santa Sede (Ciudad del Vaticano)",
  "country.VC": "San Vicente y las Granadinas",
  "country.VE": "Venezuela",
  "country.VG": "Islas Vírgenes Británicas",
  "country.VI": "Islas Vírgenes de los Estados Unidos",
  "country.VN": "Vietnam",
  "country.VU": "Vanuatu",
  "country.WF": "Wallis y Futuna",
  "country.WS": "Samoa",
  "country.YE": "Yemen",
  "country.YT": "Mayotte",
  "country.ZA": "Sudáfrica",
  "country.ZM": "Zambia",
  "country.ZW": "Zimbabue",
  "certificate.country": "Abreviación de dos letras. Ej.: US",
  "certificate.state": "Ej. Completo: Nova York",
  "certificate.organization": "Nombre de la empresa",
  "certificate.unit": "Ej.: Departamento",
  "certificate.email": "admin@domínio",
  "certificate.keysize": "Tamaño de clave",

  "maintenance.remove.clear.directory": "¿Quieres borrar todo el directorio?",
  "maintenance.remove.clear.directory.restart.proxy": "¿Quieres borrar todo el directorio? Deberá reiniciar el servicio de proxy.",

  "network.settings.title": "Configuración de red",
  "network.general.form.gateway": "Gateway",
  "network.general.form.dns1": "Servidor DNS 1",
  "network.general.form.dns2": "Servidor DNS 2",
  "network.general.form.ntp1": "Servidor NTP 1",
  "network.general.form.ntp2": "Servidor NTP 2",
  "network.interface.datagrid.name": "Nombre",
  "network.interface.datagrid.address": "Dirección IP",
  "network.interface.datagrid.mask": "Máscara",
  "network.interface.datagrid.status": "Estado",
  "network.interface.datagrid.actions": "Acciones",
  "network.interface.form.title": "Editar la interfaz",
  "network.interface.form.status": "Habilitar",
  "network.interface.form.ip": "Dirección IP",
  "network.interface.form.ip.invalid": "Dirección IP no válida",
  "network.interface.form.mask.invalid": "Máscara de red no válido",
  "network.interface.form.mask": "Máscara de red",
  "network.interface.error.ip": "Campo Dirección IP es obligatorio",
  "network.interface.save.success": "¡Configuraciones cambiada correctamente!",
  "network.interface.save.error": "¡Configuraciones no guardada!",
  "network.interface.searchInterfaces": "Buscar Interfaces",
  "network.interface.error.mask": "Campo de máscara de red es obligatorio",
  "network.email.connectionTest": "Probar conexión SMTP",
  "network.email.connectionError": "Error en la conexión SMTP",
  "network.email.connectionAuthFailed": "Autentificación SNMP fallida",
  "network.email.connectionSuccess": "Exito en la conexión SMTP",
  "network.email.hostname.required": "Nombre de host es obligatorio",
  "network.email.port.required": "Puerto es obligatorio",
  "network.email.user.required": "Usuario es obligatorio",
  "network.email.pass.required": "Contraseña es obligatoria",
  "network.email.security.required": "Seguridad es obligatorio",

  "administration.title": "Gestión",
  "administration.titleComplete": "Perfil de Gestión",
  "administration.user.title": "Usuario administrativo",
  "administration.profiles.datagrid.profile": "Perfil",
  "administration.profiles.datagrid.actions": "Acciones",
  "administration.profiles.actions.create": "Crear Perfil",
  "administration.profiles.actions.delete": "Eliminar Perfil",
  "administration.profiles.actions.clone": "Clonar Perfil",
  "administration.profiles.modal.title": "Crear Perfil",
  "administration.profiles.modal.name": "Nombre",
  "administration.profiles.modal.devices": "Dispositivos",
  "administration.profiles.modal.devicesGroups": "Grupo de Dispositivos",
  "administration.profiles.modal.clone.text": "¿Seguro que desea clonar?",
  "administration.profiles.modal.delete.text": "¿Seguro que desea eliminar?",
  "administration.profiles.modal.clone.success": "¡Perfil clonados con éxito!",
  "administration.profiles.modal.clone.error": "¡Lo perfil no fue clonado!",
  "administration.profiles.modal.clone.error.already":
    "El perfil ya ha sido clonado",
  "administration.profile.save.deleted": "¡Perfil eliminado con éxito!",
  "administration.profiles.save.deleted": "¡Perfiles eliminados con éxito!",
  "administration.profiles.save.deleted.errorAlready":
    "Ya es administrador de usuarios en el perfil {name}",
  "administration.profiles.save.deleted.error":
    "No es posible eliminar el perfil {name}",

  //Controle de acesso -----
  "administration.control.actions.create": "Crear Control",
  "administration.control.actions.delete": "Eliminar Control",

  "administration.users.datagrid.name": "Nombre",
  "administration.users.datagrid.email": "Correo Electrónico",
  "administration.users.datagrid.type": "Tipo",
  "administration.users.datagrid.profile": "Perfil",
  "administration.users.datagrid.actions": "Acciones",
  "administration.users.datagrid.auditor": "Auditor",
  "administration.users.datagrid.api_access": "Acceso API",
  "administration.users.actions.create": "Crear Usuario",
  "administration.users.actions.delete": "Eliminar Usuario",
  "administration.users.actions.clone": "Clonar Usuario",
  "administration.users.modal.title": "Usuario Administrador",
  "administration.users.modal.auditor": "Auditor",
  "administration.users.modal.auditor.required": "¡Se requiere un auditor!",
  "administration.users.modal.api_access": "Acceso a la API",
  "administration.users.modal.api_access.required": "Se requiere acceso API!",
  "administration.users.modal.name": "Nombre",
  "administration.users.modal.name.required": "¡Nombre es obligatorio!",
  "administration.users.modal.email": "Correo Electrónico",
  "administration.users.modal.email.required":
    "¡Correo Electrónico es obligatorio!",
  "administration.users.modal.user": "Usuario",
  "administration.users.modal.user.required": "¡Usuario es obligatorio!",
  "administration.users.modal.type": "Tipo",
  "administration.users.modal.type.required": "¡Tipo es obligatorio!",
  "administration.users.modal.server": "Servidor",
  "administration.users.modal.server.required": "¡Servidor es obligatorio!",
  "administration.users.modal.password": "Contraseña",
  "administration.users.modal.password.required": "¡Contraseña es obligatoria!",
  "administration.users.modal.confirmPassword": "Confirmar Contraseña",
  "administration.users.modal.confirmPassword.required":
    "Es obligatorio confirmar la contraseña!",
  "administration.users.modal.profile": "Perfil",
  "administration.users.modal.profile.required": "¡Perfil es obligatorio!",
  "administration.users.save.success": "¡Usuario registrado con éxito!",
  "administration.users.save.error": "¡El Usuario no ha sido guardado!",
  "administration.users.delete.error": "¡Los Usuarios no fueron eliminados!",
  "administration.user.delete.error": "¡El Usuario no fue eliminado!",
  "administration.user.delete.pk":
    "¡No se pudo eliminar el usuario! Hay tareas vinculadas para este usuario.",

  "administration.users.save.error.differentPass":
    "Las contraseñas no concuerdan",
  "administration.users.save.error.wakePass": "Contraseña débil",

  "administration.users.save.deleted": "¡Usuarios eliminados con éxito!",
  "administration.user.save.deleted": "¡Usuario eliminado con éxito!",

  "administration.servers.datagrid.server.name": "Nombre",
  "administration.servers.datagrid.primary.server": "Primero",
  "administration.servers.datagrid.secondary.server": "Segundo",
  "administration.servers.datagrid.authentication.type":
    "Tipo de Autentificación",
  "administration.servers.datagrid.type.server": "Tipo",
  "administration.servers.form.nas.ip.addresses": "Dirección IP del NAS",
  "administration.servers.form.secondary.server": "Segundo Servidor",
  "administration.servers.form.primary.server": "Primero Servidor",
  "administration.servers.form.server.error": "Servidores deben ser diferentes",
  "administration.servers.form.already.exists":
    "Ya hay un campo con el mismo nombre",
  "administration.servers.form.duplicate.server": "Servidor duplicado",
  "administration.servers.form.settings": "Configuraciones",
  "administration.servers.form.filter.user": "Filtro de Usuario",
  "administration.servers.form.login": "Acceso",
  "administration.servers.form.password": "Contraseña",
  "administration.servers.form.ssl": "SSL",
  "administration.servers.form.radius": "Radius",
  "administration.servers.form.ldap": "Ldap",
  "administration.servers.form.base": "Base",
  "administration.servers.form.title.ldap": "servidor LDAP",
  "administration.servers.form.modalAddLdap.help.hostname": "Ingrese el nombre de host (FQDN) o la dirección IP",
  "administration.servers.form.servers.title": "Servidores de sincronización",
  "administration.servers.form.servers.error.inuse": "¡No se puede eliminar el perfil! Servidor en uso",
  "administration.servers.form.modalAddLdap.help.port": "Ingrese el puerto de comunicación",
  "administration.servers.form.modalAddLdap.type": "Opción de certificado o inicio de sesión y contraseña",
  "administration.servers.form.modalAddLdap.identity.name": "Atributo de nombre",
  "administration.servers.form.modalAddLdap.identity.member": "Atributo de miembro",
  "administration.servers.form.modalAddLdap.identity.description": "Descripción del atributo",
  "administration.servers.form.modalAddLdap.filter.group": "Filtro de grupo",
  "administration.servers.form.modalAddLdap.info.ssl": "Para el tipo de autenticación de certificado, se requiere la casilla de verificación SSL.",
  "administration.servers.form.login.attribute": "Atributo de Acceso",
  "administration.servers.datagrid.save.success":
    "Perfil creado exitosamente",
  "administration.servers.datagrid.edit.success":
    "Perfil editado exitosamente",
  "administration.servers.action.delete.success":
    "Perfil eliminado exitosamente",
  "administration.servers.action.delete.error": "Error al eliminar servidor",
  "administration.servers.action.create.radius": "Crear Radius",
  "administration.servers.action.create.ldap": "Crear LDAP",
  "administration.servers.action.delete": "Eliminar Servidor",
  "administration.servers.action.delete.text": "¿Seguro que desea eliminar?",
  "administration.servers.action.connection.test": "Probar conexión",
  "administration.servers.action.auth.test": "Probar Autentificación",
  "administration.servers.action.connection.success":
    "Conexión realizada con éxito",
  "administration.servers.action.connection.error": "Error de conexión",
  "administration.servers.action.auth.success":
    "Autentificación realizada con éxito",
  "administration.servers.action.auth.error": "Error de Autentificación",
  "administration.audit.modal.title": "Vista prepor de la auditoría",

  /* START - Adicionado por Fabio Dias 10/12/200 - PT */
  "administration.identity.user.interface": "Interfaz de inicio",
  "administration.identity.service.provider": "Provedor de Servicio",
  "administration.identity.service.provider.disabled":
    "Proveedor de Servicio está desactivado",
  "administration.identity.saml.enable": "Activar",
  "administration.identity.service.name": "Nombre del Servicio",
  "administration.identity.service.description": "Descripción del Servicio",
  "administration.identity.url.base": "Base URL",
  "administration.identity.url.base.login": "Base URL Acceso",
  "administration.identity.url.base.logout": "Base URL Cerrar Sesión",
  "administration.identity.url.base.metadata": "Base URL Metadatos",
  "administration.identity.x509.cert": "Certificado",
  "administration.identity.x509.cert.new": "Agregar certificados",
  "administration.identity.x509.cert.public":
    "Certificado - Clave Pública (.crt)",
  "administration.identity.x509.cert.private":
    "Certificado - Clave Privada (.key)",
  "administration.identity.x509.cert.pem": "Certificado (.pem)",
  "administration.identity.x509.cert.type": "Tipo del Certificado",
  "administration.identity.x509.cert.type.pem": "(.pem)",
  "administration.identity.x509.cert.type.other": "(.crt/key)",
  "administration.identity.nameid.format": "Identificador de Nombre",
  "administration.identity.url.test": "URL de Teste",
  "administration.identity.url.assertion": "URL de Confirmación",
  "administration.identity.url.logout": "URL de Cerrar Sesión",
  "administration.identity.url.metadata": "URL de Metadatos",
  "administration.identity.id": "ID da Entidade",
  "administration.identity.sson.url": "URL de servicio de acceso único",
  "administration.identity.ssoff.url": "URL de servicio de cerrar sesión único",
  "administration.identity.binding.sso": "SSO Binding",
  "administration.identity.binding.slo": "SLO Binding",
  "administration.identity.binding.post": "Publicar",
  "administration.identity.binding.redirect": "Desviar",
  "administration.identity.username": "Usuario",
  "administration.identity.email.address": "Correo Electrónico",
  "administration.identity.user.name": "Atributo del Usuario",
  "administration.identity.user.email": "Atributo del Correo Electrónico",
  "administration.identity.saml.profile": "Atributo del Perfil",
  "administration.identity.user.profile": "Perfiles de Usuarios del GSM",
  "administration.identity.user.persist": "Persistir Usuario",
  "administration.identity.user.audit": "Auditor",
  "administration.identity.export.metadata":
    "Exportar Metadatos del Proveedor de Identidade (XML)",
  "administration.identity.import.metadata":
    "Importar Metadatos del Proveedor de Identidade (XML)",
  "administration.identity.import.file": "Importar Certificado",
  "administration.identity.export.file": "Exportar Certificado",
  "administration.identity.add.file": "Adicionar Certificado",
  "administration.identity.add.certificate": "Certificado agregado con éxito",
  "administration.identity.add.certificate.fail":
    "Error al agregar certificado",
  "administration.identity.import.certificate":
    "Certificado importado con éxito",
  "administration.identity.import.certificate.fail":
    "Error al importar certificado",
  "administration.identity.import.certificate.invalid":
    "no se ha encontrado en el certificado",
  "administration.identity.save.certificate.error":
    "Añadir o importar un certificado antes de descargar",
  "administration.identity.save.success":
    "Proveedor de identidade guardado con éxito",
  "administration.identity.save.error":
    "Error al guardar el Proveedor de identidade",
  "administration.identity.login.error":
    "Error en el login con el Proveedor de Identidade. ¡Por favor, revisa sus Configuraciones.",
  /* END - Adicionado por Fabio Dias 10/12/200 - PT */

  "system.general.timezone.select": "Seleccione una zonas horarias",
  "system.general.language.select": "Seleccione una lengua",
  "system.general.save.success": "Configuraciones cambiadas con éxito!",
  "system.general.save.disclaimer": "Guardar Descargo de Responsabilidad",
  "system.general.save.sessions": "Guardar Sesiones",
  "system.general.save.services": "Guardar Servicios",
  "system.general.save.error": "Las Configuraciones no se guardaron!",

  "system.general.host.domain.error":
    "El nombre de host agregado al dominio debe contener no más que 64 caracteres",
  "system.backupModal.title": "Copia de seguridad de sistema",
  "system.backupModal.key": "Clave",
  "system.backupModal.confirm": "Confirme la Clave",
  "system.backupModal.error.key": "El campo clave es obligatorio",
  "system.backupModal.error.confirm":
    "El campo de confirmación de la clave es obligatorio",
  "system.backupModal.error.duplicate.key": "Las claves deben ser iguales",
  "system.general.message.disclaimer.pt": "Mensaje - Portugués Brasileiro",
  "system.general.message.disclaimer.en": "Mensaje - Inglés",
  "system.general.message": "Mensaje",
  "system.restoreModal.title": "Restaurar el Sistema",
  "system.restoreModal.success": "Sistema restaurado con éxito!",
  "system.restoreModal.error.invalid":
    "Clave o archivo de copia de seguridad inválido!",
  "system.restoreModal.key": "Clave",
  "system.restoreModal.file": "Archivo de backup",
  "system.restoreModal.error.key": "Campo clave es obligatorio",
  "system.restoreModal.error.file":
    "O campo Archivo de copia de seguridad es obligatorio",
  "system.restoreModal.upload.success": "Archivo Cargado con éxito",
  "system.restoreModal.upload.failed": "Subida de archivo sin éxito",
  "system.restoreModal.upload.error.name":
    "¡Nombre del archivo no puede contener espacios en blanco!",

  "system.updates.connection.success": "Conexión efectuada con éxito",
  "system.updates.connection.error": "Conexión sin éxito",
  "system.updates.test.connection": "Probar Conexión",
  "system.updates.save.proxy": "Guardar Proxy",
  "system.updates.reload.server": "Recargar Servidor",
  "system.updates.save.server": "Guardar Servidor",
  "system.updates.confirm.reload.server":
    "¿Desean actualizar el sistema y las bases?",
  "system.updates.scheduled.update": "Programación de Actualización",
  "system.updates.automatically": "Actualizar el sistema automáticamente",
  "system.updates.bases.automatically": "Actualizar las bases automáticamente",
  "system.updates.server.proxy": "Servidor Proxy",
  "system.updates.proxy": "Actualización",
  "sandbox.form.advanced.note": "Probabilidad máxima aceptable (%)",
  "sandbox.form.advanced.note.error": "Informar valor entre 0 y 100",
  "sandbox.form.advanced.token": "Token",

  "system.storages.delete.confirm":
    "¿Seguro que desea eliminar el almacenamiento?",
  "system.storages.delete.confirmMult":
    "¿Seguro que desea eliminar los siguientes almacenamientos?",
  "system.storage.delete.title": "Confirme la eliminación",

  "system.storages.actions.create.success": "Almacenamiento creado con éxito",
  "system.storages.actions.create.error":
    "La copia de seguridad de almacenamiento no ha sido guardado",
  "system.storages.actions.delete.success":
    "Almacenamiento eliminado con éxito",
  "system.storages.actions.delete.error": "Error al eliminar almacenamiento",
  "system.storages.actions.delete.error.total":
    "{number} objeto(s) no se eliminaron. Almacenamiento en funcionamiento.",

  "system.storages.smb": "Almacenamiento SMB",
  "system.storages.nfs": "Almacenamiento NFS",
  "system.storages.ssh": "Almacenamiento SSH",
  "system.storages.usb": "Almacenamiento USB",
  "system.storages.ssh.public.key": "Clave Pública",
  "system.storages.usb.public.key": "Clave Pública",
  "system.storages.sftp.public.key": "Clave Pública",
  "system.storages.ssh.compression": "Compresión",
  "system.storages.sftp.compression": "Compresión",
  "system.storages.usb.compression": "Compresión",
  "system.storages.ssh.copy": "Copiar Clave pública",
  "system.storages.sftp.copy": "Copiar Clave pública",
  "system.storages.usb.copy": "Copiar Clave pública",
  "system.storages.nfs.bytes.reading": "Bytes Lectura",
  "system.storages.nfs.bytes.writing": "Bytes Escritura",
  "system.storages.nfs.bytes.block.size": "Bytes tamaño block",
  "system.storages.nfs.disable.locking": "Desactivar bloqueos",
  "system.storages.nfs.operation.mode": "Modo de Operación",
  "system.storages.nfs.soft": "Suave",
  "system.storages.nfs.hard": "Fuerte",
  "system.storages.nfs.enable.posix": "Habilitar posix",
  "system.storages.nfs.extra.options": "Opciones Adicionales",
  "system.storages.add.actions.success": "¡Almacenamiento guardado con éxito!",
  "system.storages.del.actions.success": "¡Almacenamiento eliminado con éxito!",
  "system.virtualDomain.del.actions.success":
    "¡Dominio Virtual eliminado con éxito!",
  "system.virtualDomain.add.actions.success":
    "¡Dominio Virtual guardado con éxito!",
  "system.storages.upd.actions.success":
    "¡Almacenamiento actualizado con éxito!",
  "system.storages.del.actions.error.use":
    "Error al eliminar. Almacenamiento en funcionamiento.",
  "system.storages.usb.device_usb": "Dispositivo USB",
  "system.storages.storage.only.logger":
    "O Almacenamiento está instalado en la Logger",
  "system.storages.storage.unavailable": "Almacenamiento inaccesible",
  "system.storages.only.logger": "Sólo Logger",

  "system.certificate.save.success": "Certificado guardado con éxito",
  "system.certificate.save.error": "El certificado no ha sido guardado",
  "system.certificate.save.settings": "Guardar certificado",
  "settings.notifications.vpn.monitor": "VPN Monitor",

  "license.serial": "Número de serie",
  "license.key": "Clave de licencia",
  "license.key.required": "Se necesita de la clave de licencia",
  "license.status": "Estado de licencia",
  "license.expire": "Fecha de expiración",
  "license.registry": "Fecha de registro",
  "license.devices": "Número de dispositivos",
  "license.terms.accept": "Aceptar",
  "license.terms.accept.terms.of.use": "Términos de uso",
  "license.terms.required": "¡Por favor, acepte los términos y condiciones!",
  "license.terms.EULA":
    "BLOCKBIT\n" +
    "\n" +
    "CONTRATO DE LICENCIA DE USUARIO FINAL\n" +
    "\n" +
    'AL HACER CLIC EN "CONTINUAR", USTED O LA ENTIDAD QUE REPRESENTA ("LICENCIADO") CONSIDERA PLENAMENTE QUE SEA LIMITADO Y SE CONVIERTE EN PARTE DE ESTE CONTRATO DE LICENCIA DE USUARIO FINAL ("CONTRATO") CON LA BLOCKBIT TECNOLOGIA LTDA. ("BLOCKBIT"). SI TALES CONDICIONES SON CONSIDERADAS UNA OFERTA, LA ACEPTACIÓN ES EXPRESAMENTE LIMITADA A TALES CONDICIONES. SI EL LICENCIADO NO CONCORDAR PLENAMENTE CON LO QUE ANTECEDE, HAGA CLIC EN EL BOTÓN “CANCELAR” Y EL PROCESO DE INSTALACIÓN NO SEGUIRÁ. SÍ HAGA CLIC EN EL BOTÓN “ACEPTAR” PARA PROSEGUIR CON LA INSTALACIÓN, USTED ESTÁ REPRESENTANDO Y GARANTIZANDO QUE ESTÁ PERMITIDO PARA ACTIVAR LA LICENCIA.\n' +
    "\n" +
    "\n" +
    "1. Concesión de licencias y Restricciones. Sujeto a las conficiones de este contrato, pago de todas las tasas y cualesquiera limitaciones aplicables de usuario/utilización, la BLOCKBIT otorga al licenciado un derecho personal, no sublicenciable y no exclusivo, de utilizar el software que es directamente accesible por este proceso de instalación, pero solo: (I) solo en formato de código del objecto (“Software”); (II) en un equipo autorizado específicamente, ubicada en un lugar con licencia autorizado por la BLOCKBIT; y (III) según la lista de precios de la BLOCKBIT. La BLOCKBIT mantiene la propiedad del Software y el Licenciado mantendrá el aviso de derecho de autor y cualquier otro aviso que aparezcan en el Software o en cualquier medio que contengan el Software.\n" +
    "2. Actualizaciones, contenido y servicio de soporte. Actualizaciones, contenido y/o servicios de soporte no es necesariamente suministrada con el Software y pueden requerir costo adicional o incluir términos y condiciones complementarias. Sin embargos, a medida que se proporciona una actualización para el Software y/o contenido, esta actualización/contenido se considerará “Software” proporcionado sujeto a este Acuerdo y deberás ser licenciado para utilización solo en equipos específicos para la cual fue licenciada. Si el servicio de contenido/soporte se proporcionan, la BLOCKBIT se reserva el derecho de cambiar el ámbito o el tiempo de tales servicios a cualquier momento y de tener acceso, utilizar y repartir libremente los datos recogidos del Licenciado a través de estos servicios. Si tales servicios se dispusieran, el Licenciado puede ser obligado a pagar tasas o otros gastos por lo uso o acceso a algúnos o todos estos servicios, tasas y términos especificados en la factura o en el formulario de solicitud para este tipo de servicio.\n" +
    "3. Restricciones. El Licenciado no (y no permitirá que terceras partes): (I) hacer ingeniería inversa, tratar de averiguar cualquier código fuente, ideas o algoritmo subyacente del Software; (II) ofrecer, rentar, prestar, difundir, usarlo con fines de compartir tiempo, agencia de servicio o de otra manera usarlo o dejar que otros usen para el beneficio de terceras partes, el Software (excepto en función expresamente y específicamente aprobado por el BLOCKBIT); (III) sin el previo consentimiento y expreso por escrito de la BLOCKBIT, realizar cualquier estudio, avaluación comparativa o análisis que implican el Software (“Benchmarking”) por cualquier razón o fin, excepto en la extensión limitada absolutamente necesaria, para determinar la conveniencia del software para interoperar con los sistemas informáticos internos del Licenciado; (IV) difundir a terceras partes cualquier Benchmarking o cualquier otra información relacionadas con estos; (V) utilizar el Software o cualquier Benchmarking en relación con el desarrollo de productos que complemento con el Software, o; (VI) reproducir, cambiar o modificar el Software. Antes de eliminar cualquier medios o dispositivos que contienen cualquier parte del Software, el Licenciado debe destruir completamente el Software contenidos en el mismo. Todas las limitaciones y restricciones del Software licenciado sin cargos o por un cargo nominal se considerará una licencia de evaluación gratis y solo podrá ser utilizado para fines de evaluación de la obtención de una licencia pagada y no para cualquier utilización productiva. EL LICENCIADO RECONOCE QUE EL SOFTWARE PUEDE INCLUIR RECURSOS PARA EVITAR LA UTILIZACION DESPUES DE UN PERIODO DE LICENCIA APLICABLE Y/O USO INCONSISTENTE DE ESTE.	El Licenciado reconoces que el Software se puede distribuir junto, contener o utilizar cierto Software de código abierto u otro software de tercera parte (“Third Part Software”). EL SOFTWARE DE TERCERA PARTE ESTA (ADEMAS DE LOS TERMINOS Y REQUISITOS DE ESTE CONTRACTO), SUJETOS Y REGIDOS (Y EL LICENCIADO ESTA DE ACUEDO Y DEBERÁ INDEMNIZAR LA BLOCKBIT POR INCUMPLIMIENTO) SUS LICENCIAS PARA EL SOFTWARE DE TERCERA PARTE. No son concedida derechos o licencias que no sean expresamente y sin ambigüedad establecidos aquí.\n" +
    "4. Confidencialidad. El Software en la forma de código fuente permanece en secreto comercial confidencial de la BLOCKBIT y/o de sus proveedores. El Software está protegido por las leyes de derecho de autor y otras leyes de propiedad intelectual de los Estados Unidos y tratados internacionales. El Licenciado reconoces que, durante la utilización del Software, el Licenciado puede obtener o aprender informaciones relacionadas con el Software, las cuales puede contener, sin limitación, informaciones relacionadas con el rendimiento, confiabilidad o estabilidad del Software, operación, conocimiento, técnicas, procesos, ideas, algoritmos, diseño y arquitectura del software (“Informaciones Propietarias”). Por las partes, estas informaciones propietarias pertenecerán exclusivamente de la BLOCKBIT. Durante y después de la efectividad de este Contracto, el Licenciado debe mantener la confianza y proteger, y no debe utilizar (excepción expresamente de la autorización por este Contacto) o revelar informaciones de Propiedad a terceras partes.\n" +
    "5. Rescisión. Este Contracto estará en vigor hasta su rescisión. El Licenciado puede terminar este Contracto en cualquier momento, eliminando todas las copias del Software y documentación relacionada. Este Contracto se rescindirá de forma automática si el Licenciado no pagar el valor total facturado por el Software cuando debido o no cumplido con cualquier termino o condición de este Contracto, incluso cualquier intensión de descargar una copia del Software para otra parte, excepto con arreglo a lo dispuesto en este documento. El Licenciado acepta que, con este término, el Licenciado eliminará todas las copias del Software y documentación relacionada. Excepto cuando expresamente dispuesto aquí, los términos de este instrumento si mantendrán independiente de cualquier rescisión. La rescisión no es un recurso exclusivo y todas las otras soluciones quedarán disponibles, independientemente de la rescisión ocurrir o no.\n" +
    "6. GARANTÍA LIMITADA Y EXENCIÓN DE RESPONSABILIDAD. EL LICENCIADO RECONOCES Y COMPRENDE QUE EL SOFTWARE LICENCIADO DE ACUERDO CON ESTE CONTRACTO ES PROPORCIONADO ‘TAL Y COMO ESTÁ’ SIN CUALQUIER GARANTÍA RELACIONADA CON LA INSTALACIÓN, UTILIZACIÓN O RENDIMIENTO DEL SOFTWARE. LA BLOCKBIT EXPRESAMENTE EXENTA Y EL LICENCIADO OTORGA EXPRESAMENTE TODAS LAS OTRAS GARANTÍAS, EXPRESAS O IMPLÍCITAS, INCLUSO GARANTÍAS DE COMERCIALIZACIÓN, ADECUACIÓN A UN FIN ESPECÍFICO, INCUMPLIMIENTO, INTEGRACIÓN DEL SISTEMA, NO INTERFERENCIA, PRECISIÓN, CONFIABILIDAD Y CUALIDAD DEL SOFTWARE, INCLUYENDO Y SIN DEROGAR DEL ARRIBA, CUALQUIER GARANTÍAS Y DERECHOS IMPLÍCITOS CON ARREGLO AL CÓDIGO COMERCIAL UNIFORME DE LOS EUA, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) Y LEY COMÚN. LA BLOCKBIT Y SUS PROVEEDORES NO GARANTIZAN QUE EL SOFTWARE CUMPLE CON LOS REQUISITOS DE LO LICENCIADO O QUE LO FUNCIONAMIENTO DEL SOFTWARE SE INTERRUMPIDA O SIN ERROR. LA BLOCKBIT SE EXIME AUN DE RESPONSABILIDADES Y EL LICENCIADO RECONOCE EXPRESAMENTE TODAS LAS GARANTÍAS RELACIONADAS A LOS RESULTADOS, INFORMACIONES, DATOS Y CUALQUIER CONSEJO PROVISTO POR EL SOFTWARE. ALGUNAS JURISDICCIONES NO PERMelemento LA ELIMINACIÓN DE GARANTÍAS IMPLÍCITAS, POR ESO LA ELIMINACIÓN ARRIBA PUEDE NO SE APLICAR A ESTAS. LA BLOCKBIT NO TENDRÁ NINGUNA RESPONSABILIDAD EN CAMBIAR EL MEDIO SI LA FALLA DEL MEDIO DERIVARSE DE ACCIDENTE, MALTRATO O USO INCORRECTO DEL MEDIO. EL SOFTWARE ES PROPORCIONADO AL LICENCIADO SIN GARANTÍA DE CUALQUIER TIPO, EXPRESA O IMPLÍCITA, INCLUSO SIN LIMITACIÓN, CUALQUIER GARANTÍA IMPLÍCITA DE COMERCIALIZACIÓN, ADECUACIÓN A UN FIN ESPECIFICO Y NO INFRACCIÓN.\n" +
    "7. Restricción de Responsabilidad. EN NINGÚN, LA BLOCKBIT O CUALQUIER OTRA PARTE INTERESADA EN LA CREACIÓN, PRODUCCIÓN O ENTREGA, INCIDENTAL O CONSECUENTE, INCLUYENDO SIN LIMITACIONES, BENEFICIOS O DATOS PERDIDOS, MISMO QUE HAYAN SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES DAÑOS. \n" +
    "8. Ley Anticorrupción. Lo Licenciado reconoce que está familiarizado y comprende lo dispuesto en la Ley Anticorrupción del Brasil n 12.846/2013, Ley contra Prácticas de Corrupción en el Exterior de los EUA (“FCPA”) y la Ley contra Soborno del Reino Unido de 2010 (“UKBA”) y está de acuerdo en cumplir con sus términos, así como cualquier disposición de la Ley local o de las policitas y procedimientos corporativos de la Blockbit en relación con estos. El Licenciado comprende también las disposiciones relacionadas las prohibiciones de la Ley Anticorrupción del Brasil, FCPA y UKBA en relación con el pago o donación de cualquier cosa de valor, incluyendo, entre otros, pago, regalos, viajes, entretenimiento y comidas, directa o indirectamente, a un oficinista de un gobierno extranjero o partido político esfuerzo por influir en un acto o decisión en su capacidad oficial o inducir el oficinista utilizar la influencia de su partido con este gobierno, para obtener o mantener negocios involucionando el Software. El Licenciado está de acuerdo en no violar o deliberadamente permitir que alguien viole la Ley Anticorrupción del Brasil, FCPA o UKBA, e el Licenciado está de acuerdo que ningún pago efectuado constituye soborno, inducir el pago, reembolso u otro pago que viole la Ley Anticorrupción del Brasil, FCPA, UKBA, o cualquier otra ley aplicable anticorrupción o antisoborno.\n" +
    "9. Avaluación. No obstante cualquier cosa es contraria a este documento, si el Licenciado esta usando el Software con fines evaluativos, este uso estará sujeto a los términos y condiciones de avaluación actuales de la BLOCKBIT o a otros términos mutuamente acordados para gobernar está avaluación.\n" +
    "10. Diversos. Ni este acuerdo ni las licencias concedidas en este documento son atribuibles o transferibles por el Licenciado (y cualquier intento de hacerlo se anulará). La BLOCKBIT puede ceder, delegar, licenciar y/o transferir libremente este Contracto, en lo todo o en parte, sin consentimiento. Este Contracto se considerará como hubiera sido hecho y debe interpretarse de acuerdo con las leyes brasileñas, sin considerar conflictos de disposiciones legales y sin considerar la Convención de las Naciones Unidas sobre la Compraventa Internacional de Mercaderías o la Ley de Operaciones Uniformes de Información de Ordenador. Sujeto a lo anterior expuesto, las disposiciones de este instrumento son únicamente para beneficio de las partes y no para cualquier otra persona o entidad. Cualquier notificación, informe, aprobación, autorización, acuerdo o consentimiento requerido o permitido en los términos de este documento debe hacerse por escrito; las notificaciones deben ser enviadas para la dirección que la parte aplicable tenga o pueda ofrecer mediante notificación por escrito o, si no hay, la dirección más reciente que la parte que enviar la notificación puede buscar usando esfuerzos razonables. Ninguna falla o tardanza en lo ejercicio parcial de cualquier derecho o poder de este instrumento se considerará como una renuncia, ni cualquier ejercicio parcial de cualquier derecho o poder de este instrumento evitará o ejercicio adicional. Si cualquier disposición sea juzgada por cualquier tribunal de jurisdicción competente con impracticable o invalida, está disposición vaya a ser limitada o eliminada extensión mínima necesaria para que este acuerdo permanezca en pleno vigor, efecto y fuerza ejecutiva. Está es la declaración completa y exclusiva de la comprensión mutua de las partes con relación a esta licencia aquí concedido y lo substituye y cancela todos los acuerdos y comúnicaciones escritos y orales anteriormente relacionados a esa licencia y cualquier renuncias o cambio será efectiva solo si ejecutada por escrito por la BLOCKBIT; Sin embargo, cualquier términos preimpresos estándar de cualquier solicitud de compra, confirmación o formulario similar a menos que sean firmados por la BLOCKBIT después de la vigencia de este instrumento, no va tener fuerza o efecto. La parte sustancialmente predominante en cualquier acción para aplicar este contracto tendrá derecho de recuperar los honorarios y costo de sus abogados relacionados con este juicio.\n",

  "update.runUpdateNow": "Actualizar ahora",
  "update.version": "Versión",
  "update.scheduled": "Programado",
  "update.running": "Progreso de la Actualización",

  "sessions.administration.modal.title": "Sesiones de Administrador",
  "sessions.administration.modal.label.start": "Inicio de Sesión",
  "sessions.administration.modal.label.session": "Sesión",

  "sessions.idle": "Tiempo limite en reposo (minutos)",
  "sessions.login": "Intentos de Login",
  "sessions.timeout": "Timeout del bloqueo (minutos)",
  "sessions.active": "Sesiones Activas",
  "sessions.block_concurrent_changes": "Bloquear cambios simultáneos",
  "system.sessions.activeModal.title": "Sesiones Activas",
  "system.sessions.datagrid.start": "Iniciar",
  "system.sessions.datagrid.name": "Nombre",
  "system.sessions.datagrid.address": "Dirección",
  "system.sessions.datagrid.status": "Estatus",
  "system.sessions.datagrid.action": "Acción",
  "system.sessions.datagrid.deleteTitle": "Eliminar Sesión",
  "system.sessions.datagrid.delete": "Eliminar",
  "system.sessions.datagrid.success": "Sesiones eliminadas con éxito",
  "system.sessions.datagrid.error": "Error al eliminar la sesión",

  "system.highAvailability.listNos": "Listado de Interfaz",
  "system.highAvailability.nodeList": "Listado de Nosotros",
  "system.highAvailability.interfaceFisica": "Interfaz de red física",
  "system.highAvailability.interfaceVirtual": "Interfaz de red virtual ",

  "sidebar.settings.system.mainNo": "Nodo principal",
  "settings.system.highAvailability.networkHeartbeat": "Interfaz Heartbeat",
  "settings.system.highAvailability.networkInterfaceRemoto": "Interfaz de red virtual",
  "settings.system.highAvailability.networkInterfaceLocal": "Interfaz de red local",
  "sidebar.settings.system.groupInterface": "Grupo de interfaz",
  "sidebar.settings.system.protocolUDP": "Usar el protocolo UDP",
  "sidebar.settings.system.monitor": "Supervisión",
  "sidebar.settings.system.on": "ON",
  "sidebar.settings.system.perfomance": "Alto rendimiento",
  "system.highAvailability.create": "Crear Interfaz",
  "system.highAvailability.remove": "Quitar Interfaz",


  "system.highAvailability.operation_mode": "Modo de Operación",
  "system.highAvailability.secret_key": "Clave Secreta",
  "system.highAvailability.local_key": "Clave Local",
  "system.highAvailability.peer_ip1": "Dirección IP Remoto #1",
  "system.highAvailability.peer_ip2": "Dirección IP Remoto #2",
  "system.highAvailability.peer_ip3": "Dirección IP Remoto #3",
  "system.highAvailability.peer_interface_1": "Heartbeat Interface #1",
  "system.highAvailability.peer_interface_2": "Heartbeat Interface #2",
  "system.highAvailability.peer_interface_3": "Heartbeat Interface #3",
  "system.highAvailability.peer_key": "Clave Remota",
  "system.highAvailability.heartbeat_interval":
    "Intervalo de Heartbeat (segundos)",
  "system.highAvailability.sync_interval":
    "Intervalo de Sincronización (minutos)",
  "system.highAvailability.failover_threshold": "Límite del Failover",
  "system.highAvailability.email_notifications":
    "Notificaciones de Correo Electrónico",
  "system.highAvailability.auto_activation": "Activación automática",
  "system.highAvailability.virtual_ip1": "Dirección IP Virtual",
  "system.highAvailability.netmask1": "Máscara de Red",
  "system.highAvailability.virtual_mac1": "Mac Virtual",
  "system.highAvailability.add.actions.success": "Cluster creado con éxito",
  "system.highAvailability.verify":
    "No debe utilizar esta interfaz virtual mientras sea una interfaz Heartbeat",
  "system.highAvailability.sync": "Cluster Sincronizado con éxito",
  "system.highAvailability.change.key": "Generar Clave",
  "system.highAvailability.change.copy": "Copiar Clave",
  "system.highAvailability.settings": "Configuraciones del Cluster",
  "system.highAvailability.interfaces": "Interfaz del Cluster",
  "system.highAvailability.status": "Estado del Cluster",

  "system.highAvailability.local.state": "Estado Local",
  "system.highAvailability.active.uptime": "Tiempo en Actividad",
  "system.highAvailability.peer.connection": "Conexión Remota",
  "system.highAvailability.peer.state": "Estado del Ponto Remoto",
  "system.highAvailability.syncronization.date": "Fecha de Sincronización",
  "system.highAvailability.syncronization.status": "Estatus de Sincronización",
  "system.highAvailability.primary.active": "Primario Activo",
  "system.highAvailability.secondary.active": "Secundario Activo",
  "system.highAvailability.standalone.active": "Standalone",
  "system.highAvailability.secondary.standby": "Secundario em Standby",
  "system.highAvailability.primary.standby": "Primario en Standby",
  "system.highAvailability.secondary.done": "Concluido",
  "system.highAvailability.sincronism": "Sincronizar ahora",
  "system.highAvailability.sincronismCluster": "Actualizar la información",
  "system.highAvailability.active": "Activar ahora",

  "clone.policy.packages": "Clonar Paquete de Políticas",
  "clone.policy.templates": "Clonar Plantillas de Políticas",
  "clone.device.templates": "Clonar Plantillas de Dispositivos",
  "clone.confirm.message.policy.packages":
    "Seleccione la versión deseada para clonar los Paquete de Política:",
  "clone.confirm.message.policy.templates":
    "Seleccione la versión deseada para clonar las Plantillas de Política:",
  "clone.confirm.message.device.templates":
    "Seleccione la versión deseada para clonar las Plantillas de Dispositivos:",

  "profile.application-control.title": "Perfil de Application Control",

  "clone.profile.webfilter.title": "Perfil(es) Web Filter",
  "clone.profile.application-control.title": "Perfil(es) Application Control",
  "clone.profile.threat-protection.title": "Perfil(es) Threat Protection",
  "clone.profile.intrusion-prevention.title": "Perfil(es) Intrusion Prevention",
  "clone.profile.ssl.title": "Perfil(es) Inspección SSL",
  "clone.profile.sd-wan.title": "Perfil(es) SD-WAN",

  "clone.profile.webfilter": "Clonar Perfil de Web Filter",
  "clone.profile.application-control": "Clonar Perfil de Application Control",
  "clone.profile.threat-protection": "Clonar Perfil de Threat Protection",
  "clone.profile.intrusion-prevention": "Clonar Perfil de Intrusion Prevention",
  "clone.profile.ssl-inspection": "Clonar Perfil de Inspección SSL",
  "clone.profile.sd-wan": "Clonar Perfil de SD-WAN",

  "clone.confirm.message.profile.webfilter":
    "Seleccione la versión deseada para clonar el Perfil de Web Filter:",
  "clone.confirm.message.profile.application-control":
    "Seleccione la versión deseada para clonar el Perfil de Application Control:",
  "clone.confirm.message.profile.threat-protection":
    "Seleccione la versión deseada para clonar el Perfil de Threat Protection:",
  "clone.confirm.message.profile.intrusion-prevention":
    "Seleccione la versión deseada para clonar el Perfil de Intrusion Prevention:",
  "clone.confirm.message.profile.ssl-inspection":
    "Seleccione la versión deseada para clonar el Perfil de Inspección SSL:",
  "clone.confirm.message.profile.sd-wan":
    "Seleccione la versión deseada para clonar el Perfil de SD-WAN:",

  "navbar.profile": "Perfil",
  "navbar.logout": "Cerrar Sesión",
  "navbar.deploy": "Deploy(s)",
  "navbar.deploy.accept": "Aceptar",
  "navbar.deploy.running": "En ejecución",
  "navbar.deploy.pending": "Pendiente",
  "navbar.deploy.withError": "Con errores",
  "navbar.deploy.deploysPanel": "Panel de Deploys",
  "packages.title": "Instalar Paquetes",
  "packages.what": "Lo que",
  "packages.who": "Quién",
  "packages.where": "Donde",
  "packages.when": "Cuando",
  "packages.packageType": "Tipo de paquete",
  "packages.installType": "Tipo de instalación",
  "packages.package": "Paquete",
  "packages.device": "Dispositivos y Grupo de Dispositivos",
  "packages.dateTime": "Fecha y hora",
  "packages.assign": "Asignar a",
  "packages.assign.tome": "Asignar para mi",
  "packages.comments": "Comentarios",
  "users.title": "Usuarios",
  "users.tabs.users": "Usuarios",
  "users.tabs.groups": "Grupos",
  "users.groups.datagrid.name": "Nombre",
  "users.groups.datagrid.type": "Tipo",
  "users.groups.datagrid.deviceName": "Nombre del Dispositivo",
  "users.groups.datagrid.used": "Usado",
  "users.groups.datagrid.actions": "Acciones",
  "users.groups.actions.create": "Crear Grupo",
  "users.groups.actions.delete": "Eliminar Grupo",
  "users.groups.modal.title": "Crear Grupo",
  "users.groups.modal.form.name": "Nombre",
  "users.groups.modal.form.description": "Descripción",
  "users.groups.modal.form.users": "Usuarios",
  "users.groups.modal.form.error.name": "El campo Nombre es obligatorio",
  "users.groups.modal.form.error.name.exists": "Este Nombre de grupo ya existe",
  "users.groups.modal.form.error.description":
    "Campo descripción es obligatorio",
  "users.groups.delete.title": "confirmar eliminación",
  "users.groups.delete.confirm": "¿Seguro que desea eliminar o grupo?",
  "users.groups.delete.confirmMult":
    "¿Seguro que desea eliminar os siguientes grupos?",
  "users.groups.messages.saved": "Grupo guardado con éxito",
  "users.groups.messages.deleted": "Grupos eliminados con éxito",
  "users.groups.messages.deleted.single": "Grupo eliminados con éxito",
  "users.users.datagrid.login": "Login",
  "users.users.datagrid.name": "Nombre",
  "users.users.datagrid.email": "Correo Electrónico",
  "users.users.datagrid.device": "Dispositivo",
  "users.users.datagrid.used": "Usado",
  "users.users.datagrid.actions": "Acciones",
  "users.users.actions.addToGroup": "Añadir al Grupo",
  "users.users.messages.success": "Usuarios adicionados con éxito al grupo",
  "users.addUserGroup.title": "Añadir Usuarios al grupo",
  "users.addUserGroup.placeholder": "Seleccione un grupo",
  "devices.title": "Dispositivos",
  "devices.tabs.inventory": "Inventario",
  "devices.tabs.communities": "Comunidades",
  "devices.tabs.templates": "Plantillas",
  "devices.tabs.provisioning": "Aprovisionamiento",
  "devices.tabs.backups": "Copia de seguridad",
  "devices.manager.action.automatic.sync.users": "Sincronización automática de usuario",
  "devices.manager.action.automatic.tymeSync": "Tiempo de sincronización (horas)",
  "devices.manager.group.delete.success": "Grupo eliminado con éxito",
  "devices.manager.device.delete.success": "Dispositivo eliminado con éxito",
  "devices.manager.device.delete.error":
    "Ocurrió un error al intentar eliminar el dispositivo",
  "devices.manager.device.resetStatus.error":
    "Ocurrió un error al intentar actualizar el estatus de los dispositivos",
  "devices.manager.device.sync.success": "Dispositivos sincronizados con éxito",
  "devices.manager.device.sync.error":
    "Ocurrió un error al intentar sincronizar el estatus de los dispositivos",
  "devices.manager.device.update.error":
    "Ocurrió un error al intentar actualizar los dispositivos",
  "devices.manager.device.grid.connError": "ERROR DE CONEXIÓN",
  "devices.manager.device.grid.connOk": "CONEXIÓN ESTABLECIDA",
  "devices.manager.device.grid.name": "Nombre",
  "devices.manager.device.grid.model": "Modelo",
  "devices.manager.device.grid.license_status": "Estatus de la licencia",
  "devices.manager.device.grid.version": "Versión",
  "devices.manager.device.grid.template": "Plantilla",
  "devices.manager.device.grid.policy_ipv4": "Política IPv4",
  "devices.manager.device.grid.policy_ipv6": "Política IPv6",
  "devices.manager.device.grid.actions": "Acciones",
  "devices.manager.device.grid.actions.export.json": "Exportar a JSON",
  "devices.manager.device.grid.actions.export.csv": "Exportar a CSV",
  "devices.manager.device.grid.actions.createGroup": "Crear Grupo",
  "devices.manager.device.grid.actions.deleteGroups": "Eliminar Grupos",
  "devices.manager.device.grid.actions.managerGroups": "Gestionar Grupos",
  "devices.manager.managerGroupsModal.title": "Gestionar Grupos",
  "devices.manager.device.grid.actions.createDevice": "Crear Dispositivo",
  "devices.manager.device.grid.actions.deleteDevices": "Eliminar Disposiivos",
  "devices.manager.device.grid.actions.reloadStatus": "Recargar Estatus",
  "devices.manager.device.grid.actions.synchronizeDevices":
    "Sincronizar Dispositivos",
  "devices.manager.device.grid.actions.updateDevices":
    "Actualizar Dispositivos",
  "devices.manager.updateModal.title": "Actualizar/Sincronizar Dispositivos",
  "devices.manager.updateModal.update": "Actualizar Dispositivos",
  "devices.manager.updateModal.sync": "Sincronizar Dispositivos",
  "devices.manager.groupModal.title.create": "Añadir Grupo",
  "devices.manager.groupModal.title.edit": "Editar Grupo",
  "devices.manager.groupModal.name": "Nombre",
  "devices.manager.groupModal.description": "Descripción",
  "devices.manager.groupModal.devices": "Dispositivos",
  "devices.manager.groupModal.logger": "Logger",
  "devices.manager.groupModal.successCreate": "Grupo grabado con éxito!",
  "devices.manager.groupModal.successUpdate": "Grupo actualizado con éxito!",
  "devices.manager.deviceModal.title.create": "Dispositivos",
  "devices.manager.deviceModal.sshkey": "Clave de Deploy",
  "devices.manager.deviceModal.apikey": "Clave de API",
  "devices.manager.deviceModal.useradmin": "Usuario Administrador",
  "devices.manager.deviceModal.adminpasswd": "Contraseña",
  "devices.manager.deviceModal.group": "Grupo de Dispositivos",
  "devices.manager.deviceModal.logger": "Logger",
  "devices.manager.deviceModal.name": "Nombre",
  "devices.manager.deviceModal.company": "Empresa",
  "devices.manager.deviceModal.description": "Descripción",
  "devices.manager.deviceModal.model": "Modelo",
  "devices.manager.deviceModal.successCreate":
    "Dispositivo guardado con éxito!",
  "devices.manager.deviceModal.successUpdate":
    "Dispositivo actualizado con éxito!",
  "devices.manager.deviceModal.deviceNameAlready": "Dispositivo ya existe",
  "devices.manager.deviceModal.error.errorExists": "Dispositivo ya existe",
  "devices.manager.deviceModal.error.errorMax": "Error máximo (?)",
  "devices.manager.deviceModal.error.errorMaxDevices": "Has alcanzado el número máximo de dispositivos para tu licencia.",
  "devices.manager.deviceModal.error.sshkey": "Clave de Deploy es obligatoria",
  "devices.manager.deviceModal.error.apikey": "Clave de API es obligatoria",
  "devices.manager.deviceModal.error.name": "Nombre es obligatorio",
  "devices.manager.deviceModal.error.company": "Empresa es obligatoria",
  "devices.manager.deviceModal.error.useradmin":
    "Acceso de el Usuario de gestión es obligatorio",
  "devices.manager.deviceModal.error.ipexists":
    "No es posible grabar lo mismo dirección IP para una interfaz",
  "devices.manager.deviceModal.error.special.characters":
    "La contraseña no puede contener los caracteres especiales siguientes: \" & | ; > < ' ",
  "devices.manager.delete.group.title": "Eliminar grupo",
  "devices.manager.delete.group.message":
    "¿Seguro que desea eliminar el grupo {name}?",
  "devices.manager.delete.device.title": "Eliminar dispositivo",
  "devices.manager.delete.device.message":
    "¿Seguro que desea eliminar el dispositivo {name}?",
  "devices.manager.delete.group.title.mult": "Eliminar grupos",
  "devices.manager.delete.group.message.mult":
    "¿Seguro que desea eliminar los grupos {name}?",
  "devices.manager.delete.device.title.mult": "Eliminar dispositivo",
  "devices.manager.delete.device.message.mult":
    "¿Seguro que desea eliminar los dispositivos {name}?",

  "devices.community.modalAdd.title": "Crear comúnidad",
  "devices.community.modalDelete.title": "Eliminar comúnidad",
  "devices.community.modalDelete.message":
    "¿Seguro que desea eliminar la comúnidad: {name}?",
  "devices.community.modalDelete.message.plural":
    "¿Seguro que desea eliminar las siguientes comúnidades?",
  "devices.community.create.title": "Crear comúnidad",
  "devices.community.edit.title": "Editar comúnidad",
  "devices.community.delete.success": "Comunidad eliminada con éxito",
  "devices.community.form.general": "General",
  "devices.community.form.general.name": "Nombre",
  "devices.community.form.general.description": "Descripción",
  "devices.community.form.general.ike_version": "Versión del IKE",
  "devices.community.form.general.exchange_mode": "Modo de intercambio",
  "devices.community.form.general.exchange_mode.aggressive": "Agresivo",
  "devices.community.form.general.exchange_mode.main": "Principal",
  "devices.community.form.general.topology": "Topología",
  "devices.community.form.general.shared_key": "Clave de Intercambio",
  "devices.community.form.card.settings": "Configuraciones",
  "devices.community.form.save.error": "Dispositivo no ha sido guardado",
  "devices.community.form.save.success": "Dispositivo agregado con éxito",
  "devices.community.form.delete.device.success":
    "Dispositivo eliminado con éxito",
  "devices.community.form.error.role.already.exists":
    "Esta comúnidad ya tiene un hub",
  "devices.community.form.error.required":
    "Por favor al menos dos Dispositivos",

  "devices.community.device.grid.actions.addDevice": "Crear dispositivo",
  "devices.community.device.grid.actions.removeDevice": "Eliminar dispositivo",
  "devices.community.device.modal.device": "Dispositivo",
  "devices.community.device.modal.listAdd": "Red",
  "devices.community.device.modal.host": "Host Local",
  "devices.community.device.modal.localId": "ID Local",
  "devices.community.device.modal.role": "Función",
  "devices.community.device.modal.dynamic": "Dinámico",

  "devices.community.form.success": "Comunidade guardada con éxito",

  "devices.community.form.encryption": "Encriptación",
  "devices.community.form.encryption.phase1": "Fase 1 (IKE)",
  "devices.community.form.encryption.phase2": "Fase 2 (ESP)",
  "devices.community.form.encryption.cryptography_algorithms": "Algoritmo de Encriptación",
  "devices.community.form.encryption.dh.group": "DH Grupo",
  "devices.community.form.encryption.pfs.group": "PFS Grupo",
  "devices.community.form.encryption.encryption_algorithms":
    "Algoritmo de Encriptación",
  "devices.community.form.encryption.authentication_algorithms":
    "Algoritmo de Autentificación",
  "devices.community.form.encryption.dh.group_algorithms": "DH Grupo",
  "devices.community.form.encryption.pfs.group_algorithms": "PFS Grupo",
  "devices.community.form.encryption.diffie_hellman":
    "Grupo Diffie-Hellman (DH)",
  "devices.community.form.encryption.esp_encryption_algorithms":
    "Algoritmos de Encriptación ESP",
  "devices.community.form.encryption.esp_authentication_algorithms":
    "Algoritmos de Autentificación ESP",
  "devices.community.form.encryption.perfect_forward":
    "Grupo Perfect Forward Secrecy (PFS)",

  "devices.community.form.advanced": "Avanzado",
  "devices.community.form.advanced.ike_lifetime":
    "Vida útil de la(s) IKE (segundos)",
  "devices.community.form.advanced.key_lifetime":
    "Vida útil de la(s) Key (segundos)",
  "devices.community.form.advanced.keying_tries": "Tentativas de Keying",
  "devices.community.form.advanced.rekey_margin":
    "Margen(es) de Rekey (segundos)",
  "devices.community.form.advanced.dead_peer_action": "Acción del DPD ",
  "devices.community.form.advanced.dead_peer_action.clear": "Limpiar",
  "devices.community.form.advanced.dead_peer_action.hold": "Intervalo",
  "devices.community.form.advanced.dead_peer_action.restart": "Reiniciar",
  "devices.community.form.advanced.dead_peer_action.none": "Ningún",
  "devices.community.form.advanced.dead_peer_delay":
    "Delay de lo(s) DPD (segundos)",
  "devices.community.form.advanced.dead_peer_timeout":
    "Timeout de lo(s) DPD (segundos)",
  "devices.community.form.advanced.reauth": "Re autentificación",
  "devices.community.form.advanced.fragmentation": "Fragmentación",
  "devices.community.form.advanced.compression": "Compresión",
  "devices.community.form.advanced.natt": "NAT-T",

  "devices.community.form.general.name.error": "Nombre es obligatorio",
  "devices.community.form.general.shared_key.error":
    "Clave compartida es obligatoria",
  "devices.community.form.advanced.ike_lifetime.error":
    "Vida útil del IKE es obligatorio",
  "devices.community.form.advanced.key_lifetime.error":
    "Vida útil de la clave es obligatoria",
  "devices.community.form.advanced.keying_tries.error":
    "Tentativas de Keying es obligatoria",
  "devices.community.form.advanced.rekey_margin.error":
    "Margen de Rekey es obligatoria",
  "devices.community.form.advanced.dead_peer_delay.error":
    "Delay del DPD es obligatorio",
  "devices.community.form.advanced.dead_peer_timeout.error":
    "Timeout del DPD es obligatorio",
  "devices.community.form.advanced.dead_peer_action.error":
    "Acción del DPD es obligatorio",

  "devices.template.title": "Plantilla de Dispositivo",
  "devices.template.datagrid.name": "Nombre",
  "devices.template.datagrid.description": "Descripción",
  "devices.template.datagrid.version": "Versión",
  "devices.template.datagrid.actions": "Acciones",
  "devices.template.actions.create": "Crear Plantilla",
  "devices.template.actions.delete": "Eliminar Plantilla",
  "devices.template.actions.clone": "Clonar Plantilla",
  "devices.template.modal.form.title": "Crear Plantilla",
  "devices.template.modal.form.name": "Nombre",
  "devices.template.modal.form.version": "Versión",
  "devices.template.modal.form.description": "Descripción",
  "devices.template.modal.delete.success": "¡Plantilla eliminada con éxito!",
  "devices.template.modal.delete.error": "¡Error en la eliminación del grupo!",
  "devices.template.modal.clone.success": "¡Plantilla clonado con éxito!",
  "devices.template.modal.clone.error":
    "¡Error en la clonación de la plantilla!",

  "devices.template.config.title": "Configurar Plantilla",
  "devices.template.tabs.form.template": "Plantilla",
  "devices.template.tabs.form.firewall": "Firewall",
  "devices.template.tabs.form.proxy": "Proxy",
  "devices.template.tabs.form.webcache": "Web Cache",
  "devices.template.tabs.form.webfilter": "Web Filter",
  "devices.template.tabs.form.antimalware": "Antimalware",
  "devices.template.tabs.form.dpi": "Deep Inspection",
  "devices.template.tabs.form.sdwan": "SD-WAN",
  "devices.template.tabs.form.dhcp": "DHCP",
  "devices.template.tabs.form.dns": "DNS",
  "devices.template.tabs.form.ddns": "DDNS",
  "devices.template.config.name": "Nombre",
  "devices.template.config.description": "Descripción",
  "devices.template.config.version": "Versión",
  "devices.template.config.modules": "Módulos",
  "devices.template.config.moduleSelect": "Seleccionar el módulo",

  "devices.template.firewall.form.services": "Servicios",
  "devices.template.firewall.form.securitysettings":
    "Configuraciones de seguridad",
  "devices.template.firewall.form.timeouts": "Timeouts",
  "devices.template.firewall.form.create.zone": "Zona de Protección",
  "devices.template.firewall.actions.create": "Crear Zona de Protección",
  "devices.template.firewall.actions.delete": "Eliminar Zona de Protección",
  "devices.template.firewall.form.zoneprotection": "Nueva Zona de Protección",
  "devices.template.firewall.form.addzone": "Zona añadida con éxito",
  "devices.template.firewall.form.add.dos": "Protección DoS añadida con éxito",
  "devices.template.firewall.form.add.ip.spoofing":
    "IP Spoofing añadido con éxito",
  "devices.template.firewall.form.addservice": "Servicio añadido con éxito",
  "devices.template.firewall.tab.policy": "Política",
  "devices.template.firewall.tab.condition": "Condición",
  "devices.template.firewall.form.enabled": "Activado",
  "devices.template.firewall.form.zone": "Zona",
  "devices.template.firewall.form.zones": "Zonas",
  "devices.template.firewall.form.action": "Acción",
  "devices.template.firewall.form.service": "Servicio",
  "devices.template.firewall.form.description": "Descripción",
  "devices.template.firewall.form.authenticated": "Autentificado",
  "devices.template.firewall.form.user": "Usuario",
  "devices.template.firewall.form.group": "Grupo",
  "devices.template.firewall.form.ipv4src": "Dirección IP de origen IPv4",
  "devices.template.firewall.form.ipv4dest": "Dirección IP de destino IPv4",
  "devices.template.firewall.form.ipv6src": "Dirección IP de origen IPv6",
  "devices.template.firewall.form.ipv6dest": "Dirección IP de destino IPv6",
  "devices.template.firewall.form.hour": "Hora",
  "devices.template.firewall.form.dos.protection": "Protección DoS",
  "devices.template.firewall.form.syn.flood": "SYN flood",
  "devices.template.firewall.form.syn.flood.limit":
    "Limite de SYN flood (por segundo)",
  "devices.template.firewall.form.syn.flood.burst": "Burst de SYN flood",
  "devices.template.firewall.form.tcp.flood": "TCP flood",
  "devices.template.firewall.form.tcp.flood.limit":
    "Limite de TCP flood (por segundo)",
  "devices.template.firewall.form.tcp.flood.burst": "Burst de TCP flood",
  "devices.template.firewall.form.udp.flood": "UDP flood",
  "devices.template.firewall.form.udp.flood.limit":
    "Limite de UDP flood (por segundo)",
  "devices.template.firewall.form.udp.flood.burst": "Burst de UDP flood",
  "devices.template.firewall.form.icmp.flood": "ICMP flood",
  "devices.template.firewall.form.icmp.flood.limit":
    "Limite de ICMP flood (por segundo)",
  "devices.template.firewall.form.icmp.flood.burst": "Burst del ICMP flood",
  "devices.template.firewall.form.ip.spoofing": "Protección contra IP Spoofing",
  "devices.template.firewall.datagrid.description": "Descripción",
  "devices.template.firewall.datagrid.service": "Servicio",
  "devices.template.firewall.datagrid.action": "Acción",
  "devices.template.firewall.datagrid.zone": "Zona",
  "devices.template.firewall.datagrid.auth": "Autentificación",
  "devices.template.firewall.form.lan": "LAN",
  "devices.template.firewall.form.wan": "WAN",
  "devices.template.firewall.form.dmz": "DMZ",
  "devices.template.firewall.form.both.http":
    "HTTP y HTTPS detectados en la misma puerto o servicio proxy operativo solo en el modo explícito",
  "devices.template.firewall.form.options": "Opciones",
  "devices.template.firewall.all": "TODOS",
  "devices.template.firewall.error.zone":
    "Seleccione al menos una de las zonas",
  "devices.template.firewall.error.option":
    "Seleccione al menos una de las opciones",
  "devices.template.firewall.burst.rate": "Tasa de explosión (paquete/segundo)",
  "devices.template.firewall.packet.rate": "Tasa de paquete (paquete/segundo)",

  "devices.template.proxy.form.interface":
    "Se requiere al menos una interfaz ETH",
  "devices.template.proxy.form.sslexception": "Excepción SSL",
  "devices.template.proxy.form.disablessl":
    "Desactivar la inspección SSL en el servicio de Proxy",
  "devices.template.proxy.form.required": "Es obligatorio",
  "devices.template.proxy.form.invalid": "No es válido",
  "devices.template.proxy.form.port": "Puerto",
  "devices.template.proxy.form.ssl": "SSL",
  "devices.template.proxy.form.type": "Tipo",
  "devices.template.proxy.form.port21": "Puerto 21",
  "devices.template.proxy.form.port22": "Puerto 22",
  "devices.template.proxy.form.malwareScanning": "Verificación de Malware",
  "devices.template.proxy.form.port25": "Puerto 25",
  "devices.template.proxy.form.port465": "Puerto 465",
  "devices.template.proxy.form.port587": "Puerto 587",
  "devices.template.proxy.form.addheader": "Añadir encabezado",
  "devices.template.proxy.form.port110": "Puerto 110",
  "devices.template.proxy.form.port995": "Puerto 995",
  "devices.template.proxy.form.spamassassin-active": "Filtro de Spam (0~10)",
  "devices.template.proxy.form.spamassassin-value": "Valor entre 0 y 10",
  "devices.template.proxy.form.emailSubject": "Asunto del e-mail",
  "devices.template.proxy.form.emailTemplate": "Modelo de Correo Electrónico",
  "devices.template.proxy.form.explicit.proxy": "Proxy explícito",
  "devices.template.proxy.form.explicit.proxy.warning":
    "Para que la funcionalidad de Proxy Explícito funcione correctamente, también se deben habilitar las reglas de Zone Protection que pueden usar el mismo servicio",
  "devices.template.proxy.form.explicit.proxy.warning.message.part1": "La regla de Zone Protection nombrada ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part2": " también utiliza el servicio llamado ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part3": " y está discapacitado. Habilite la regla mencionada para que el Proxy Explícito funcione correctamente.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part4": "El servicio seleccionado para Proxy Explícito no se utiliza en ninguna regla de Zone Protection existente. Para que el Proxy Explícito funcione correctamente, se debe crear y habilitar una regla de Zone Protection con el servicio.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part5": "Regla de Zone Protection asociada:",
  "devices.template.proxy.form.authentication.mode": "Modo de autentificación",
  "devices.template.proxy.form.authentication.mode.basic": "Básico",
  "devices.template.proxy.form.autentication.mode.captive": "Captive Portal",
  "devices.template.proxy.form.modal.error.rule.exists": "Esta regla ya existe",

  "devices.template.antimalware.form.detect":
    "Detectar aplicaciones potencialmente no deseados",
  "devices.template.antimalware.form.block": "Bloquear archivos encriptados",
  "devices.template.antimalware.form.heuristic": "Habilitar Análisis de Comportamiento y Dinámica",
  "devices.template.antimalware.form.passive": "Modo pasivo",
  "devices.template.antimalware.form.filesize": "Tamaño máximo del archivo",
  "devices.template.antimalware.form.quarantine": "Tamaño de la cuarentena",
  "devices.template.antimalware.form.dayin": "Días en cuarentena",

  "devices.template.webfilter.form.custom": "Personalizar página de bloqueo",
  "devices.template.webfilter.form.blocking.message":
    "La configuración de control de acceso impide que su solicitación sea permitida en el momento. ¡Por favor, comúníquese con su proveedor de servicios si crees que esto no estas correcto.",
  "devices.template.webfilter.form.customnewlogo": "Nuevo logotipo",
  "devices.template.webfilter.form.customblock": "Mensaje de bloqueo",
  "devices.template.webfilter.form.customredirect":
    "Desviar para página externa",
  "devices.template.webfilter.form.hostname": "Nombre de lo Host",
  "devices.template.webfilter.form.googledomains": "Dominios Google",
  "devices.template.webfilter.form.googleenabled": "Activado",
  "devices.template.webfilter.form.googleaddress": "Dirección IP",
  "devices.template.webfilter.form.googlegroups": "Grupos",
  "devices.template.webfilter.form.googleusers": "Usuarios",
  "devices.template.webfilter.form.safe": "Safe search",
  "devices.template.webfilter.form.safeenabled": "Activado",
  "devices.template.webfilter.form.safeaddress": "Dirección IP",
  "devices.template.webfilter.form.safegroups": "Grupos",
  "devices.template.webfilter.form.safeusers": "Usuarios",

  "devices.template.webcache.form.size": "Tamaño de la memoria caché",
  "devices.template.webcache.form.maximum":
    "Tamaño máximo del objeto en la memória",
  "devices.template.webcache.form.disk": "Tamaño del caché de disco",
  "devices.template.webcache.form.minimum":
    "Tamaño mínimo del objeto en lo disco",
  "devices.template.webcache.form.dynamic": "Caché de contenido dinámico",
  "devices.template.webcache.form.exception": "Caché de excepción",

  "devices.template.dns.form.configuration": "Configuración",
  "devices.template.dns.form.dnsservers": "Servidores DNS",
  "devices.template.dns.form.interfaces": "Interfaces",
  "devices.template.dns.form.dnscache": "Caché DNS",
  "devices.template.dns.form.security": "Seguridad",
  "devices.template.dns.form.rebind": "Protección contra Re consolidación",
  "devices.template.dns.form.allowlocal": "Permitir Local",
  "devices.template.dns.form.allowdomains": "Dominios permitidos",
  "devices.template.dns.form.redirection": "Redireccionamiento",
  "devices.template.dns.modal.title": "Nuevo redireccionamiento",
  "devices.template.dns.modal.server": "Servidor DNS",
  "devices.template.dns.modal.redirect": "Redireccionar dirección",
  "devices.template.dns.datagrid.server": "Servidor DNS",
  "devices.template.dns.save.success": "Servidor añadido con éxito",
  "devices.template.dns.actions.create": "Crear Servidor",
  "devices.template.dns.actions.delete": "Eliminar Servidor",

  "devices.template.dpi.modal.titleProfile": "Perfil DPI",
  "devices.template.dpi.modal.titleWhite": "Direcciones Permitidas",
  "devices.template.dpi.modal.titleBlack": "Direcciones Bloqueadas",
  "devices.template.dpi.modal.error.delete.profile":
    "No es posible eliminar {Nombre}. Perfil en uso en el Zona de Protección.",
  "devices.template.dpi.modal.form.error.name.exists":
    "Un perfil con ese nombre ya existe",
  "devices.template.dpi.delete.success": "Perfil eliminado con éxito",
  "devices.template.dpi.delete.error": "¡Error en el perfil eliminado!",
  "devices.template.dpi.delete.error.inUse":
    "¡No es posible eliminar el perfil! Perfil en uso",
  "devices.template.dpi.datagrid.profiles": "Perfiles",
  "devices.template.dpi.datagrid.name": "Nombre",
  "devices.template.dpi.datagrid.type": "Tipo",
  "devices.template.dpi.datagrid.whitelist": "Direcciones Permitidas",
  "devices.template.dpi.datagrid.blacklist": "Direcciones Bloqueadas",
  "devices.template.dpi.datagrid.actions": "Acciones",
  "devices.template.dpi.datagrid.status": "Estatus",
  "devices.template.dpi.datagrid.block": "Bloqueo",
  "devices.template.dpi.datagrid.risk": "Riesgo",
  "devices.template.dpi.datagrid.quarantine": "Cuarentena",
  "devices.template.dpi.datagrid.signature": "Suscripción",
  "devices.template.dpi.datagrid.ip.address": "Dirección IP",
  "devices.template.dpi.datagrid.direction": "Dirección",
  "devices.template.dpi.datagrid.category": "Categoría",
  "devices.template.dpi.datagrid.hight": "Alto",
  "devices.template.dpi.datagrid.medium": "Mediano",
  "devices.template.dpi.datagrid.low": "Bajo",
  "devices.template.dpi.datagrid.required.fields":
    "Todos los campos son obligatorios",
  "devices.template.dpi.datagrid.already.exists": "Excepción ya existe",
  "devices.template.dpi.profile.name": "Nombre",
  "devices.template.dpi.profile.description": "Descripción",
  "devices.template.dpi.profile.type": "Tipo",
  "devices.template.dpi.profile.process": "Proceso",
  "devices.template.dpi.profile.devin": "Entrada en Interfaz",
  "devices.template.dpi.profile.devout": "Salida de la Interfaz",
  "devices.template.dpi.profile.intrusionPrevention": "Intrusion Prevention",
  "devices.template.dpi.profile.advancedProtection":
    "Advanced Threat Protection",
  "devices.template.dpi.profile.applicationControl": "Application Control",
  "devices.template.dpi.profile.automaticRules":
    "Activar actualización automática de las reglas",
  "devices.template.dpi.profile.allPorts": "Inspeccionar todas los puertos",
  "devices.template.dpi.list.ipmask": "IP/MASK",

  "devices.template.sdwan.modal.title": "Perfil SD-WAN",
  "devices.template.sdwan.tab.interface": "Interfaces",
  "devices.template.sdwan.tab.monitor": "Monitor",
  "devices.template.sdwan.actions.createProfile": "Crear Perfil",
  "devices.template.sdwan.actions.deleteProfile": "Eliminar Perfil",
  "devices.template.sdwan.save.successProfile": "Perfil guardado con éxito",
  "devices.template.sdwan.save.errorProfile": "El perfil no ha sido guardado",
  "devices.template.sdwan.modal.form.error.name.exists":
    "Un perfil con este Nombre ya existe",
  "devices.template.sdwan.delete.success": "Perfil eliminado con éxito",
  "devices.template.sdwan.delete.error": "¡Error no perfil eliminado!",
  "devices.template.sdwan.delete.error.inUse":
    "¡No se pudo eliminar el perfil! Perfil en utilización",
  "devices.template.sdwan.datagrid.profiles": "Perfiles",
  "devices.template.sdwan.datagrid.name": "Nombre",
  "devices.template.sdwan.datagrid.description": "Descripción",
  "devices.template.sdwan.datagrid.version": "Versión",
  "devices.template.sdwan.datagrid.type": "Tipo",
  "devices.template.sdwan.datagrid.interfaces": "Interfaces",
  "devices.template.sdwan.datagrid.actions": "Acciones",
  "devices.template.sdwan.form.name": "Nombre",
  "devices.template.sdwan.form.version": "Versión",
  "devices.template.sdwan.form.description": "Descripción",
  "devices.template.sdwan.form.type": "Tipo",
  "devices.template.sdwan.form.interfaces": "Interfaces",
  "devices.template.sdwan.form.monitorInterval": "Intervalo de monitoreo (seg)",
  "devices.template.sdwan.form.balancingInterval":
    "Intervalo de balanceo (min)",
  "devices.template.sdwan.form.failRatio": "Tasa de falla (1 - 100%)",
  "devices.template.sdwan.form.bandwidth": "Bandwidth (Mbps)",
  "devices.template.sdwan.form.qualityCriteria": "Criterio de calidad (Mbps)",
  "devices.template.sdwan.form.persistentConn": "Conexión persistente",
  "devices.template.sdwan.form.persistenceTimeout":
    "Timeout da persistencia 1-1440 minutos",
  "devices.template.sdwan.form.persistenceTimeoutReduce":
    "Timeout da persistencia 1-1440 minutos",
  "devices.template.sdwan.form.loadbalance": "Load Balance",
  "devices.template.sdwan.form.valueJitter": "Jitter",
  "devices.template.sdwan.form.valueLatency": "Latencia",
  "devices.template.sdwan.form.valuePacketLoss": "Pérdida de paquetes",
  "devices.template.sdwan.form.valueBandwidth": "Límite de ancho de banda",
  "devices.template.sdwan.form.address": "Dirección",
  "devices.template.sdwan.form.protocol": "Protocolo",
  "devices.template.sdwan.form.attempts": "Tentativas",
  "devices.template.sdwan.form.timeout": "Timeout",
  "devices.template.sdwan.form.performance": "Indicadores de Performance",
  "devices.template.sdwan.form.monitoring": "Objetivo de monitoreo",
  "devices.template.sdwan.form.error.loadbalance.invalid":
    "Loadbalance total no válido",
  "devices.template.sdwan.form.error.interface.invalid":
    "¡Por favor, seleccione una interfaz",
  "devices.template.sdwan.form.error.address": "Dirección no válido",
  "devices.template.sdwan.form.modal.error.rule.exists":
    "Este dirección ya existe",
  "devices.template.sdwan.form.failback": "Failback",
  "devices.template.sdwan.form.device-description": "Device Description",
  "devices.template.sdwan.form.packet-duplication": "Packet Duplication",
  "devices.template.sdwan.form.load-balance": "Load Balance",

  "devices.template.ssl.modal.title": "Perfil SSL",
  "devices.template.ssl.form.name": "Nombre",
  "devices.template.ssl.form.settings.workers": "Cantidad de Workers",
  "devices.template.ssl.form.limit": "Cantidad de CPUs disponible sobrepasado",
  "devices.template.ssl.form.min": "La cantidad mínima de Workers es 1",
  "devices.template.ssl.form.version": "Versión",
  "devices.template.ssl.form.description": "Descripción",
  "devices.template.ssl.form.mode": "Modo",
  "devices.template.ssl.form.protocols": "Protocolo",
  "devices.template.ssl.form.exception": "Excepción de inspección",
  "devices.template.ssl.form.dictionary": "Diccionario",
  "devices.template.ssl.datagrid.name": "Nombre",
  "devices.template.ssl.datagrid.description": "Descripción",
  "devices.template.ssl.datagrid.version": "Versión",
  "devices.template.ssl.datagrid.mode": "Modo",
  "devices.template.ssl.datagrid.actions": "Acciones",
  "devices.template.ssl.save.successProfile": "Perfil guardado con éxito",
  "devices.template.ssl.save.errorProfile": "Perfil no ha sido guardado",
  "devices.template.ssl.delete.success": "Perfil eliminado con éxito",
  "devices.template.ssl.delete.error": "Error en eliminar el perfil ",
  "devices.template.ssl.delete.error.inUse":
    "¡No fue posible eliminar el perfil! Perfil en uso",

  "devices.template.sdwan.modal.titleService": "Servicio SD-WAN",
  "devices.template.sdwan.actions.createService": "Crear servicio",
  "devices.template.sdwan.actions.deleteService": "Eliminar servicio",
  "devices.template.sdwan.save.successService": "Servicio añadido con éxito",
  "devices.template.sdwan.form.enable": "Habilitar",
  "devices.template.sdwan.form.service": "Servicio",
  "devices.template.sdwan.form.dstAddress": "Dirección IP de Destino",
  "devices.template.sdwan.form.profile": "Perfil",
  "devices.template.sdwan.actions.delete.service":
    "¿Seguro que desea eliminar?",

  "devices.template.dhcp.datagrid.servers": "Servidores",
  "devices.template.dhcp.datagrid.interface": "Interfaz",
  "devices.template.dhcp.datagrid.type": "Tipo",
  "devices.template.dhcp.datagrid.range": "Rango",
  "devices.template.dhcp.datagrid.relay": "Relay",
  "devices.template.dhcp.datagrid.actions": "Acciones",
  "devices.template.dhcp.modal.titleServer": "Servidor DHCP",
  "devices.template.dhcp.modal.titleRange": "Rango DHCP",
  "devices.template.dhcp.modal.titleRelay": "Relay DHCP",

  "devices.template.dhcp.modal.interface": "Interfaz",
  "devices.template.dhcp.modal.description": "Descripción",
  "devices.template.dhcp.modal.type": "Tipo",
  "devices.template.dhcp.modal.gateway": "Gateway",
  "devices.template.dhcp.modal.dnsSufix": "Sufijo DNS",
  "devices.template.dhcp.modal.renewaltime": "Tiempo de renovación (segundos)",
  "devices.template.dhcp.modal.dns": "DNS",
  "devices.template.dhcp.modal.wins": "WINS",
  "devices.template.dhcp.modal.tftp": "TFTP Server (opción 150)",
  "devices.template.dhcp.modal.rangeini": "Inicio del Rango",
  "devices.template.dhcp.modal.rangeend": "Final del Rango",
  "devices.template.dhcp.modal.macfilter": "MAC Filter",
  "devices.template.dhcp.modal.ipv4server": "Servidor IPV4",
  "devices.template.dhcp.modal.ipv6server": "Servidor IPV6",
  "devices.template.dhcp.modal.enableDhcp": "Habilitar DHCP",
  "devices.template.dhcp.modal.renewaltime.invalid": "¡Tiempo de renovación inválido!",

  "devices.template.dhcp.actions.createServer": "Crear Servidor",
  "devices.template.dhcp.actions.deleteServer": "Eliminar Servidor",
  "devices.template.dhcp.actions.createRange": "Crear Rango",
  "devices.template.dhcp.actions.deleteRange": "Eliminar Rango",
  "devices.template.dhcp.actions.createRelay": "Crear Relay",
  "devices.template.dhcp.actions.deleteRelay": "Eliminar Relay",
  "devices.template.dhcp.actions.remove.text": "¿Seguro que desea eliminar?",

  "devices.service.dhcp.settings.authentication.radius": "Autenticación RADIUS",
  "devices.service.dhcp.settings.adress.static": "Direcciones estáticas",
  "devices.service.dhcp.settings.import.static.title": "Importar direcciones estáticas",
  "devices.service.dhcp.settings.import.static.add": "Agregar Host",
  "devices.service.dhcp.settings.import.static.edit": "Para editar Host",
  "devices.service.dhcp.settings.range.edit": "Para editar Range",
  "devices.service.dhcp.settings.range.add": "Agregar Range",
  "devices.service.dhcp.settings.range.settings": "Ajuste de Range",
  "devices.service.dhcp.settings.win.primary": "WINS Primario",
  "devices.service.dhcp.settings.win.secudary": "WINS Secundario",
  "devices.service.dhcp.settings.tftp.primary": "TFTP Primario",
  "devices.service.dhcp.settings.tftp.secudary": "TFTP Secundario",
  "devices.service.dhcp.add.server.noDevice": "No hay interfaz disponible, verifique la configuración de rede.",
  "devices.service.dhcp.add.server.select.interface": "Seleccione una interfaz!",
  "devices.service.dhcp.add.server.select.type": "Tipo de IP",
  "devices.service.dhcp.add.Relay.title.add": "Agregar Relay",
  "devices.service.dhcp.add.Relay.title.edit": "Para editar Relay",
  "devices.service.dhcp.add.Relay.server.ipv6": "Servidores IPv6",
  "devices.service.dhcp.add.Relay.server.ipv4": "Servidores IPv4",
  "devices.service.dhcp.lease.remove": "Estas seguro que quieres eliminar lo(s) siguiente(s) Lease(s)?",
  "devices.service.dhcp.datagrid.options.title": "Opciones DHCP adicionales",
  "devices.service.dhcp.modal.options.title.add": "Crear nuevas opciones de DHCP",
  "devices.service.dhcp.modal.options.title.edit": "Editar opciones de DHCP",
  "devices.service.dhcp.modal.options.label.code": "Código de opción",
  "devices.service.dhcp.modal.options.placeholder.value": "Introduzca el valor",
  "devices.service.dhcp.modal.options.code": "Código",
  "devices.service.dhcp.modal.options.code.error": "The custom code must be integer",
  "devices.service.dhcp.modal.options.info.redirect": "*Al aplicar la cola se reiniciará el servicio DHCP, para consultar su estado haga clic aquí.",

  "devices.service.dhcp.message.relay.setting": "DHCP Relay configurada!",
  "devices.service.dhcp.message.no.range": "Range no configurado! Establezca un range antes de guardar.",
  "devices.service.dhcp.message.value.integer": "El valor de tiempo para el arrendamiento debe ser un número entero!",
  "devices.service.dhcp.message.ipRadius.required": "El campo IP del Radius es obligatorio!",
  "devices.service.dhcp.message.secret.Radius.required": "El Campo Secreto Radius debe estar lleno!",
  "devices.service.dhcp.message.range.delete.sucess": "Range eliminado con éxito!",
  "devices.service.dhcp.message.object.interface": "Error! No se puede editar la dirección de la interfaz.",
  "devices.service.dhcp.message.invalid.range": "Rango no válido! ¡El Rango final debe ser mayor que el inicial!",
  "devices.service.dhcp.message.invalid.ranges": "Ranges no válidos!",
  "devices.service.dhcp.message.invalid.ranges.out": "La dirección IP de la interfaz no se encuentra dentro del rango seleccionado!",
  "devices.service.dhcp.message.invalid.ranges.AlreadyExists": "Rango contenido en otro registrado!",
  "devices.service.dhcp.message.invalid.ranges.out.interface": "Puerta de enlace incorrecta: ¡fuera del alcance de la interfaz!",
  "devices.service.dhcp.message.invalid.ranges.broadcast": "Puerta de enlace incorrecta: red o dirección de transmisión",
  "devices.service.dhcp.message.invalid.mac": "Error de Mac informado!",
  "devices.service.dhcp.message.range.save.sucess": "Rango guardado con éxito!",
  "devices.service.dhcp.message.static.Already.used": "El host ya se está utilizando en direcciones estáticas!",
  "devices.service.dhcp.message.static.ip.Already.used": "IP ya se está utilizando en direcciones estáticas!",
  "devices.service.dhcp.message.static.mac.Already.used": "Mac ya se está utilizando en direcciones estáticas!",
  "devices.service.dhcp.message.static.not.subnet": "La dirección IP no pertenece a la subnet!",
  "devices.service.dhcp.message.import.empty": "importación cancelada! ¡Archivo vacío!",
  "devices.service.dhcp.message.fields": "Importación cancelada! error en los campos: ",
  "devices.service.dhcp.message.fields.host": "Importación cancelada! Duplicación de nombre de host: ",
  "devices.service.dhcp.message.fields.ip": "Importación cancelada! Duplicación de IP: ",
  "devices.service.dhcp.message.fields.mac": "Importación cancelada! Duplicación de direcciones Mac: ",
  "devices.service.dhcp.message.import.sucess": " registros importados con éxito!",
  "devices.service.dhcp.message.line": "En la Linea: ",
  "devices.service.dhcp.message.used.radius": "Aviso! Cambiar el servidor DHCP puede causar un conflicto de IP.",

  "devices.template.ddns.form.dynamicDNS": "DNS Dinámico",
  "devices.template.ddns.modal.title": "Novo Host",
  "devices.template.ddns.actions.create": "Crear Host",
  "devices.template.ddns.actions.delete": "Eliminar Host",
  "devices.template.ddns.datagrid.service": "Servicio",
  "devices.template.ddns.datagrid.host": "Host",
  "devices.template.ddns.datagrid.interface": "Interfaz",
  "devices.template.ddns.datagrid.user": "Usuario",
  "devices.template.ddns.datagrid.password": "Contraseña",
  "devices.template.ddns.datagrid.actions": "Acción",
  "devices.template.ddns.save.success": "Host añadido con éxito",

  "devices.template.custom.branding": "Marca Personalizada",
  "devices.template.custom.custom": "Personalizar",
  "devices.template.custom.title": "Título de la página",
  "devices.template.custom.favicon": "Favicon",
  "devices.template.custom.favicon.recommended": "Recomendado PNG o ICO 32x32",
  "devices.template.custom.logo": "Logotipo",
  "devices.template.custom.logo.recommended": "Recomendado SVG 300x65",
  "devices.template.custom.background": "Background",
  "devices.template.custom.background.recommended":
    "Recomendado PNG o JPG 1920x1080",
  "devices.template.custom.upload": "Haga clic para cargar",
  "devices.template.custom.preview": "Previsualización",
  "devices.template.custom.restore": "Restaurar por defecto",
  "devices.template.custom.restore.confirm":
    "¿Desea confirmar la restauración a las configuraciones por defecto de la fábrica?",
  "devices.template.custom.color": "Cor",
  "devices.template.custom.upload.error.size":
    "El archivo debe ser mas pequeño que 2MB",
  "devices.template.custom.upload.error.dimension":
    "Las dimensiones de la imagen no son las que se recomiendan",
  "devices.template.custom.color.menu_section_bg_color": "Sección",
  "devices.template.custom.color.menu_section_color": "Fuente Sección",
  "devices.template.custom.color.menu_selected_bg_color": "Seleccionado",
  "devices.template.custom.color.menu_selected_color": "Fuente Selec",
  "devices.template.custom.color.menu_open_bg_color": "Abierto",
  "devices.template.custom.color.menu_open_color": "Fuente Abierto",
  "devices.template.custom.color.menu_open_hover_color": "F Abierto Selec",
  "devices.template.custom.color.menu_bg_color": "Menu",
  "devices.template.custom.color.menu_color": "Fuente Menu",
  "devices.template.custom.color.menu_base_bg_color": "Base",

  "devices.profiles.intrusion.prevention.form.name": "Nombre",
  "devices.profiles.intrusion.prevention.form.version": "Versión",
  "devices.profiles.intrusion.prevention.form.description": "Descripción",
  "profiles.intrusionprevention.error.processes.limit":
    "Limite del procesos alcanzados",

  "devices.template.provisioning": "Aprovisionamiento de plantilla",
  "devices.template.provisioning.add.batch": "Aprovisionamiento en lote",
  "devices.template.provisioning.file": "Archivo",
  "devices.template.provisioning.line": "Línea",
  "devices.template.provisioning.view.uuid": "UUID con error",
  "devices.template.provisioning.name.and.uuid": "Nombre y UUID",
  "devices.template.provisioning.import.file": "Fr archivo",
  "devices.template.provisioning.download.file": "Archivo inválido",
  "devices.import-rule.error.file": "File is not valid",
  "devices.template.provisioning.import.success":
    "{number} elemento(s) importado(s) con éxito",
  "devices.template.provisioning.import.error": "Error al importar lote",
  "devices.template.provisioning.import.error.check.file":
    "Error al importar lote. Compruebe los archivos de importación.",
  "devices.template.provisioning.batch.import.error":
    "No fue posible importar el lote",
  "devices.template.provisioning.delete.batch": "Eliminar lote",
  "devices.template.provisioning.delete.unique": "Eliminar",
  "devices.template.provisioning.error.duplicate.eth": "ETH duplicada",
  "devices.template.provisioning.error.duplicate.uuid": "UUID duplicado",
  "devices.template.provisioning.error.duplicate.name": "Nombre duplicado",
  "devices.template.provisioning.error.errorexists":
    "Nombre o UUID ya registrado",
  "devices.template.provisioning.error.validate.error": "Campo no válido",
  "devices.template.provisioning.error.field": "Campo vacío",
  "devices.template.provisioning.status.costumer": "Error Cliente ID",
  "devices.template.provisioning.status.used": "Licencia en utilización",
  "devices.template.provisioning.status.expired": "Fecha de caducidad vencida",
  "devices.template.provisioning.status.found": "Licencia no existe",
  "devices.template.provisioning.status.inactive": "Licencia inactiva",
  "devices.template.provisioning.error.file.csv":
    "Solo se puede cargar archivos CSV",

  "devices.backups.create": "Crear copia de seguridad",
  "devices.backups.delete": "Eliminar copia de seguridad",
  "devices.backups.last.backup": "Último copia de seguridad",
  "devices.backups.last.status": "Último copia de seguridad",
  "devices.backups.next.backup": "Próximo copia de seguridad",
  "devices.backups.backup.details": "Detalles sobre las copias de seguridad",
  "devices.backups.backup.history": "Histórico de copia de seguridad",
  "devices.backups.status.error.disk": "Error en el almacenamiento",
  "devices.backups.status.error.disk.full": "Almacenamiento lleno",
  "devices.backups.backup.system": "Sistema",
  "devices.backups.backup.snapshot": "Snapshot",
  "devices.backups.status.partial": "Parcial",
  "devices.backups.backup.remote.storage": "Almacenamiento Remoto",
  "devices.backups.backup.retention.backup":
    "Número de copia de seguridad retenidos",
  "devices.backups.backup.retention.percent": "Porcentaje de espacio en disco",
  "devices.backups.backup.schedule": "Programación",
  "devices.backups.backup.select.type": "Seleccione un tipo",
  "devices.backups.backup.select.device": "Seleccione un dispositivo",
  "devices.backups.backup.select.device.group":
    "Seleccione un grupo de dispositivos",
  "devices.backups.backup.devices": "Dispositivos",
  "devices.backups.backup.devices.group": "Grupo de Dispositivos",
  "devices.backups.schedule.disabled": "Desactivado",
  "devices.backups.schedule.oneshot": "Una vez",
  "devices.backups.schedule.daily": "Diariamente",
  "devices.backups.schedule.weekly": "Semanalmente",
  "devices.backups.schedule.monthly": "Mensualmente",
  "devices.backups.schedule.month.day": "Día del mes",
  "devices.backups.schedule.week.day": "Día de la semana",
  "devices.backups.schedule.date.time": "Fecha y hora",
  "devices.backups.action.save.success":
    "Copia de seguridad guardada con éxito",
  "devices.backups.action.running.success":
    "La copia de seguridad está siendo ejecutado",
  "devices.backups.action.save.error": "Error al guardar la copia de seguridad",
  "devices.backups.action.delete.success":
    "Copia(s) de seguridad eliminado(s) con éxito",
  "devices.backups.action.delete.error": "Error al eliminar copia de seguridad",
  "devices.backups.action.delete.storage.error":
    "Error al eliminar la copia de seguridad. Almacenamiento no disponible.",
  "devices.backups.action.restore.success":
    "Espere. Su copia de seguridad está en proceso de restauración.",
  "devices.backups.action.restore.success.manager":
    "Copia de seguridad restaurada con éxito",
  "devices.backups.action.restore.already.exists":
    "Espere. Ya existe una copia de seguridad en proceso de restauración",
  "devices.backups.action.restore.error.encryption.key":
    "Error al restaurar la copia de seguridad. Segredo no válido.",
  "devices.backups.action.restore.error":
    "Error al restaurar la copia de seguridad",
  "devices.backups.action.disabled.success":
    "Copia de seguridad desactivado con éxito",
  "devices.backups.action.disabled.error":
    "Error al desactivado la copia de seguridad",
  "devices.backups.action.enabled.success":
    "Copia de seguridad activada con éxito",
  "devices.backups.action.enabled.error": "Error al activar backup",
  "devices.backups.action.stop.success": "Copia de seguridad parada con éxito",
  "devices.backups.action.stop.error": "Error al parar la copia de seguridad",
  "devices.backups.action.duplicate.error": "Campo duplicado",
  "devices.backups.action.already.exists":
    "Nombre de la copia de seguridad ya creado",
  "devices.backups.action.disabled": "Desactivar la copia de seguridad",
  "devices.backups.action.enabled": "Activar la copia de seguridad",
  "devices.backups.status.success": "Éxito",
  "devices.backups.status.stopped": "Parado",
  "devices.backups.status.restoring": "Restaurando",
  "devices.backups.status.waiting": "Esperando",
  "devices.backups.status.waiting.schedule": "Esperando programación",
  "devices.backups.status.running": "En ejecución",
  "devices.backups.status.downloading": "Descargando",
  "devices.backups.status.pending": "Pendiente",
  "devices.backups.status.error": "Error",
  "devices.backups.status.deploy.running": "Implementación en progreso",
  "devices.backups.status.cancelled": "Cancelado",
  "devices.backups.backup.not.done": "No realizado",
  "devices.backups.backup.not.scheduled": "No programado",
  "devices.backups.backup.download": "Descargar",
  "devices.backups.backup.restore": "Restaurar",
  "devices.backups.backup.stop": "Parar",
  "devices.backups.backup.view.details": "Ver detalles",
  "devices.backups.backup.download.start":
    "Tu descarga empezará en un instante",
  "devices.backups.backup.download.error": "Error al descargar",
  "devices.backups.backup.encryption.key": "Segredo",

  "policies.header": "Políticas",
  "policies.tab.package.title": "Paquetes de política",
  "policies.tab.template.title": "Plantilla de política",

  "policies.package.title": "Paquetes de Política",
  "policies.package.grid.policies": "Políticas",
  "policies.package.bulk.create": "Crear Paquetes",
  "policies.package.bulk.delete": "Eliminar Paquetes",
  "policies.package.bulk.clone": "Clonar Paquetes",
  "policies.package.saved": "Paquetes creado con éxito",
  "policies.package.edited": "Paquetes editado con éxito",
  "policies.package.cloned": "Paquetes clonado con éxito",
  "policies.package.deleted": "Paquetes eliminado con éxito",
  "policies.package.error": "¡Error de red!",

  "policies.templates.title": "Plantilla de Política",
  "policies.templates.bulk.create": "Crear Plantilla",
  "policies.templates.bulk.delete": "Eliminar Plantilla",
  "policies.templates.bulk.clone": "Clonar Plantilla",
  "policies.templates.saved": "Paquete creado con éxito",
  "policies.templates.edited": "Paquete editado con éxito",
  "policies.templates.cloned": "Paquete clonado con éxito",
  "policies.templates.deleted": "Paquete eliminado con éxito",
  "policies.templates.error": "¡Erro!",

  "policy.manager.title": "Gestor de Políticas",
  "policy.manager.readonly": "(solo lectura)",
  "policy.manager.position.header": "Reglas Previas Locales",
  "policy.manager.position.footer": "Reglas Posteriores Locales",
  "policy.manager.position.local": "Reglas Locales",
  "policy.manager.group.create": "Crear Grupo",
  "policy.manager.group.delete": "Eliminar Grupos",
  "policy.manager.group.created": "Grupo creado con éxito",
  "policy.manager.group.edited": "Grupo editado con éxito",
  "policy.manager.group.deleted": "Grupo eliminado con éxito",
  "policy.manager.order.changed": "Orden alterada con éxito",
  "policy.manager.policy.saved": "Política guardada con éxito",
  "policy.manager.policy.enabled": "Política activada",
  "policy.manager.policy.disabled": "Política desactivada",
  "policy.manager.policy.deleted": "Política eliminada con éxito",
  "policy.manager.policy.create": "Crear política",
  "policy.manager.policy.delete": "Eliminar Políticas",
  "policy.manager.policy.import": "Importar Plantilla",
  "policy.manager.policy.save": "Guardar Plantilla",
  "policy.manager.policy.action.allow": "Permitir",
  "policy.manager.policy.action.reject": "Desechar",
  "policy.manager.policy.action.deny": "Denegar",

  "policy.manager.policy.validation.modal.conclicted_with":
    "Estoy en conflicto con la regla de identificación",
  "policy.manager.policy.validation.modal.type": "Tipo do conflicto",
  "policy.manager.policy.validation.modal.type.1": "Ofuscación",
  "policy.manager.policy.validation.modal.type.2":
    "Mismos parámetros y diferentes acciones",
  "policy.manager.policy.validation.modal.type.3": "Regla duplicada",
  "policy.manager.policy.validation.modal.verified": "Registrado",
  "policy.manager.policy.validation.modal.description": "Descripción",

  "policy.manager.group.valid_polices": "Valida regras",
  "policy.manager.group.header.rule": "Regla",
  "policy.manager.group.header.source": "Origen",
  "policy.manager.group.header.destination": "Destino",
  "policy.manager.group.header.schedule": "Programación",
  "policy.manager.group.header.services": "Servicios",
  "policy.manager.group.header.tags": "Tags",
  "policy.manager.group.header.modules": "Módulos",
  "policy.manager.group.header.action": "Acción",
  "policy.manager.group.expand_all": "Expandir Todos",
  "policy.manager.group.collapse_all": "Recoger Todos",
  "policy.manager.notags": "Sin tags",
  "policy.manager.network_zone": "Zona de rede: {zone}",
  "policy.manager.network_interface": "Interfaz de red: {interface}",
  "policy.manager.network_macaddress": "Dirección MAC: {mac}",
  "policy.manager.filter.changed": "Filtro cambiado",
  "policy.manager.error": "¡Error!",
  "policy.manager.invalid": "¡Operação inválida!",
  "policy.manager.template.imported": "Plantilla importada con éxito",
  "policy.manager.template.saved": "Plantilla guardada con éxito",
  "policy.manager.policy.cloned": "Regla clonada con éxito",
  "policy.manager.policy.clone": "Clone",
  "policy.manager.policy.clone.title": "Confirme para clonar",
  "policy.manager.policy.clone.confirm":
    "¿Seguro que quiere clonar la regla {ruleName}?",

  "policy.modal.form.error.name.exists": "El nombre de esta política ya existe",

  "policy.form.properties": "Propriedades",
  "policy.form.properties.general": "General",
  "policy.form.properties.name": "Nombre",
  "policy.form.properties.name.required": "Por favor introduzca el Nombre!",
  "policy.form.properties.description": "Descripción",
  "policy.form.properties.description.required":
    "Por favor introduzca la Descripción!",
  "policy.form.properties.action": "Acción",
  "policy.form.properties.action.required": "Por favor seleccione una acción!",
  "policy.form.properties.tags": "Tags",
  "policy.form.properties.policy.group": "Grupo de política",
  "policy.form.properties.policy.group.required":
    "Por favor seleccione un grupo!",
  "policy.form.properties.traffic.monitor": "Traffic Monitor",
  "policy.form.properties.traffic.logging": "Traffic Logging",
  "policy.form.properties.schedule": "Programación",
  "policy.form.properties.time": "Tiempo",
  "policy.form.properties.time.required": "¡Por favor seleccione un horario!",
  "policy.form.properties.period.date": "Programación",
  "policy.form.properties.period.date.required":
    "¡Seleccione una programación de fecha!",
  "policy.form.properties.traffic.monitor.modal":
    "Desactivar esta función, no será posible monitorear los datos de esta Política en Dashboard y Live Sessions",
  "policy.form.properties.traffic.monitor.modal.title": "¡Atención!",
  "policy.form.properties.traffic.monitor.modal.button.ok": "Seguir",
  "policy.form.properties.traffic.monitor.modal.button.cancel": "Cancelar",

  "policy.form.connection": "Conexión",
  "policy.form.connection.item": "Elemento",
  "policy.form.connection.source": "Origen",
  "policy.form.connection.source.required": "¡Por favor seleccione una fuente!",
  "policy.form.connection.source.network.zone": "Zona de red",
  "policy.form.connection.source.network.zone.required":
    "¡Por favor seleccione una zona de red de origen!",
  "policy.form.connection.source.network.interface": "Interfaz de red",
  "policy.form.connection.source.network.interface.required":
    "¡Por favor, seleccione una interfaz de red de origen!",
  "policy.form.connection.source.ip.address": "Dirección IP",
  "policy.form.connection.source.ip.address.required":
    "¡Por favor, seleccione algún dirección IP de origen!",
  "policy.form.connection.source.mac.address": "MAC Address",
  "policy.form.connection.source.mac.address.required":
    "¡Por favor, seleccione un dirección MAC de origen!",
  "policy.form.connection.destination": "Destino",
  "policy.form.connection.destination.ip.address": "Dirección IP",
  "policy.form.connection.destination.ip.address.required":
    "¡Por favor, seleccione un dirección IP de destino!",
  "policy.form.connection.destination.service": "Servicio",
  "policy.form.connection.destination.service.required":
    "¡Por favor, seleccione algún servicio de destino!",
  "policy.form.connection.identification": "Identificación",
  "policy.form.connection.authenticated": "Autentificado",
  "policy.form.connection.users": "Usuarios",
  "policy.form.connection.users.required":
    "¡Por favor, seleccione algún Usuario!",
  "policy.form.connection.groups": "Grupos",
  "policy.form.connection.groups.required": "¡Por favor, seleccione un grupo!",

  "policy.form.inspection": "Inspección",
  "policy.form.content.web.proxy": "Proxy Web",
  "policy.form.content.ftp": "FTP",
  "policy.form.content.https": "HTTPS",
  "policy.form.content.validate.ssl.certificate": "Validar un certificado SSL",
  "policy.form.content.http": "HTTP",
  "policy.form.content.ssl.inspection": "Inspección SSL",
  "policy.form.content.explicit.proxy": "Proxy Explícito",
  "policy.form.content.ssl.common.name": "Nombre común de lo SSL",
  "policy.form.content.ssl.common.name.required":
    "¡Por favor, seleccione algún nombre común ssl!",
  "policy.form.content.malware.scanning": "Verificação de Malware",
  "policy.form.content.malware.scanning.required":
    "¡Por favor, seleccione algúna verificación de malware!",
  "policy.form.content.web.filter": "Web Filter",
  "policy.form.content.web.categories": "Categorías Web",
  "policy.form.content.web.categories.required":
    "¡Por favor, seleccione la categoría!",
  "policy.form.content.applications": "Aplicaciones",
  "policy.form.content.applications.required":
    "¡Por favor, seleccione algúna aplicación!",
  "policy.form.content.url.filter": "Filtro de URL",
  "policy.form.content.url.filter.required": "¡Por favor, seleccione una URL!",
  "policy.form.content.browsers": "Navegadores",
  "policy.form.content.browsers.required":
    "¡Por favor, seleccione algún navegador!",
  "policy.form.content.http.method": "Método HTTP",
  "policy.form.content.http.method.required":
    "¡Por favor, seleccione algún método HTTP!",
  "policy.form.content.smtp": "SMTP",
  "policy.form.content.pop3": "POP3",

  "policy.form.content.inspection.ssl": "Seleccione un perfil para inspección SSL.",
  "policy.form.content.inspection.intrusion.prevention": "Seleccione un perfil para Prevención de Intrusiones.",
  "policy.form.content.inspection.threat.protection": "Seleccione un perfil para Protección contra Amenazas.",
  "policy.form.content.inspection.application.control": "Seleccione un perfil para Control de Aplicaciones.",
  "policy.form.content.inspection.web.filter": "Seleccione un perfil para el Filtro Web.",

  "policy.form.control.surfing.control": "Surfing Control",
  "policy.form.control.content.type.filter": "Filtro de tipo de contenido",
  "policy.form.control.content.type.filter.required":
    "Por favor seleccione un tipo de contenido",
  "policy.form.control.http.filter.header": "Encabezado del filtro HTTP",
  "policy.form.control.http.filter.header.required": "¡Valor no válido!",
  "policy.form.control.maximum.time": "Tiempo máximo",
  "policy.form.control.maximum.time.required": "¡Valor no válido!",
  "policy.form.control.maximum.time.select.one": "¡Seleccione un!",
  "policy.form.control.maximum.time.opt.min": "Minutos por día",
  "policy.form.control.maximum.time.opt.hour": "Horas por día",
  "policy.form.control.maximum.traffic": "Tráfico máximo",
  "policy.form.control.maximum.traffic.required": "¡Valor no válido!",
  "policy.form.control.maximum.traffic.select.one": "¡Seleccione un!",
  "policy.form.control.maximum.traffic.opt.day": "MB por día",
  "policy.form.control.maximum.download.size": "Tamaño máximo de descarga",
  "policy.form.control.maximum.download.size.required": "¡Valor no válido!",
  "policy.form.control.maximum.download.size.select.one": "¡Seleccione un!",
  "policy.form.control.maximum.upload.size": "Tamaño máxima para cargar",
  "policy.form.control.maximum.upload.size.required": "¡Valor no válido!",
  "policy.form.control.maximum.upload.size.select.one": "¡Seleccione un!",

  "policy.form.security.deep.inspection": "Deep Inspection",
  "policy.form.security.sensor": "Sensor",
  "policy.form.security.device.template": "Plantilla de dispositivo",
  "policy.form.security.device.template.select.one": "¡Seleccione un!",
  "policy.form.security.profile.dpi": "Perfil de DPI",
  "policy.form.security.profile.dpi.select.one": "¡Seleccione un!",
  "policy.form.security.threat.blocking": "Bloqueo de amenazas",
  "policy.form.security.compromised.addresses": "Dirección comprometidos",
  "policy.form.security.compromised.addresses.required":
    "¡Por favor, seleccione un dirección comprometido!",
  "policy.form.security.geolocation": "Geolocalización",
  "policy.form.security.geolocation.select.one": "¡Seleccione un!",
  "policy.form.security.packet.filter": "Filtrado de paquetes",
  "policy.form.security.ttl": "TTL",
  "policy.form.security.ttl.select.one": "¡Seleccione un!",
  "policy.form.security.ttl.required": "¡Valor no válido!",
  "policy.form.security.package.type": "Tipo de Paquete",
  "policy.form.security.package.type.select.one": "¡Seleccione un!",
  "policy.form.security.packet.content": "Contenido del Paquete",
  "policy.form.security.packet.content.select.one": "¡Seleccione un!",
  "policy.form.security.tcp.mss": "TCP MSS",
  "policy.form.security.tcp.mss.required": "¡Valor no válido!",

  "policy.form.routing": "Enrutamiento",
  "policy.form.routing.gateway": "Gateway",
  "policy.form.routing.nat": "NAT",
  "policy.form.routing.cgnat": "CGNAT",
  "policy.form.routing.cgnat.empty": "Este é requerido",
  "policy.form.routing.cgnat.enable": "Activar CGNAT",
  "policy.form.routing.snat.default": "Gateway Default (Máscarado)",
  "policy.form.routing.sdwan": "SD-WAN",
  "policy.form.routing.device.template": "Plantilla de dispositivo",
  "policy.form.routing.device.template.select.one": "¡Seleccione un!",
  "policy.form.routing.profile.sdwan": "Perfil de SD-WAN",
  "policy.form.routing.profiles.sdwan": "Perfil(es) de SD-WAN",
  "policy.form.routing.profile.sdwan.select.one": "¡Seleccione un!",
  "policy.form.routing.qos": "QoS",
  "policy.form.routing.options": "QoS e Traffic Shaping",
  "policy.form.routing.traffic.shaping": "Control de ancho de banda",
  "policy.form.routing.traffic.shaping.select.one": "¡Seleccione un!",
  "policy.form.routing.flag.packets.tos": "Marque paquete (TOS)",
  "policy.form.routing.flag.packets.tos.select.one": "¡Seleccione un!",
  "policy.form.routing.flag.packets.dscp": "Marque paquete (DSCP)",
  "policy.form.routing.flag.packets.dscp.select.one": "¡Seleccione un!",
  "policy.form.routing.approuting": "Enrutamiento de aplicaciones",
  "policy.form.routing.webapp": "Aplicaciones",

  "policy.form.advanced": "Avanzado",
  "policy.form.advanced.dosProtection": "Protección DoS",
  "policy.form.advanced.packetRate": "Tasa de Paquete (paquete/segundos)",
  "policy.form.advanced.burstRate": "Tasa de Explosión",
  "policy.form.advanced.options": "Opciones",
  "policy.form.advanced.tcpmss": "TCP MSS",
  "policy.form.advanced.save": "Guardar",

  "highAvailability.warning":
    "Dispositivo secundario activo, cualquier cambio en la interfaz puede comprometer la vuelta de el servidor primario",

  "objects.mapping.modal.title": "Mapeamiento de objeto",
  "objects.mapping.modal.usedin": "Utilizado",
  "objects.mapping.modal.name": "Nombre",
  "objects.mapping.modal.interface": "Interfaz",
  "objects.title": "Objetos",
  "objects.tabs.address": "Dirección",
  "objects.tabs.service": "Servicios",
  "objects.tabs.time": "Horario",
  "objects.tabs.schedule": "Programaciones",
  "objects.tabs.dicionarie": "Diccionarios",
  "objects.tabs.content": "Contenido",

  "objects.actions.create": "Crear objeto",
  "objects.actions.group.create": "Crear Grupo",
  "objects.actions.delete": "Eliminar Objeto",
  "objects.modal.title": " Objeto de {object}",
  "objects.modal.group.title": " Grupo de Objeto de {object}",
  "objects.modal.group.title.address": "Grupo de Objetos de Dirección",

  "objects.addressGroup.modal.object": "Objetos",
  "objects.addressGroup.modal.title": "Crear grupo de objetos de dirección",
  "objects.addressGroup.modal.select.type": "Seleccionar un tipo",
  "objects.actions.create.success": "¡Objeto creado con éxito!",
  "objects.actions.create.error": "¡El objeto no ha sido guardado!",
  "objects.actions.create.error.dns": "¡Dirección Host no resuelto!",
  "objects.actions.delete.success": "¡Objeto eliminado con éxito!",
  "objects.actions.delete.error": "¡Error al eliminar objeto!",
  "objects.actions.delete.error.total":
    "{number} elemento(s) no se eliminaron. Objeto en uso.",

  "objects.address.datagrid.name": "Nombre",
  "objects.address.datagrid.description": "Descripción",
  "objects.address.datagrid.type": "Tipo",
  "objects.address.datagrid.used": "Usado",
  "objects.address.datagrid.actions": "Acciones",
  "objects.address.actions.create": "Crear Objeto",
  "objects.address.actions.delete": "Eliminar Objeto",
  "objects.address.actions.delete.success": "¡Objeto eliminado con éxito!",
  "objects.address.modal.title": "Objeto de dirección",
  "objects.address.modal.form.name": "Nombre",
  "objects.address.modal.form.item": "Dirección",
  "objects.address.modal.form.list": "Lista",
  "objects.address.modal.form.type": "Tipo",
  "objects.address.modal.form.description": "Descripción",
  "objects.address.modal.form.ip": "Dirección IPv4",
  "objects.address.modal.form.ipv6": "Dirección IPv6",
  "objects.address.modal.form.mac": "Dirección MAC",
  "objects.address.modal.form.fqdn": "Dirección FQDN",
  "objects.address.modal.form.unique.ip": "Único",
  "objects.address.modal.form.mask": "Máscara",
  "objects.address.modal.form.prefix": "Prefijo",
  "objects.address.modal.form.invalid": "Campos no válidos",
  "objects.address.modal.form.error.name": "Campo Nombre es obligatorio",
  "objects.address.modal.form.error.type":
    "Campo Tipo de Dirección es obligatorio",
  "objects.address.modal.form.error.list":
    "Campo Lista de Dirección es obligatorio",
  "objects.address.modal.form.error.description":
    "Campo Descripción es obligatorio",
  "objects.address.modal.form.name.exists":
    "Un dirección con este nombre ya existe",
  "objects.address.modal.form.error.unique":
    "Un objeto que es solo un dirección IP no puede contener más de un IP/red",
  "objects.address.modal.save.success": "Configuraciones cambiadas con éxito!",
  "objects.address.modal.import.success":
    "{number} elemento(s) importado(s) con éxito",
  "objects.address.modal.import.error":
    "{number} elemento(s) no fue(fueron) importado(s) con éxito",
  "objects.address.modal.import.warning":
    "El archivo de importación debe contener un elemento por línea",
  "objects.address.modal.error.file.bigger":
    "El archivo debe ser inferior a 2 MB",
  "objects.address.modal.error.file.txt": "Solo se puede cargar archivos TXT",
  "objects.address.modal.save.error":
    "¡Las Configuraciones no fueron guardadas!",
  "objects.address.delete.title": "Confirmar eliminación",
  "objects.address.delete.confirm":
    "¿Seguro que desea eliminar o objeto de dirección?",
  "objects.address.delete.confirmMult":
    "¿Seguro que desea eliminar el siguiente objetos de dirección?",

  "objects.services.datagrid.name": "Nombre",
  "objects.services.datagrid.description": "Descripción",
  "objects.services.datagrid.type": "Tipo",
  "objects.services.datagrid.used": "Usado",
  "objects.services.datagrid.actions": "Acciones",
  "objects.services.actions.create": "Crear Objeto",
  "objects.services.actions.delete": "Eliminar Objeto",
  "objects.services.modal.title": "Crear objeto de Servicio",
  "objects.services.modal.form.name": "Nombre",
  "objects.services.modal.form.type": "Tipo de protocolo",
  "objects.services.modal.form.item": "Tipos",
  "objects.services.modal.form.list": "Lista",
  "objects.services.modal.form.description": "Descripción",
  "objects.services.modal.form.tcp": "TCP",
  "objects.services.modal.form.udp": "UDP",
  "objects.services.modal.form.ip": "IP",
  "objects.services.modal.form.icmp": "ICMP V4",
  "objects.services.modal.form.icmpv6": "ICMP V6",
  "objects.services.modal.form.portType": "Tipo de Puerto",
  "objects.services.modal.form.port": "Puerto",
  "objects.services.modal.form.protocol": "Protocolo",
  "objects.services.modal.form.types": "Tipos",
  "objects.services.modal.form.source.port": "Puerto de origen",
  "objects.services.modal.form.destination.port": "Puerto de destino",
  "objects.services.modal.form.initial.port": "Puerto inicial",
  "objects.services.modal.form.end.port": "Puerto final",
  "objects.services.modal.form.save.success": "Objeto guardado con éxito",
  "objects.services.modal.form.save.error": "El Objeto no ha sido guardado",
  "objects.services.modal.form.invalid": "Campos no válidos",
  "objects.services.modal.form.name.exists":
    "Un objeto con este nombre ya existe",

  "objects.services.modal.form.error.name": "O campo Nombre es obligatorio",
  "objects.services.modal.form.error.type":
    "O campo tipo de protocolo es obligatorio",
  "objects.services.modal.form.error.list":
    "O campo Lista de Protocolos es obligatorio",
  "objects.services.modal.form.error.description":
    "O campo Descripción es obligatorio",
  "objects.services.delete.title": "Confirmar eliminación",
  "objects.services.delete.confirm":
    "¿Seguro que desea eliminar o objeto de servicio?",
  "objects.services.delete.confirmMult":
    "¿Seguro que desea eliminar os siguientes objetos de servicio?",

  "objects.times.datagrid.name": "Nombre",
  "objects.times.datagrid.description": "Descripción",
  "objects.times.datagrid.type": "Tipo",
  "objects.times.datagrid.used": "Usado",
  "objects.times.datagrid.actions": "Acciones",
  "objects.times.actions.create": "Crear Objeto",
  "objects.times.actions.delete": "Eliminar Objeto",
  "objects.times.modal.title": "Crear objeto de tiempo",
  "objects.times.modal.form.name": "Nombre",
  "objects.times.modal.form.type": "Día de la semana",
  "objects.times.modal.form.item": "Hora de comienzo / término",
  "objects.times.modal.form.start.time": "Hora de comienzo",
  "objects.times.modal.form.start.datetime": "Fecha y hora de comienzo",
  "objects.times.modal.form.end.time": "Fim del tempo",
  "objects.times.modal.form.end.datetime": "Fecha y hora de término",
  "objects.times.modal.form.list": "Lista",
  "objects.times.modal.form.description": "Descripción",
  "objects.times.modal.form.tcp": "TCP",
  "objects.times.modal.form.udp": "UDP",
  "objects.times.modal.form.ip": "IP",
  "objects.times.modal.form.icmp": "ICMP V4",
  "objects.times.modal.form.icmpv6": "ICMP V6",
  "objects.times.modal.form.sunday": "Domingo",
  "objects.times.modal.form.monday": "Lunes",
  "objects.times.modal.form.tuesday": "Martes",
  "objects.times.modal.form.wednesday": "Miércoles",
  "objects.times.modal.form.thursday": "Jueves",
  "objects.times.modal.form.friday": "Viernes",
  "objects.times.modal.form.saturday": "Sábado",
  "objects.times.modal.form.invalid": "Campos no válidos",
  "objects.times.modal.form.name.exists": "Un objeto con este nombre ya existe",
  "objects.times.modal.form.error.name": "El campo Nombre es obligatorio",
  "objects.times.modal.form.error.type":
    "El campo Tipo de Protocolo es obligatorio",
  "objects.times.modal.form.error.list":
    "El campo Lista de Protocolos es obligatorio",
  "objects.times.modal.form.error.description":
    "El campo Descripción es obligatorio",
  "objects.times.modal.form.error.equal.period":
    "El período final debe ser más grande que el período inicial",
  "objects.times.delete.title": "¿Confirmar eliminación?",
  "objects.times.delete.confirm":
    "¿Seguro que desea eliminar el objeto de tiempo?",
  "objects.times.delete.confirmMult":
    "¿Seguro que desea eliminar los siguientes objetos de tiempo?",

  "objects.schedules.datagrid.name": "Nombre",
  "objects.schedules.datagrid.description": "Descripción",
  "objects.schedules.datagrid.type": "Tipo",
  "objects.schedules.datagrid.used": "Usado",
  "objects.schedules.datagrid.actions": "Acciones",
  "objects.schedules.actions.create": "Crear Objeto",
  "objects.schedules.actions.delete": "Eliminar Objeto",
  "objects.schedules.modal.title": "Crear objeto programación",
  "objects.schedules.modal.form.name": "Nombre",
  "objects.schedules.modal.form.item": "Fecha de inicio / término",
  "objects.schedules.modal.form.list": "Lista",
  "objects.schedules.modal.form.description": "Descripción",
  "objects.schedules.modal.form.error.name": "Campo Nombre es obligatorio",
  "objects.schedules.modal.form.error.list":
    "El campo Lista de Protocolos es obligatorio",
  "objects.schedules.modal.form.error.description":
    "El campo Descripción es obligatorio",
  "objects.schedules.delete.title": "¿Confirmar eliminación?",
  "objects.schedules.delete.confirm":
    "¿Seguro que desea eliminar el objeto de programación?",
  "objects.schedules.delete.confirmMult":
    "¿Seguro que desea eliminar los siguientes objetos de programación?",

  "objects.dictionaries.datagrid.name": "Nombre",
  "objects.dictionaries.datagrid.description": "Descripción",
  "objects.dictionaries.datagrid.type": "Tipo",
  "objects.dictionaries.datagrid.used": "Usado",
  "objects.dictionaries.datagrid.actions": "Acciones",
  "objects.dictionaries.actions.create": "Crear Objeto",
  "objects.dictionaries.actions.delete": "Eliminar Objeto",
  "objects.dictionaries.modal.title": "Crear objetos de diccionario",
  "objects.dictionaries.modal.form.name": "Nombre",
  "objects.dictionaries.modal.form.type": "Tipo de Protocolo",
  "objects.dictionaries.modal.form.list": "Lista",
  "objects.dictionaries.modal.form.expressions": "Expresiones",
  "objects.dictionaries.modal.form.word": "Palabra",
  "objects.dictionaries.modal.form.description": "Descripción",
  "objects.dictionaries.modal.form.tcp": "TCP",
  "objects.dictionaries.modal.form.udp": "UDP",
  "objects.dictionaries.modal.form.ip": "IP",
  "objects.dictionaries.modal.form.icmp": "ICMP V4",
  "objects.dictionaries.modal.form.icmpv6": "ICMP V6",
  "objects.dictionaries.modal.form.invalid": "Campos no válidos",
  "objects.dictionaries.modal.form.error.name":
    "El campo Nombre es obligatorio",
  "objects.dictionaries.modal.form.error.type":
    "El campo Tipo de Protocolo es obligatorio",
  "objects.dictionaries.modal.form.error.list":
    "El campo Lista de Protocolo es obligatorio",
  "objects.dictionaries.modal.form.error.description":
    "El campo Descripción es obligatorio",
  "objects.dictionaries.modal.form.name.exists":
    "Un diccionario con este nombre ya existe",
  "objects.dictionaries.delete.title": "¿Confirmar eliminación?",
  "objects.dictionaries.delete.confirm":
    "¿Seguro que desea eliminar el objeto de lo tipo diccionario",
  "objects.dictionaries.delete.confirmMult":
    "¿Seguro que desea eliminar los siguientes objetos de lo tipo diccionario?",
  "objects.dictionaries.modal.import.success":
    "{number} elemento(s) importados con éxito",
  "objects.dictionaries.modal.import.warning":
    "El archivo de importación debe contener un elemento por línea",
  "objects.dictionaries.modal.import.error":
    "{number} elemento(s) no fueron importados con éxito",
  "objects.dictionaries.modal.error.file.bigger":
    "El archivo debe tener menos de 2 MB",
  "objects.dictionaries.modal.error.file.txt":
    "Solo se puede cargar archivos TXT",

  "objects.contents.datagrid.name": "Nombre",
  "objects.contents.datagrid.description": "Descripción",
  "objects.contents.datagrid.type": "Tipo",
  "objects.contents.datagrid.used": "Usado",
  "objects.contents.datagrid.actions": "Acciones",
  "objects.contents.actions.create": "Crear Objeto",
  "objects.contents.actions.delete": "Eliminar Objeto",
  "objects.contents.modal.title": "Crear objeto de programación",
  "objects.contents.modal.form.name": "Nombre",
  "objects.contents.modal.form.type": "Tipo de protocolo",
  "objects.contents.modal.form.list": "Lista",
  "objects.contents.modal.form.listMime": "Lista de Mime-Types",
  "objects.contents.modal.form.listExt": "Lista de Extensiones",
  "objects.contents.modal.form.description": "Descripción",
  "objects.contents.modal.form.tcp": "TCP",
  "objects.contents.modal.form.udp": "UDP",
  "objects.contents.modal.form.ip": "IP",
  "objects.contents.modal.form.icmp": "ICMP V4",
  "objects.contents.modal.form.icmpv6": "ICMP V6",
  "objects.contents.modal.form.error.name": "Campo Nombre es obligatorio",
  "objects.contents.modal.form.error.type":
    "El campo Tipo de Protocolo es obligatorio",
  "objects.contents.modal.form.error.list":
    "El campo Lista de Protocolos es obligatorio",
  "objects.contents.modal.form.error.description":
    "El campo Descripción es obligatorio",
  "objects.contents.modal.form.name.exists":
    "Un objeto con este Nombre ya existe",
  "objects.contents.modal.form.invalid": "Campos no válidos",
  "objects.contents.delete.title": "¿Confirmar eliminación?",
  "objects.contents.delete.confirm":
    "¿Seguro que desea eliminar el contenido del objeto?",
  "objects.contents.delete.confirmMult":
    "¿Seguro que desea eliminar el contenido de los seguientes objetos?",

  "deploys.title": "Deploys",
  "deploys.task.information": "Informaciones de la tarea",
  "deploys.task.view": "Visualizar tarea",
  "deploys.filter.status.success": "Éxito",
  "deploys.filter.status.accept": "Aceptar",
  "deploys.filter.status.running": "En ejecución",
  "deploys.filter.status.pending": "Pendiente",
  "deploys.filter.status.error": "Error",
  "deploys.filter.status.cancelled": "Cancelada",
  "deploys.filter.taskType.policyPack": "Paquetes de política",
  "deploys.filter.taskType.deviceTemp": "Plantilla de dispositivo",
  "deploys.filter.taskType.deviceComm": "Comunidad de dispositivos",
  "deploys.datagrid.package": "Paquete",
  "deploys.datagrid.assignee": "Auditor",
  "deploys.datagrid.owner": "Propietario",
  "deploys.datagrid.scheduled": "Programado",
  "deploys.datagrid.device": "Paquete",
  "deploys.datagrid.progress": "Progreso",
  "deploys.datagrid.status": "Estatus",
  "deploys.datagrid.message": "Mensaje",
  "deploys.datagrid.profile.limit": "Límite de perfiles alcanzado",
  "deploys.datagrid.worker.limit": "Límite del proceso alcanzado",
  "deploys.datagrid.invalid.user": "Usuario(s) no válido(s)",
  "deploys.datagrid.invalid.group": "Grupos(s) no válido(s)",
  "deploys.datagrid.invalid.interface": "Interfaz(ces) no válida(s)",
  "deploys.datagrid.invalid.zone": "Zona(s) no válida(s)",
  "deploys.datagrid.invalid.package.empty":
    "Paquete de políticas no válido: vacío",
  "deploys.filter.scheduled": "Programado",
  "deploys.filter.owner": "Propietario",
  "deploys.filter.auditor": "Auditor",
  "deploys.filter.status": "Estatus",
  "deploys.filter.package": "Paquete",
  "deploys.delete.success": "Deploy eliminado con éxito",
  "deploys.create.success": "¡Deploy creado con éxito!",
  "deploys.create.error": "¡Deploy no puede ser creado!",
  "deploys.modal.monitor.title": "Monitor del dispositivo",
  "deploys.modal.activity.title": "Actividades de la tarea",
  "deploys.modal.justify.title": "Justificar acción",
  "deploys.modal.justify.comment": "Comentarios",
  "deploys.modal.error.comment": "Proceso de copia de seguridad activo.",

  // =========== ATP =========== //
  "profiles.atp.tab.application": "Aplicaciones",
  "profiles.atp.tab.malware.scanning": "Verificación de malware",
  "profiles.atp.tab.threat.blocking": "Bloqueo de amenazas",

  "profiles.atp.tab.quarantine.query.editor": "Editor de Consultas",
  "profiles.atp.tab.quarantine.query.save": "Guardar las Consultas",
  "profiles.atp.tab.quarantine.action.remove": "Eliminar elementos",
  "profiles.atp.tab.quarantine.tabpane.create": "Crear Consultas",
  "profiles.atp.tab.quarantine.tabpane.load": "Cargar las Consultas",
  "profiles.atp.tab.quarantine.tabpane.create.new": "Nueva Consultas",
  "profiles.atp.tab.quarantine.tabpane.create.edit": "Editar Consultas",
  "profiles.atp.tab.quarantine.tabpane.create.filter": "Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.value": "Valor",
  "profiles.atp.tab.quarantine.tabpane.create.filterString":
    "Cadena del Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.filterString.result":
    "Resultados de la Cadena del Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.name.exists":
    "Una consulta con este nombre ya existe",
  "profiles.atp.tab.quarantine.action.remove.text":
    "¿Seguro que desea eliminar?",
  "profiles.atp.tab.quarantine.action.remove.success":
    "La eliminación tuvo éxito",
  "profiles.atp.tab.quarantine.action.remove.error": "Error en la eliminación",

  "profiles.atp.tab.quarantine.action.download.success": "Descarga con éxito",
  "profiles.atp.tab.quarantine.action.download.error": "Error en la descarga",
  "profiles.atp.tab.quarantine.action.download.allow": "Descarga liberado",
  "profiles.atp.tab.quarantine.action.download.denied": "Descarga bloqueado",
  "profiles.atp.tab.quarantine.action.download.allow.tooltip":
    "Liberar a descargar",
  "profiles.atp.tab.quarantine.action.download.denied.tooltip":
    "Bloquear descargas",
  "profiles.atp.tab.quarantine.action.download.error.sizelimit": "No se puede descargar, se excedió el límite.",
  "profiles.atp.tab.quarantine.action.download.error.dontanalyze": "No se puede descargar, el archivo no se analizó.",

  "profiles.atp.tab.quarantine.queries.action.remove.success":
    "La consulta fue eliminada con éxito!",
  "profiles.atp.tab.quarantine.queries.action.remove.error":
    "Error en la eliminación de la consulta!",
  "profiles.atp.tab.quarantine.queries.filter.user": "Usuario",
  "profiles.atp.tab.quarantine.queries.filter.src": "Origen",
  "profiles.atp.tab.quarantine.queries.filter.spt": "Puerto de origen",
  "profiles.atp.tab.quarantine.queries.filter.dst": "Destino",
  "profiles.atp.tab.quarantine.queries.filter.dpt": "Puerto de destino",
  "profiles.atp.tab.quarantine.queries.filter.file": "Archivo",
  "profiles.atp.tab.quarantine.queries.filter.url": "Url",
  "profiles.atp.tab.quarantine.queries.filter.mime": "Mime-type",

  "profiles.atp.tab.quarantine.queries.filter.status": "Estatus",
  "profiles.atp.tab.quarantine.queries.filter.date": "Fecha",
  "profiles.atp.tab.quarantine.queries.filter.analyze": "Verificación",
  "profiles.atp.tab.quarantine.queries.filter.dontanalyze": "No analizado",
  "profiles.atp.tab.quarantine.queries.filter.infected": "Infectado",
  "profiles.atp.tab.quarantine.queries.filter.clean": "Limpio",
  "profiles.atp.tab.quarantine.queries.filter.download": "Descarga",
  "profiles.atp.tab.quarantine.queries.filter.sizelimit": "Limite de tamaño",
  "profiles.atp.tab.quarantine.queries.filter.notfound": "No localizado",
  "profiles.atp.tab.quarantine.tabpane.create.name":
    "Personalizar nombre de la nueva consulta",
  "profiles.atp.tab.quarantine.tabpane.create.select.field":
    "Seleccione un campo",

  "atp.custom.error.in.using": "No se pudo eliminar la firma. ¡La firma personalizada está en uso!",

  "atp.custom.signature.input.regex": "Ingrese su expresión regular",

  // =========== Dashboard ======== //

  "monitor.system-status": "Estado del sistema",
  "monitor.system-status.information": "Informaciones del Sistema",
  "monitor.system-status.resources": "Recursos del Sistema",
  "monitor.system-status.services": "Servicios del Sistema",
  "monitor.system-status.license": "Informaciones da licencia",
  "monitor.system-status.subscriptions": "Suscripciones",
  "monitor.system-status.subscriptions.last.modify": "Última Modificación",
  "monitor.system-status.last.update": "Última Actualización",
  "monitor.system-status.last.backup": "Última Copia de Seguridad",
  "monitor.system-status.high.availability": "Alta Disponibilidad",

  "monitor.system-status.service.running": "Servicio en ejecución",
  "monitor.system-status.service.stopped": "Servicio interrumpido",
  "monitor.system-status.service.disabled": "Servicio desactivado",
  "monitor.system-status.service.action.start": "Iniciando servicio",
  "monitor.system-status.service.action.stopped": "Interrumpiendo servicio",

  "monitor.dashboard.lastMinute": "Últimos 5 minutos",
  "monitor.dashboard.lastHour": "Última hora",
  "monitor.dashboard.networkTraffic": "Tráfico de red",
  "monitor.dashboard.liveUsers": "Usuarios activos",
  "monitor.dashboard.webActivity": "Actividad web",
  "monitor.dashboard.networkAttacks": "Ataques de red",
  "monitor.dashboard.malwareDetections": "Detecciones de malware",
  "monitor.dashboard.threatBlocking": "Bloqueo de Amenaza",
  "monitor.dashboard.conectionsMap": "Mapa de las Conexiones",
  "monitor.dashboard.trafficMonitor": "Monitor de Tráfico",
  "monitor.dashboard.topUsers": "Top Usuarios",
  "monitor.dashboard.topSources": "Top Origenes",
  "monitor.dashboard.topServices": "Top Servicios",
  "monitor.dashboard.topPolicies": "Top Políticas",
  "monitor.dashboard.topCategories": "Top Categorías",
  "monitor.dashboard.topApplications": "Top Aplicaciones",
  "monitor.dashboard.topAttacks": "Top Ataques",
  "monitor.dashboard.topThreats": "Top Amenaza",

  "monitor.trafficMonitor.interfaces.error":
    "Seleccione al menos 1 interfaz y hasta 4",
  "monitor.trafficMonitor.in": "IN",
  "monitor.trafficMonitor.out": "OUT",
  "monitor.trafficMonitor.sdwan.error": "Seleccione un perfil",
  "monitor.trafficMonitor.throughput": "Velocidad de transferencia",
  "monitor.trafficMonitor.bandwidth": "Ancho de banda",

  "monitor.diagnostics.packetCapture": "Captura de Paquetes",
  "monitor.diagnostics.categoryLookup": "Pesquisa por Categoria",
  "monitor.diagnostics.categoryLookup.notFound": "Dirección no clasificada",
  "monitor.diagnostics.packetCapture.error":
    "Introduzca una dirección, puerto o protocolo",
  "monitor.diagnostics.packetCapture.confirm.title":
    "¿Desea eliminar el archivo?",
  "monitor.diagnostics.packetCapture.cancel.title":
    "¿Desea cancelar la captura?",
  "monitor.diagnostics.packetCapture.ok": "Proseguir",
  "monitor.diagnostics.packetCapture.protocol": "Protocolo",
  "monitor.diagnostics.packetCapture.size": "Tamaño",
  "monitor.diagnostics.packetCapture.tooltip": "Configurar captura",
  "monitor.diagnostics.packetCapture.DraggableModal.title":
    "Configuración de captura",
  "monitor.diagnostics.packetCapture.form.minute": "Minuto",
  "monitor.diagnostics.packetCapture.form.outhers": "Otros",
  "monitor.diagnostics.packetCapture.maxSize": "Tamaño máximo del archivo",
  "monitor.diagnostics.packetCapture.bpf": "Filtro de Paquetes Berkeley (BPF)",

  "monitor.liveSession.confirm": "¿Desea eliminar la sesión del usuario?",
  "monitor.liveSession.vpn.network": "Dirección IP/Red",
  "monitor.liveSession.vpn.tunnel": "Site-to-Site",
  "monitor.liveSession.vpn.ras": "Acesso Remoto",
  "monitor.liveSession.vpn.confirm": "¿Desea interrumpir la conexión?",
  "monitor.liveSession.vpn.success": "Conexión interrumpida con éxito",
  "monitor.liveSession.vpn.error": "Error al interrumpir la conexión",
  "monitor.liveSession.vpn.error.disabled.server": "Error al guardar. Verifique si VPN NG está activo y vuelva a intentarlo.",
  "monitor.liveSession.vpn.connectionDate": "Fecha de la conexión",
  "monitor.liveSession.network.confirm": "¿Desea eliminar esta conexión?",
  "monitor.liveSession.network.success": "Conexión eliminada con éxito",
  "monitor.liveSession.network.error": "Error al eliminar la conexión",
  "monitor.liveSession.network.connections.info":
    "Total de conexiones establecidas",
  "monitor.liveSession.network.logsessions.disable":
    "El registros de sesiones han sido desactivados",
  "monitor.liveSession.waiting": "Aguarde mientras la conexión es establecida",
  // =========== IPS =========== //

  "profiles.tab.ips.smart": "IPS inteligente (Habilitar suscripciones automáticamente)",
  "profiles.tab.ips.smart.enable": "IPS inteligente",
  "profiles.intrusionprevention.settings.riskLow": "Riesgo bajo",
  "profiles.intrusionprevention.settings.riskMedium": "Riesgo medio",
  "profiles.intrusionprevention.settings.riskHigh": "Riesgo alto",
  "profiles.intrusionprevention.settings.info.devices": "Las interfaces listadas son aquellas que están habilitadas y sin configuración de IP y Máscara.",

  "profiles.tab.ips.whitelist": "Direcciones Permitidas",
  "profiles.tab.ips.blacklist": "Direcciones Bloqueadas",
  "profiles.tab.ips.quarantine": "Cuarentena",
  "profiles.tab.ips.whitelist.create": "Crear",
  "profiles.tab.ips.whitelist.delete": "Eliminar",
  "profiles.tab.ips.whitelist.address": "Dirección",

  "profiles.tab.ips.whitelist.customization": "Firmas Personalizadas",
  "profiles.tab.ips.action.add.customization":
    "Firmas Personalizadas insertado con éxito",
  "profiles.tab.ips.error.duplicated-sid":
    "Error de firmas personalizadas, SID duplicado",
  "profiles.tab.ips.action.remove.sucess.customization":
    "Firmas Personalizadas eliminado con éxito",

  "profiles.tab.ips.blacklist.create": "Crear",
  "profiles.tab.ips.blacklist.delete": "Eliminar",
  "profiles.tab.ips.blacklist.address": "Dirección",
  "profiles.tab.ips.action.add.sucess": "Dirección añadido con éxito",
  "profiles.tab.ips.error.loading": "Error al cargar la página",
  "profiles.tab.ips.action.remove.sucess": "Dirección eliminado con éxito",
  "devices.template.provisioning.download.return": "Volver",
  "profiles.tab.ips.action.remove.text": "¿Seguro que desea eliminar?",
  "profiles.tab.ips.quarantine.action.whitelist":
    "Mover a la Direcciones Permitidas",
  "profiles.tab.ips.quarantine.action.blacklist":
    "Mover a la Direcciones Bloqueadas",
  "profiles.tab.ips.quarantine.action.move.success":
    "Dirección movido con éxito",
  "profiles.tab.ips.quarantine.action.move.error":
    "Error al mover el Dirección",
  "profiles.tab.ips.quarantine.action.remove": "Eliminar",
  "profiles.tab.ips.quarantine.action.move.title.whitelist":
    "Direcciones Permitidas",
  "profiles.tab.ips.quarantine.action.move.title.blacklist":
    "Direcciones Bloqueadas",
  "profiles.tab.ips.quarantine.action.timeout": "Timeout",
  "profiles.tab.ips.quarantine.action.move.text.whitelist":
    "¿Realmente desea cambiar estos direcciones IPs para la Direcciones Permitidas?",
  "profiles.tab.ips.quarantine.action.move.text.blacklist":
    "¿Realmente desea mover estos direcciones IPs para la Direcciones Bloqueadas?",
  "profiles.tab.ips.modal.form.error.time": "Campo Tiempo es obligatorio",
  "profiles.tab.ips.modal.form.timeout.hour": "Hora",
  "profiles.tab.ips.modal.form.timeout.min": "Minutos",
  "profiles.tab.ips.modal.error.file.bigger":
    "El archivo debe tener menos de 2 MB",
  "profiles.tab.ips.modal.error.file.txt": "Solo puede cargar archivos TXT",
  "profiles.tab.ips.modal.import.success":
    "{number} elemento(s) importado(s) con éxito",
  "profiles.tab.ips.modal.form.ip": "Dirección IPv4",
  "profiles.tab.ips.modal.form.ipv6": "Dirección IPv6",
  "profiles.tab.ips.modal.form.item": "Dirección",
  "profiles.tab.ips.modal.form.mask": "Máscara",
  "profiles.tab.ips.modal.form.prefix": "Prefijo",

  "profiles.tab.ips.modal.form.column-rule": "Regla",
  "profiles.tab.ips.modal.form.column-reason": "Razón",

  "profiles.tab.proxy.settings.invalid": "",

  "quarantine.actions.delete.success":
    "Dirección IP en la cuarentena eliminado con éxito!",
  "quarantine.actions.delete.error.total":
    "{number} elemento(s) no se eliminaron. Dirección IP en uso.",
  "quarantine.delete.title": "Confirmar eliminación",
  "quarantine.delete.confirm":
    "¿Seguro que desea eliminar de la cuarentena el dirección IP?",
  "quarantine.delete.confirmMult":
    "¿Seguro que desea eliminar el siguiente dirección IP de la cuarentena?",

  // =========== Webfilter =========== //

  "profiles.tab.webfilter.settings": "Configuraciones",

  "profiles.webFilter.modal.form.error.name": "Campo Nombre es obligatorio",
  "profiles.webFilter.modal.form.error.name.exists":
    "Un perfil con ese nombre ya existe",
  "profiles.webFilter.modal.form.error.type":
    "El campo Tipo de Dirección es obligatorio",
  "profiles.webFilter.modal.form.error.list":
    "El campo Lista de Dirección es obligatorio",
  "profiles.webFilter.modal.form.error.description":
    "El campo Descripción es obligatorio",
  "profiles.webFilter.surfingQuotas": "Surfing Quotas",
  "profiles.webFilter.error.filter": "Por favor seleccione al menos un filtro",
  "profiles.webFilter.error.category":
    "Por favor seleccione al menos una categoría",

  "profiles.title": "Perfiles",
  "profiles.title.webfilter": "Web Filter",
  "profiles.title.ips": "Intrusion Prevention",
  "profiles.title.atp": "Threat Protection",
  "profiles.title.sdwan": "SD-WAN",
  "profiles.title.ssl": "Proxy",
  "profiles.title.appControl": "Application Control",

  "profiles.tab": "Perfiles",
  "profiles.tab.webfilter": "Web Filter",
  "profiles.tab.ips": "Intrusion Prevention",
  "profiles.tab.sdwan": "SD-WAN",
  "profiles.tab.ssl": "Inspeção SSL",
  "profiles.tab.appControl": "Application Control",

  "profiles.tab.atp.settings": "Configuraciones",
  "profiles.tab.atp.quarantine": "Cuarentena",
  "profiles.tab.atp.sandbox": "Sandbox",
  "profiles.tab.atp.quarantine.threat": "Cuarentena de amenazas",
  "profiles.tab.ssl.inspection": "Inspeção SSL",
  "profiles.tab.ssl.services": "Servicios de el Proxy",
  "profiles.tab.sdwan.settings": "Configuraciones",
  "profiles.tab.appControl.settings": "Configuraciones",

  "profiles.tab.ssl.inspection.limit.reached":
    "¡Se ha alcanzado el límite de perfiles!",
  "profiles.tab.ssl.workers.limit.reached":
    "¡Se ha alcanzado el límite de workers!",

  "profiles.webFilter.addCategory": "Categorías personalizadas",
  "profiles.webFilter.MaxUpSize": "Tamaño máximo de carga",
  "profiles.webFilter.MaxDownSize": "Tamaño máximo de descarga",
  "profiles.webFilter.MBPerDay": "MB por día",
  "profiles.webFilter.MaxTrafic": "Trafico Máximo",
  "profiles.webFilter.HoursPerDay": "Horas por día",
  "profiles.webFilter.MinPerDay": "Minutos por día",
  "profiles.webFilter.webCategories": "Categorías Web",
  "profiles.webFilter.modalTree.permitions.Allow": "Permitir",
  "profiles.webFilter.modalTree.permitions.Deny": "Denegar",
  "profiles.webFilter.modalTree.permitions.Warning": "Atención",
  "profiles.webFilter.FileFilter": "Filtros para Archivos",
  "profiles.webFilter.BlockFilter": "Bloqueio de Archivos",
  "profiles.webFilter.MaxTime": "Tempo Máximo",
  "profiles.webFilter.datagrid.profile": "Perfil",
  "profiles.webFilter.datagrid.actions": "Acciones",
  "profiles.webFilter.actions.create": "Crear Perfil",
  "profiles.webFilter.actions.delete": "Eliminar Perfil",
  "profiles.webFilter.actions.clone": "Clonar Perfil",
  "profiles.webfilter.action.remove.text": "¿Seguro que desea eliminar?",

  "profiles.webFilter.modal.category": "Categoría",
  "profiles.webFilter.modal.title": " Perfil",
  "profiles.webFilter.modal.name": "Nombre",
  "profiles.webFilter.modal.devices": "Dispositivo",
  "profiles.webFilter.modal.devicesGroups": "Grupos de Dispositivos",

  "profiles.webFilter.datagrid.name": "Nombre",
  "profiles.webFilter.datagrid.description": "Descripción",
  "profiles.webFilter.datagrid.safeSearch": "Safe search",
  "profiles.webFilter.datagrid.safeSearch-detail":
    "Forzar el Safe Search para Google, Bing, Yahoo",
  "profiles.webFilter.datagrid.googleApps": "Google apps",
  "profiles.webFilter.datagrid.googleApps-detail":
    "Restringir dominios de acceso para el Google Apps",

  "profiles.webFilter.datagrid.used": "Usado",
  "profiles.webFilter.actions.delete.success": "Perfil eliminado con éxito!",
  "profiles.webFilter.actions.add.success": "Perfil añadido con éxito",
  "profiles.webFilter.actions.updated.success": "Perfil actualizado con éxito",
  "profiles.webfilter.actions.add.error": "¡El perfil no ha sido guardado!",

  "profiles.actions.clone.success": "Perfil(es) clonado(s) con éxito",
  "profiles.actions.clone.error": "El(los) perfil(es) no fue(ron) clonado(s)!",
  "profiles.actions.clone-partial.error":
    "Los perfiles fueron parcialmente clonados!",

  "profiles.webFilter.modal.form.name": "Nombre",
  "profiles.webFilter.modal.form.item": "Dirección",
  "profiles.webFilter.modal.form.list": "Relación",
  "profiles.webFilter.modal.form.type": "Tipo",
  "profiles.webFilter.modal.form.description": "Descripción",
  "profiles.webFilter.modal.form.version": "Versión",
  "profiles.webFilter.modal.form.ip": "Dirección IPv4",
  "profiles.webFilter.modal.form.ipv6": "Dirección IPv6",
  "profiles.webFilter.modal.form.mac": "Dirección MAC",
  "profiles.webFilter.modal.form.fqdn": "Dirección FQDN",
  "profiles.webFilter.modal.save.success":
    "Configuraciones cambiadas con éxito!",
  "profiles.webFilter.modal.save.error":
    "¡Las Configuraciones no han sido guardado!",
  "profiles.webFilter.delete.title": "Confirmar eliminación",
  "profiles.webFilter.delete.confirm":
    "¿Seguro que desea eliminar el objeto de dirección?",
  "profiles.webFilter.delete.confirmMult":
    "¿Seguro que desea eliminar los siguientes objetos de dirección?",

  "profiles.intrusionprevention.resetMotal.confirm":
    "¿Realmente desea restablecer el perfil para el estándar?",
  "profiles.intrusionprevention.profile.create": "Crear perfil",
  "profiles.intrusionprevention.profile.create.success": "Perfil creado",
  "profiles.intrusionprevention.profile.create.error": "Error al crear perfil",
  "profiles.intrusionprevention.profile.delete": "Eliminar Perfil",
  "profiles.intrusionprevention.profile.deleted.single":
    "Perfil eliminado con éxito",
  "profiles.intrusionprevention.profile.deleted":
    "Perfiles eliminados con éxito",
  "profiles.intrusionprevention.profile.deleted.inUse":
    "¡No fue posible eliminar el perfil! Perfil en uso",
  "profiles.intrusionprevention.profile.delete.confirm.general":
    "¿Seguro que desea eliminar:",
  "profiles.intrusionprevention.profile.delete.confirm":
    "¿Seguro que desea eliminar los perfiles:",
  "profiles.intrusionprevention.profile.delete.confirm.single":
    "¿Seguro que desea eliminar el perfil:",
  "profiles.intrusionprevention.profile.restore.error":
    "Error al restablecer el perfil",
  "profiles.intrusionprevention.profile.restore.success": "Perfil restaurado",
  "profiles.intrusionprevention.error.profile.exists":
    "Un perfil con ese nombre ya existe",
  "profiles.intrusionprevention.settings.device.same":
    "Los dispositivos no pueden ser los mismos",
  "profiles.intrusionprevention.settings.definitions": "Definiciones",
  "profiles.intrusionprevention.settings.clientRecommended":
    "Activar reglas recomendadas por el cliente",
  "profiles.intrusionprevention.settings.serverRecommended":
    "Activar reglas recomendadas por el servidor",
  "profiles.intrusionprevention.settings.inspect":
    "Inspeccione todas los puertos",
  "profiles.intrusionprevention.alert": "Estás activando más de 10 mil registros. Puede causar ralentizaciones y reducir el rendimiento.",
  "profiles.intrusionprevention.risk.low": "Bajo",
  "profiles.intrusionprevention.risk.medium": "Medio",
  "profiles.intrusionprevention.risk.high": "Alto",
  "profiles.intrusionprevention.signatures": "Suscripciones",
  "profiles.intrusionprevention.threats": "Amenaza",
  "profiles.intrusionprevention.apps": "Aplicaciones",
  "profiles.intrusionprevention.reason-invalid-rule-duplicated_rule":
    "Regla duplicada",
  "profiles.intrusionprevention.reason-invalid-rule-invalid_rule":
    "Regla Inválida",
  "profiles.intrusionprevention.reason-invalid-rule-not_match":
    "Regla Inválida",

  "profiles.tab.threatProtection": "Threat Protection",
  "profile.threatProtection.name": "Nombre",
  "profile.threatProtection.description": "Descripción",
  "profile.threatProtection.version": "Versión",
  "profile.threatProtection.actions.add.success": "Perfil añadido con éxito",
  "profile.threatProtection.actions.add.error": "El perfil no ha sido guardado",
  "profile.threatProtection.actions.delete.success":
    "Perfil eliminado con éxito",
  "profile.threatProtection.actions.delete.error.inUse":
    "¡No fue posible eliminar el perfil! Perfil en uso",
  "profiles.threatProtection.error.profile.exists":
    "Un perfil con ese nombre ya existe",
  "profiles.threatProtection.action.remove.text": "¿Seguro que desea eliminar?",
  "profile.threatProtection.malwareScanning": "Verificación de Malware",
  "profile.threatProtection.threatBlocking": "Bloqueo de amenazas",
  "profile.threatProtection.threatProtection": "Protección contra amenazas",
  "profile.threatProtection.threatProtectionProfile":
    "Perfil de protección contra amenazas",
  "profile.threatProtection.malwareScanning.required":
    "¡Por favor, seleccione algúno Malware Scanning.",
  "profile.threatProtection.threatBlocking.required":
    "¡Por favor, seleccione algúno Threat Blocking.",
  "profile.threatProtection.required.threatProtection":
    "¡Por favor, seleccione algúno Threat Protection.",

  "profile.appcontrol.createProfile": "Crear Perfil",
  "profile.appcontrol.deleteProfile": "Eliminar Perfil",
  "profile.appcontrol.actions.clone": "Clonar Perfil",
  "profile.appcontrol.save.errorProfile": "El perfil no ha sido guardado",
  "profile.appcontrol.delete.sucess": "Perfil eliminado con éxito",
  "profile.appcontrol.delete.error.inUse":
    "¡No fue posible eliminar el perfil! Perfil en uso",
  "profile.appcontrol.filter.invalid": "Filtros no válidos",
  "profile.appcontrol.applications.required":
    "¡Por favor, seleccione algúna aplicación!",
  "profile.appcontrol.item": "Item",
  "profile.appcontrol.form.applications": "Aplicaciones",
  "profile.appcontrol.form.error.name": "El campo nombre es obligatorio",
  "profile.appcontrol.form.error.workers": "El campo workers es obligatorio",
  "profile.appcontrol.action.remove.text": "¿Seguro que desea eliminar",
  "profile.appcontrol.form.profileid.undefined": "Necesario guardar el perfil antes de crear grupos de categorías",
  "profile.appcontrol.form.name.exists": "Un perfil con este nombre ya existe.",
  "profile.appcontrol.form.error.name.pattern": "Apenas se permiten letras, números, espacios, guiones y guiones bajos.",

  "profiles.proxy.action.remove.text": "¿Seguro que desea eliminar",
  "profiles.proxy.action.remove.profiles.text":
    "¿Seguro que desea eliminar los perfiles?",

  "profiles.sdwan.action.remove.text": "¿Seguro que desea eliminar",
  "profiles.sdwan.action.remove.profiles.text":
    "¿Seguro que desea eliminar los perfiles?",
  "profiles.sdwan.deleteProfile": "Eliminar Perfil",
  "profiles.sdwan.deleteService": "Eliminar Servicio",
  "profiles.ssl.blockCert": "Bloquear certificados no válidos",

  "loggers.title": "Loggers",
  "loggers.actions.create": "Crear Logger",
  "loggers.actions.create.loggerDevice": "Crear Dispositivo de Logger",
  "loggers.actions.edit.loggerDevice": "Editar Dispositivo de Logger",
  "loggers.actions.delete": "Eliminar Logger",
  "loggers.actions": "Acciones",
  "loggers.name": "Nombre",
  "loggers.mode": "Modo",
  "loggers.cpu.usage": "Utilización de CPU",
  "loggers.memory.usage": "Utilización de memoria",
  "loggers.disk.usage": "Utilización de disco",
  "loggers.storage.usage": "Utilización del Almacenamiento",
  "loggers.address": "Dirección",
  "loggers.secretkey": "Clave secreta",
  "loggers.description": "Descripción",
  "loggers.devices": "Dispositivo & Grupo de Dispositivo",
  "loggers.save.success": "Los Loggers se guardaron con éxito",
  "loggers.save.error": "Los Loggers no han sido salvados",
  "loggers.save.error.ha.enabled.logger.integrated":
    "No es posible crear un Logger Integrada porque la Alta Disponibilidad está activada ",
  "loggers.delete.success": "Los Loggers se han eliminado con éxito",
  "loggers.delete.error": "Error al eliminar los loggers",
  "loggers.backups.retention.backup": "Número de copia de seguridad retenidos",
  "loggers.backups.retention.percent": "% Retención de espacio en disco",
  "loggers.backups.delete.backups": "Eliminar Copia de Seguridad",
  "loggers.backups.restore.backups": "Restaurar Copia de Seguridad",
  "loggers.backups.restore.last.date": "Última Modificación",
  "loggers.storage.logRotation": "Rotação de Log",
  "loggers.storage.logRotation.enable": "Habilitar Rotação de Log",
  "loggers.storage.logRotation.retention.byDisk":
    "% Retención de Logs por Espacio en Disco",
  "loggers.storage.logRotation.retention.byPeriod":
    "Retención de Logs por Periodo",
  "loggers.storage.logRotation.maintenance.interval":
    "Intervalos de Mantenimiento",
  "loggers.clusters.cluster": "Cluster",
  "loggers.clusters.create.cluster": "Crear Cluster",
  "loggers.clusters.delete.cluster": "Eliminar Cluster",
  "loggers.clusters.active.primary": "Activar Logger Primário",
  "loggers.clusters.active.replica": "Activar Logger Réplica",
  "loggers.clusters.active.logger": "Ativar Logger",
  "loggers.clusters.sync.progress": "Progreso da sincronización",
  "loggers.clusters.sync.unavailable": "No disponible",
  "loggers.clusters.primary": "Logger Primário",
  "loggers.clusters.secondary": "Logger Réplica",
  "loggers.clusters.primary.active": "Primário Activo",
  "loggers.clusters.secondary.active": "Réplica Activa",
  "loggers.clusters.virtual.ip": "Dirección IP Virtual",
  "loggers.clusters.secret.key": "Clave secreta",
  "loggers.clusters.netmask": "Máscara de red",
  "loggers.clusters.heartbeat.interval": "Intervalo del Heartbeat (segundos)",
  "loggers.clusters.interface.info": "Interfaz utilizada en el logger-config",
  "loggers.clusters.email.info":
    "Necesita configuración de SMTP em Configuración > Red > Correo Electrónico",
  "loggers.clusters.ip.info": "Dirección IP utilizado no logger-config",
  "loggers.clusters.failover.threshold": "Limite de Failover",
  "loggers.clusters.auto.activation": "Activación automática da Réplica",
  "loggers.clusters.notifications.email": "Notificaciones por e-mail",
  "loggers.clusters.action.duplicate.error": "Campo duplicado",
  "loggers.clusters.action.already.exists": "Nombre del cluster ya existente",
  "loggers.clusters.action.primary.activated":
    "¿Estás seguro que quieres activar la logger primária? A logger réplica entrará en standby.",
  "loggers.clusters.action.replica.activated":
    "¿Estás seguro que quieres activar la logger réplica? A logger primária entrará en standby.",
  "loggers.clusters.action.activated.success":
    "Logger activado con éxito. Espere a que concluya la sincronización en pocos minutos.",
  "loggers.clusters.action.activated.error": "Error al activar logger",
  "loggers.clusters.action.save.success": "Cluster guardado con éxito",
  "loggers.clusters.action.delete.success": "Cluster(s) eliminado(s) con éxito",
  "loggers.clusters.action.delete.error": "Error al eliminar cluster",
  "loggers.clusters.error.equal": "{name1} es igual al {name2}",
  "loggers.clusters.error.limit": "Está permitido añadir solo 125 clusters",
  "loggers.clusters.heartbeat.ip.verify":
    "Dirección IP Heartbeat configurado en otro cluster",
  "loggers.clusters.virtual.ip.verify":
    "Dirección IP Virtual configurado en otro cluster",
  "loggers.cluster.verify":
    "No es posible eliminar una (o más) Logger(s) configurada en Cluster",
  "events.authentication.reason.src": "Dirección Remoto",
  "events.authentication.reason.time": "Horario",
  "events.authentication.reason.date": "Periodo",
  "events.authentication.reason.user_agent": "Plataforma",
  "events.authentication.reason.zone": "Zona de Red",
  "events.authentication.reason.no_policy": "Ninguna política encontrada",
  "events.authentication.reason.user_blocked": "Usuario bloqueado",
  "events.authentication.reason.timeout": "Tiempo de sesión",
  "events.authentication.reason.policy": "Política",
  "events.authentication.reason.auth": "Autenticación",
  "events.authentication.reason.user": "Usuario/Grupo",
  "events.authentication.reason.internal_error": "Error interno",
  "events.authentication.reason.max_session": "Número de sesión excedido",
  "events.authentication.reason.session override": "Sobrescritura de sesión",
  "events.authentication.reason.updated": "Sesión actualizada",

  "events.title": "Eventos",
  "events.new.query": "Nova Consulta",
  "events.edit.query": "Editar Consulta",
  "events.save.query": "Guardar Consulta",
  "events.create.query": "Crear Consulta",
  "events.custom.query": "Crear nuevo nombre de consulta",
  "events.load.query": "Cargar Consulta",
  "events.date.range": "Período de fecha",
  "events.filter": "Filtro",
  "events.contain": "Contiene",
  "events.not.contain": "No contiene",
  "events.not.equals": "Diferente",
  "events.equals": "Igual",
  "events.value": "Valor",
  "events.filter.string": "Filtro por palabra",
  "events.filter.string.results": "Resultado de filtro por palabra",
  "events.query.editor": "Editor de Consultas",
  "events.information": "Informaciones del evento",
  "events.view": "Visualización del evento",
  "events.select.field": "Seleccione un campo",
  "events.log.analysis": "Análisis de Log",
  "events.history": "Histórico de Hits",
  "events.error.filter.string": "¡Por favor, introduzca un filtro por palabra",
  "events.error.name": "¡Por favor, introduzca un Nombre",
  "events.delete.all.selected": "Eliminar todos los seleccionados",
  "events.search": "Buscar",
  "events.today": "Hoy",
  "events.yesterday": "Onten",
  "events.last_10m": "Últimos 10 minutos",
  "events.last_6h": "Últimas 6 horas",
  "events.last_12h": "Últimas 12 horas",
  "events.last_18h": "Últimas 18 horas",
  "events.last_7": "Últimos 7 días",
  "events.last_30": "Últimos 30 días",
  "events.this_month": "Este mes",
  "events.last_month": "Último mes",
  "events.date": "Por fecha",
  "events.range": "Por período",
  "events.start.date": "Fecha de inicio",
  "events.end.date": "Fecha límite",
  "events.select.date": "Seleccione la fecha",
  "events.records": "Registros",
  "events.record": "Registro",
  "analyzer.title": "Analyzer",
  "analyzer.reports.NetworkTraffic": "Tráfico de Red",
  "analyzer.reports.WebFilter": "Web Filter",
  "analyzer.reports.ApplicationControl": "Application Control",
  "analyzer.reports.IntrusionPrevention": "Intrusion Prevention",
  "analyzer.reports.ThreatProtection": "Threat Protection",
  "analyzer.reports.UserBehaviour": "User Behaviour",
  "analyzer.reports.Hits": "Hits",
  "analyzer.reports.Traffic": "Tráfico",
  "analyzer.reports.AllowedApplication": "Aplicaciones Permitidas",
  "analyzer.reports.DeniedApplication": "Aplicaciones Negadas",
  "analyzer.reports.History": "Histórico",
  "analyzer.reports.TotalTraffic": "Tráfico Total",
  "analyzer.reports.TopAllowedCategories": "Top Categorías Permitidas",
  "analyzer.reports.TopDeniedCategories": "Top Categorías Negadas",
  "analyzer.reports.TopAllowedApplications": "Top Aplicaciones Permitidas",
  "analyzer.reports.TopDeniedApplications": "Top Aplicaciones Negadas",
  "analyzer.reports.ThreatBlocking": "Amenaza",
  "analyzer.reports.MalwareScanning": "Malware",
  "analyzer.reports.Geolocation": "Geolocalización",
  "analyzer.reports.ZoneTraffic": "Zona de Tráfico",
  "analyzer.reports.UsageTraffic": "Uso de Tráfico",
  "analyzer.reports.TopUsers": "Top Usuarios",
  "analyzer.reports.Top.SiteToSite": "Top Conexiones Site-To-Site",
  "analyzer.reports.Top.RemoteUsers": "Top Usuarios Remotos",
  "analyzer.reports.RemoteUsers": "Usuarios Remotos",
  "analyzer.reports.TopServices": "Top Servicios",
  "analyzer.reports.TopSources": "Top Orígenes",
  "analyzer.reports.TopPolicies": "Top Políticas",
  "analyzer.reports.TopProfiles": "Top Perfiles",
  "analyzer.reports.TopDestinations": "Top Destinos",
  "analyzer.reports.TopCategories": "Top Categorías",
  "analyzer.reports.TopSites": "Top Dominios",
  "analyzer.reports.TopSitesByTime": "Top Dominios - Tiempo",
  "analyzer.reports.TopContentType": "Top Tipos de Contenido",
  "analyzer.reports.TopClasstypes": "Top Tipos de Clases",
  "analyzer.reports.TopMalwares": "Top Malwares",
  "analyzer.reports.StartDownload": "La descarga comenzará en un instante",
  "analyzer.reports.TopInfectedDomains": "Top Dominios Infectados",
  "analyzer.reports.TopThreatsByAddress": "Top Amenaza por Dirección",
  "analyzer.reports.TopThreatsByUsers": "Top Amenaza por Usuarios",
  "analyzer.reports.TopAttacks": "Top Ataques",
  "analyzer.reports.TopThreats": "Top Amenaza",
  "analyzer.reports.TopApplications": "Top Aplicaciones",
  "analyzer.reports.SelectDevice": "Seleccione un Dispositivo/Grupo",
  "analyzer.reports.SelectUser": "Seleccione un Usuario",
  "analyzer.reports.HistoryTotalTraffic": "Histórico de Tráfico Total",
  "analyzer.reports.DeniedDomains": "Dominios Negados",
  "analyzer.reports.AllowedDomains": "Dominios Permitidos",
  "analyzer.reports.HistoryDeniedDomains": "Histórico de Dominios Negados",
  "analyzer.reports.HistoryAllowedDomains": "Histórico de Dominios Permitidos",
  "analyzer.reports.HistoryUsers": "Histórico de Usuarios",
  "analyzer.reports.HistoryPolicies": "Histórico de Perfiles",
  "analyzer.reports.HistoryCategories": "Histórico de Categorías",
  "analyzer.reports.HistorySites": "Histórico de Dominios",
  "analyzer.reports.HistoryContentType": "Histórico de Tipo de Contenido",
  "analyzer.reports.User": "Usuario",
  "analyzer.reports.Service": "Servicio",
  "analyzer.reports.Source": "Origen",
  "analyzer.reports.Destination": "Destino",
  "analyzer.reports.Policy": "Política",
  "analyzer.reports.Profile": "Perfil",
  "analyzer.reports.Domain": "Domínio",
  "analyzer.reports.Application": "Aplicación",
  "analyzer.reports.ContentType": "Tipo de Contenido",
  "analyzer.reports.Category": "Categoría",
  "analyzer.reports.Classtype": "Tipo de Clase",
  "analyzer.reports.Malware": "Malware",
  "analyzer.reports.Address": "Dirección IP",
  "analyzer.reports.Attack": "Ataque",
  "analyzer.reports.Threat": "Amenaza",
  "analyzer.reports.Alerted": "Alertado",
  "analyzer.reports.Blocked": "Bloqueado",
  "analyzer.reports.Low": "Bajo",
  "analyzer.reports.Medium": "Medio",
  "analyzer.reports.High": "Alto",
  "analyzer.reports.RiskHigh": "Risco - Alto",
  "analyzer.reports.RiskMedium": "Risco - Medio",
  "analyzer.reports.RiskLow": "Risco - Bajo",
  "analyzer.reports.totalApplication": "Aplicaciones",

  "analyzer.reports.common.selectDevice": "Seleccione un Dispositivo",
  "analyzer.reports.policy.globalTags": "Tags Globales",
  "analyzer.reports.user.applications": "Aplicaciones",
  "analyzer.reports.user.panel": "Panel de Análisis",
  "analyzer.reports.component.footer.totalTraffic": "Tráfico Total",
  "analyzer.reports.component.footer.totalHits": "Hits Totales",

  "report.actions.add.success": "Informes agregados con éxito",

  "analytics.reports.modal.recurrence": "Reaparición",
  "analytics.reports.schedule.unique": "Única",
  "analytics.reports.schedule.daily": "Diariamente",
  "analytics.reports.schedule.weekly": "Semanalmente",
  "analytics.reports.schedule.monthly": "Mensalmente",
  "analytics.reports.scheduled": "Programado",
  "analytics.reports.owner": "Propietario",
  "analytics.reports.period": "Periodo",
  "analytics.reports.status": "Estatus",
  "analytics.reports.reports": "Informes",
  "analytics.reports.download": "Descarga",
  "analytics.reports.visualize": "Visualizar",
  "analytics.reports.pending": "Pendiente",
  "analytics.reports.running": "En ejecución",
  "analytics.reports.modal.title": "Informes",
  "analytics.reports.modal.type": "Tipo",
  "analytics.reports.modal.analysis": "Análisis",
  "analytics.reports.modal.customQueries": "Consultas Personalizadas",
  "analytics.reports.modal.footerText": "Texto de pie de página",
  "analytics.reports.modal.customizeLogo": "Personalizar el Logo",
  "analytics.reports.changeSchedule": "Alterar lo planificación",
  "analytics.reports.changeSchedule.dateAndTime": "Fecha y hora",
  "analytics.reports.changeSchedule.sucess":
    "Programación actualizada con éxito",
  "analytics.reports.changeSchedule.error":
    "¡La programación no ha sido guardado!",
  "analytics.reports.upload.errorSize":
    "¡Archivo debe ser más pequeño que 2MB!",
  "analytics.reports.upload.errorType": "¡Formato de imagen no válido!",
  "analytics.reports.actions.delete.success": "¡Informes eliminados con éxito!",
  "analytics.reports.actions.add.error": "¡El informe no ha sido guardado!",
  "analytics.reports.logo.extension": "¡Extensión no válida!",
  "analytics.reports.logo.size.archive":
    "¡Tamaño del archivo superior al previsto!",
  "analytics.reports.logo.size.image":
    "¡Tamaño de la imagen superior al previsto!",
  "webCategory.uncategorized": "Sitios no categorizados",
  "webCategory.abortion": "Activismo relacionado con derechos reproductivos",
  "webCategory.pro-life": "Sitios pro-vida",
  "webCategory.pro-choice": "Sitios a favor de la libertad de elección",
  "webCategory.activism-groups": "Grupos de activismo",
  "webCategory.adult-material": "Sitios para un público adulto",
  "webCategory.adult-content": "Contenido para mayores",
  "webCategory.nudity": "Desnudez",
  "webCategory.sex": "Sexo",
  "webCategory.sex-education": "Educación Sexual",
  "webCategory.lingerie-and-swimsuit": "Lencería y Trajes de baño",
  "webCategory.business-and-economy": "Negocios y Economía",
  "webCategory.financial-data-and-services": "Servicios y datos financieros",
  "webCategory.drugs":
    "Medicamentos o Fármacos (según se definen en la Ley de los E.U.A.)",
  "webCategory.abused-drugs": "Drogadicción ",
  "webCategory.prescribed-medications": "Medicamentos con prescripción médica",
  "webCategory.supplements-and-unregulated-compounds":
    "Suplementos/compuestos no regulados",
  "webCategory.marijuana": "Marihuana",
  "webCategory.education": "Educación",
  "webCategory.educational-institutions": "Instituciones educacionales",
  "webCategory.cultural-institutions": "Instituciones culturales",
  "webCategory.educational-materials": "Materiales educativos",
  "webCategory.reference-materials": "Materiales de Referencia",
  "webCategory.entertainment": "Entretenimiento",
  "webCategory.mp3-and-audio-download-services": "MP3",
  "webCategory.gambling": "Juegos de azar y apuestas",
  "webCategory.games": "Juegos / Games",
  "webCategory.government": "Gobierno",
  "webCategory.military": "Agencias militares",
  "webCategory.political-organizations": "Grupos políticos",
  "webCategory.health": "Salud",
  "webCategory.illegal-or-questionable": "Contenido ilícito/dudoso",
  "webCategory.pedophilia": "Pedofilia",
  "webCategory.information-technology": "Tecnología de la información",
  "webCategory.hacking": "Hacking",
  "webCategory.proxy-avoidance": "Sistemas de anulación de Proxy",
  "webCategory.search-engines-and-portals": "Motores de búsqueda y portales",
  "webCategory.web-hosting": "Hospedaje Web",
  "webCategory.url-translation-sites": "Sitios de traducción de URL",
  "webCategory.computer-security":
    "Informaciones acerca de la seguridad informática",
  "webCategory.internet-communication": "Comunicaciones por la Internet",
  "webCategory.web-chat": "Chat en la Web",
  "webCategory.web-mail": "Correo Electrónico por la Web",
  "webCategory.job-search": "Búsqueda de empleo",
  "webCategory.militancy-and-extremist": "Sitios de militancia/extremismo",
  "webCategory.news-and-media": "informativos e prensa",
  "webCategory.alternative-journals": "Publicaciones alternativas",
  "webCategory.productivity-categories": "Gestión de productividad",
  "webCategory.advertisements": "Anuncios publicitarios",
  "webCategory.freeware-and-software-download":
    "Descargarse gratuitas/software",
  "webCategory.instant-messaging": "Sistemas de mensajería instantánea",
  "webCategory.message-boards-and-forums": "Tableros de mensajes y foros",
  "webCategory.online brokerage and trading":
    "Corretaje y negociaciones on-line",
  "webCategory.pay-to-surf": "Sitios de navegación paga (pay-to-surf)",
  "webCategory.bandwidth-categories": "Gestión del ancho de banda",
  "webCategory.internet-radio-and-tv": "Radio y Televisión en el Internet",
  "webCategory.streaming-media": "Transmisión multimedia",
  "webCategory.peer-to-peer-file-sharing":
    "Intercambio de archivos peer-to-peer",
  "webCategory.personal-network-storage-and-backup":
    "Almacenamiento/Copia de Seguridad personal en la red",
  "webCategory.internet-telephony": "Telefonía en Internet",
  "webCategory.potentially-unwanted-software":
    "Vigilancia indebido y invasión de privacidad",
  "webCategory.malicious-web-sites": "Sitios web maliciosos",
  "webCategory.spyware": "Spyware",
  "webCategory.racism-and-hate": "Racismo/Odio",
  "webCategory.religion": "Religión",
  "webCategory.non-traditional-religions-and-occult-and-folklore":
    "Religiones no tradicionales",
  "webCategory.traditional-religions": "Religiones tradicionales",
  "webCategory.shopping": "Compra",
  "webCategory.internet-auctions": "Subastas en el Internet",
  "webCategory.real-estate": "Inmuebles",
  "webCategory.social-organizations": "Organizaciones Sociales",
  "webCategory.professional-and-worker-organizations":
    "Organizaciones de laborales y profesionales",
  "webCategory.service-and-philanthropic-organizations":
    "Organizaciones de Servicios y filantrópicas",
  "webCategory.social-and-affiliation-organizations":
    "Organizaciones Sociales y Afiliaciones",
  "webCategory.society-and-lifestyles": "Anuncios personales y noviazgos",
  "webCategory.alcohol-and-tobacco": "Alcohol y Tabaco",
  "webCategory.gay-or-lesbian-or-bisexual-interest": "LGBTQIA+",
  "webCategory.personals-and-dating": "Anuncios personales y noviazgos",
  "webCategory.restaurants-and-dining": "Restaurantes y gastronomía",
  "webCategory.hobbies": "Hobbies",
  "webCategory.social-networking-and-personal-sites":
    "Página personal en la Web",
  "webCategory.special-events": "Eventos especiales",
  "webCategory.sports": "Deportes",
  "webCategory.sport-hunting-and-gun-clubs": "Caza deportiva / Clubes de armas",
  "webCategory.tasteless": "Mal gusto",
  "webCategory.travel": "Turismo",
  "webCategory.vehicles": "Vehículos",
  "webCategory.violence": "Violencia",
  "webCategory.weapons": "Armas",

  "webCategoryDescription.uncategorized": "",
  "webCategoryDescription.abortion":
    "Sitios con presentación neutral o equilibrado del tema.",
  "webCategoryDescription.pro-life":
    "Sitios que proporcionan información sobre o son patrocinadas por organizaciones que apoyan el aborto legal, que ofrecen apoyo o incentivo para aquellos que buscan el procedimiento.",
  "webCategoryDescription.pro-choice":
    "Sitios que proporcionan información sobre o son patrocinadas por organizaciones que se oponen al aborto legal que buscan una mayor restricción al aborto.",
  "webCategoryDescription.activism-groups": "",
  "webCategoryDescription.adult-material": "",
  "webCategoryDescription.adult-content":
    "Sitios que exhiben desnudez total o parcial en un contexto sexual, pero no actividad sexual; contenido erótico; parafernalia sexual; negocios orientados al sexo, como los clubs, clubes nocturnos, servicios de acompañantes; y sitios de soporte de compra on-line dichos bienes y servicios.",
  "webCategoryDescription.nudity":
    "Sitios que ofrecen representaciones de formas humanas desnudo o semidesnudo, individualmente o en grupos, no siendo abiertamente sexuales en intención o efecto.",
  "webCategoryDescription.sex":
    "Sitios que muestran o describen gráficamente actos o actividades sexuales, incluyendo el exhibicionismo; Además, sitios que ofrecen links directos para estos sitios.",
  "webCategoryDescription.sex-education":
    "Sitios que ofrecen informaciones sobre sexo y la sexualidad, sin intención pornográfica.",
  "webCategoryDescription.lingerie-and-swimsuit":
    "Sitios que ofrecen imágenes de modelos em trajes sugestivos, pero no sucio, con semidesnudos permitida. Incluye 'cheese-cake photo', calendario, arte y fotografía pin-up. Incluye también sitios que ofrecen ropa interior o moda playa a la venta.",
  "webCategoryDescription.business-and-economy":
    "Sitios patrocinados o dedicados a empresas, asociaciones de empresas, grupo del sector o negocio en general.",
  "webCategoryDescription.financial-data-and-services":
    "Sitios que ofrecen noticias y cotizaciones de acciones, valores y otros vehículos de inversión, consejos de inversión, pero no comercio on-line. Incluye bancos, cooperativas de crédito, tarjetas de crédito y seguros.",
  "webCategoryDescription.drugs": "",
  "webCategoryDescription.abused-drugs":
    "Sitios que defienden o ofrecen instrucciones para el uso de drogas prohibidas, excepto marihuana, abuso o uso no autorizado de drogas controladas o reguladas; además, parafernalia asociada a este uso o abuso.",
  "webCategoryDescription.prescribed-medications":
    "Sitios que proporcionan información sobre medicamento aprobado y sus aplicaciones médicas.",
  "webCategoryDescription.supplements-and-unregulated-compounds":
    "Sitios que proporcionan información o fomentan la venta o el uso de sustancias químicas no regulados efectuada por el FDA (como compuestos que se forman naturalmente).",
  "webCategoryDescription.marijuana":
    "Sitios que proporcionan información sobre o fomentan el cultivo,  preparación y el uso de marihuana.",
  "webCategoryDescription.education": "",
  "webCategoryDescription.educational-institutions":
    "Sitios patrocinados por escuelas y otras instalaciones educativas, por instituciones de No investigaciones no académicas relacionados con eventos y actividades educativas.",
  "webCategoryDescription.cultural-institutions":
    "Sitios patrocinados por museos, galerías, teatros (pero no cines), bibliotecas e instituciones similares; Además, sitios cuyo objetivo es exhibir obras de arte..",
  "webCategoryDescription.educational-materials":
    "Sitios que proporcionan información sobre y que difundan, materiales para el programa de estudio o instrucciones directas; también, publicaciones periódicas de formación y publicaciones similares.",
  "webCategoryDescription.reference-materials":
    "Sitios que ofrecen contenido de referencia, como atlas, diccionarios, enciclopedias, formularios, páginas blancas, amarillas y datos estadísticos públicos.",
  "webCategoryDescription.entertainment":
    "Sitios que proporcionan información sobre o fomentan peliculas, radio y television no noticiosos, libros, humor y revistas.",
  "webCategoryDescription.mp3-and-audio-download-services":
    "Sitios que admiten la descarga de MP3, otros archivos de sonido o que funcionan como directorios de estos sitios.",
  "webCategoryDescription.gambling":
    "Sitios que proporcionan información o fomentan los juegos de azar o ofrecemos atención a los juegos de azar on-line, que implican el riesgo de perder dinero.",
  "webCategoryDescription.games":
    "Sitios que proporcionan información sobre o fomentan los juegos electrónicos, videojuegos, juegos de computadora, role-playing games o juego en línea. Incluye  y sorteos de premios.",
  "webCategoryDescription.government":
    "Sitios patrocinados por filiales, oficinas o agencias de cualquier nivel gubernamental, excepto de las Fuerzas Armadas.",
  "webCategoryDescription.military":
    "Sitios patrocinados por filiales o agencias de las Fuerzas Armadas.",
  "webCategoryDescription.political-organizations":
    "Sitios patrocinados por o proporcionando informaciones de los partidos políticos y grupos de interés con enfoco en las elecciones o legislación.",
  "webCategoryDescription.health":
    "Sitios que proporcionan información asesoría sobre salud personal o servicios, procedimientos o dispositivos médicos, pero no medicamentos. Incluye grupos de autoayuda.",
  "webCategoryDescription.illegal-or-questionable":
    "Sitios que ofrecen instrucciones o fomentan los crímenes no violentos, comportamiento no ético o deshonestos o la prevención de la prosecución.",
  "webCategoryDescription.pedophilia":
    "Sitios que fomentan la pedofilia o que ofrecen imagens o textos con contenido de pedofilia.",
  "webCategoryDescription.information-technology":
    "Sitios patrocinados por o proporcionando informaciones sobre computadoras, software, Internet en empresas relacionadas, incluyendo sitios que ofrecen apoyo a la venta de hardware, software, periféricos y servicios.",
  "webCategoryDescription.hacking":
    "Sitios que contêm informaciones o que promover el acceso o uso ilícito, o de carácter cuestionable, de equipos de comúnicación, software o bases de datos.",
  "webCategoryDescription.proxy-avoidance":
    "Sitios que proporcionan información sobre como Ignorar los recursos del servidor proxy o obtener acceso a URLs de cualquier manera que evite el servidor proxy.",
  "webCategoryDescription.search-engines-and-portals":
    "Sitios que ofrecen compatibilidad con la búsqueda en la Web, grupo de noticias o índices o carpetas de ellos.",
  "webCategoryDescription.web-hosting":
    "Sitios de las organizaciones que ofrecen servicio de alojamiento o página del dominio de nível superior de a comúnidad de la Web.",
  "webCategoryDescription.url-translation-sites":
    "Sitios que ofrecen de traducción de URLs online. Estos sitios web acceden la URL a traducir de un modo que ignora el servidor proxy, potencialmente permitiendo el acceso no autorizado.",
  "webCategoryDescription.computer-security":
    "Sitios que proporcionan información o herramientas de descarga gratuitas en la seguridad informática.",
  "webCategoryDescription.internet-communication": "",
  "webCategoryDescription.web-chat":
    "Sitios que alojan servicios de chat en la Web o que ofrecen soporte o ofrecen informaciones sobre chat HTTP o IRC.",
  "webCategoryDescription.web-mail":
    "Sitios que ofrecen servicios de email abierto para uso de todos.",
  "webCategoryDescription.job-search":
    "Sitios que ofrecen informaciones o promueven tu búsqueda laboral o empleados.",
  "webCategoryDescription.militancy-and-extremist":
    "Sitios que ofrecen informaciones, fomentan o son patrocinados por grupos que abogan por creencia o acciones antigubernamentales.",
  "webCategoryDescription.news-and-media":
    "Sitios que ofrecen noticias y opiniones actuales, incluidos los patrocinados por periódicos, revistas de circulación general o otros medios.",
  "webCategoryDescription.alternative-journals":
    "Servicio online equivalente a periódico de supermercado e publicaciones adicionales.",
  "webCategoryDescription.productivity-categories": "",
  "webCategoryDescription.advertisements":
    "Sitios que ofrecen publicidad gráfica o otros archivos de contenido publicitario.",
  "webCategoryDescription.freeware-and-software-download":
    "Sitios que se dedican principalmente ofrece descarga de freeware y software.",
  "webCategoryDescription.instant-messaging":
    "Sitios que permiten mensajería instantánea.",
  "webCategoryDescription.message-boards-and-forums":
    "Sitios que alojan tableros de mensajes, grupos de discusión e otros de foros de debate que No se necesita filiación.",
  "webCategoryDescription.online brokerage and trading":
    "Sitios que ofrecen soporte a negociación de activos de valores y gestión de inversiones.",
  "webCategoryDescription.pay-to-surf":
    "Sitios que recompensan a los usuarios por actividades en internet, como mostrar los sitios, anuncios o correo electrónico.",
  "webCategoryDescription.bandwidth-categories": "",
  "webCategoryDescription.internet-radio-and-tv":
    "Sitios cuyo principal objetivo es proporcionar programación de radio o TV por Internet.",
  "webCategoryDescription.streaming-media":
    "Sitios que ofrecen principalmente contenido de streaming media, como trailers de películas.",
  "webCategoryDescription.peer-to-peer-file-sharing":
    "Sitios que ofrecen software de cliente para permitir el compartición y transferencia de archivos punto a punto.",
  "webCategoryDescription.personal-network-storage-and-backup":
    "Sitios que almacena archivos personales en proveedores de Internet para copia de seguridad o compartición.",
  "webCategoryDescription.internet-telephony":
    "Sitios que permitem a los usuarios hacer llamadas telefónicas en Internet o obtener informaciones o software para este fin.",
  "webCategoryDescription.potentially-unwanted-software":
    "Sitios que usan tecnología que cambian el funcionamiento del hardware, software o red del usuario de modo que reduce el control sobre la experiencia el usuario, la privacidad o la recolección y distribución de informaciones personales.",
  "webCategoryDescription.malicious-web-sites":
    "Sitios que contienen códigos que puede intencionalmente cambiar los sistemas del usuario final sin su consentimiento y causar daños.",
  "webCategoryDescription.spyware":
    "Sitios o páginas que descargan software que, sin el conocimiento del usuario, generan tráfico HTTP (excepto de la simple identificación y validación del usuario).",
  "webCategoryDescription.racism-and-hate":
    "Sitios que fomentan la identificación de grupos raciales, difamación o sumisión de grupos o la superioridad de cualquier grupo.",
  "webCategoryDescription.religion": "",
  "webCategoryDescription.non-traditional-religions-and-occult-and-folklore":
    "Sitios que proporcionan información sobre o fomentan la religión no especificada en religiones tradicionales o otras creencias y prácticas no convencionales, culturales o populares.",
  "webCategoryDescription.traditional-religions":
    "Sitios que proporcionan información sobre o fomentan la Bahai, Budismo, Ciencia Cristiana, Cristianismo, Hinduismo, Islam, Judaísmo, Mormonismo, Sintoísmo y Sijismo, más allá de ateísmo.",
  "webCategoryDescription.shopping":
    "Sitios que ofrecen soporte de compra en línea de productos y servicios de consumo, excepto: materiales sexuales, lencería, trajes de baño, inversiones, medicamentos, materiales educativos, software o hardware de computadora, alcohol, tabaco, viajes, vehículos y repuestos y armas.",
  "webCategoryDescription.internet-auctions":
    "Sitios que ofrecen soporte a la oferta y compra de mercancias entre individuos.",
  "webCategoryDescription.real-estate":
    "Sitios que proporcionan información sobre alquiler, compra, venta o financiación de propiedades residenciales.",
  "webCategoryDescription.social-organizations": "",
  "webCategoryDescription.professional-and-worker-organizations":
    "Sitios patrocinados por lo que promueven o ofrecen informaciones sobre organizaciones dedicadas al progreso profesional o los intereses de los trabajadores.",
  "webCategoryDescription.service-and-philanthropic-organizations":
    "Sitios patrocinados por lo que promueven o ofrecen informaciones sobre organizaciones dedicadas a hacer el bien como su actividad principal.",
  "webCategoryDescription.social-and-affiliation-organizations":
    "Sitios patrocinados por lo que promueven o ofrecen informaciones sobre organizaciones dedicadas principalmente la socialización o el interés común que no sean filantropía o promoción profesional.",
  "webCategoryDescription.society-and-lifestyles":
    "Sitios que proporcionan información sobre el asuntos de la vida cotidiana, excluyendo entretenimiento, salud, pasatiempos, trabajos, sexo y deportes.",
  "webCategoryDescription.alcohol-and-tobacco":
    "Sitios que proporcionan información, promueven la venta de bebidas alcohólicas o productos del tabaco o parafernalia asociada.",
  "webCategoryDescription.gay-or-lesbian-or-bisexual-interest":
    "Sitios que proporcionan información o adaptan al estilo de vida LGBTQIA+, incluyendo aquellos que promueven las compras en línea, pero excluyendo los que son sexuales u orientado a los problemas.",
  "webCategoryDescription.personals-and-dating":
    "Sitios que ayudan a los usuarios a establecer relaciones interpersonales, excluyendo los que están destinados a organización de encuentro sexuales y excluyendo los de interés exclusivamente LGBTQIA+.",
  "webCategoryDescription.restaurants-and-dining":
    "Sitios que enumeran, revisan, anuncian o fomentan los servicios de alimentación, comidas o suministro de los productos alimenticios.",
  "webCategoryDescription.hobbies":
    "Sitios que proporcionan información sobre o fomentan los pasatiempos privados e ampliamente sedentarios, pero no videojuegos, de vídeo o en línea.",
  "webCategoryDescription.social-networking-and-personal-sites":
    "Sitios dedicados principalmente la expresión personal (como diarios o blogs personales) o pequeño grupos, frecuentemente, pero no necesariamente, que implican varios enlaces a sitios similares.",
  "webCategoryDescription.special-events":
    "Sitios dedicados a un evento actual que requiere creación de categorías aparte.",
  "webCategoryDescription.sports":
    "Sitios que proporcionan información sobre o fomentan los deportes, juegos activos y recreación.",
  "webCategoryDescription.sport-hunting-and-gun-clubs":
    "Sitios que proporcionan información o directorios de los clubs de armas y grupos similares, incluyendo instalaciones de juegos de guerra y paintball.",
  "webCategoryDescription.tasteless":
    "Sitios con contenido gratuitamente ofensivo o impactante, pero no violenta o aterrador. Incluye sitios parcialmente dedicado o totalmente la escatología e tópicos similares o el lenguaje, humor o comportamiento inapropiado.",
  "webCategoryDescription.travel":
    "Sitios que proporcionan información sobre o fomentan los servicios y destinos relacionados con los viajes.",
  "webCategoryDescription.vehicles":
    "Sitios que proporcionan información sobre o fomentan veículos, incluyendo aquellos que ofrecen soporte de compra en línea de vehículos y componentes.",
  "webCategoryDescription.violence":
    "Sitios que representan o fomentan la violencia o daños corporales, incluyendo daño auto infligido; o que exhiban gratuitamente imágenes de muerte, sangre o herida; o que contengan imágenes o descripciones grotescas o aterradoras sin nada de valor que te redime.",
  "webCategoryDescription.weapons":
    "Sitios que proporcionan información sobre, promueven la venta de armas y elementos relacionados.",

  "sidebar.management": "Gestión",
  "sidebar.manager": "Gestionar",
  "sidebar.management.devices": "Dispositivos",
  "sidebar.management.devices.inventory": "Inventario",
  "sidebar.management.devices.community": "Comunidades",
  "sidebar.management.devices.templates": "Plantilla",
  "sidebar.management.devices.provisioning": "Provisionamiento",
  "sidebar.management.devices.backups": "Copias de seguridad",
  "sidebar.management.policies": "Políticas",
  "sidebar.management.policies.packages": "Paquetes",
  "sidebar.management.policies.templates": "Plantilla",
  "sidebar.management.profiles": "Perfiles",
  "sidebar.management.profiles.webfilter": "Web Filter",
  "sidebar.management.profiles.threat.protection": "Threat Protection",
  "sidebar.management.profiles.application.control": "Application Control",
  "sidebar.management.profiles.intrusion.prevention": "Intrusion Protection",
  "sidebar.management.profiles.ssl.inspection": "Inspección SSL",
  "sidebar.management.profiles.sdwan": "SD-WAN",
  "sidebar.management.objects": "Objetos",
  "sidebar.management.objects.address": "Dirección es",
  "sidebar.management.objects.services": "Servicios",
  "sidebar.management.objects.times": "Horarios",
  "sidebar.management.objects.schedules": "Programaciones",
  "sidebar.management.objects.dictionaries": "Diccionarios",
  "sidebar.management.objects.contents": "Contenidos",
  "sidebar.management.users": "Usuarios",
  "sidebar.management.groups": "Grupos",

  "sidebar.analytics": "Analytics",
  "sidebar.analytics.dashboard": "Dashboard",
  "sidebar.analytics.analyzer": "Analyzer",
  "sidebar.analytics.firewall": "Firewall",
  "sidebar.analytics.networkTraffic": "Network Traffic",
  "sidebar.analytics.policyUsage": "Policy Usage",
  "sidebar.analytics.webFilter": "Web Filter",
  "sidebar.analytics.applicationControl": "Application Control",
  "sidebar.analytics.intrusionPrevention": "Intrusion Prevention",
  "sidebar.analytics.threatProtection": "Threat Protection",
  "sidebar.analytics.userBehavior": "User Behavior",
  "sidebar.analytics.reports": "Informes",
  "sidebar.analytics.events": "Eventos",
  "sidebar.analytics.alerts": "Alertas",
  "sidebar.analytics.loggers": "Loggers",
  "sidebar.analytics.kibana": "Informes personalizados",
  "sidebar.settings": "Configuraciones",
  "sidebar.settings.system": "Sistema",
  "sidebar.settings.system.general": "General",
  "sidebar.settings.system.license": "Licencia",
  "sidebar.settings.system.update": "Actualización",
  "sidebar.settings.system.storage": "Almacenamiento",
  "sidebar.settings.system.backups": "Copias de seguridad",
  "sidebar.settings.system.sessions": "Sesiones",
  "sidebar.settings.system.services": "Servicios",
  "sidebar.settings.system.ha": "Alta disponibilidad (Activo-Pasivo)",
  "sidebar.settings.system.ha_sync": "Alta disponibilidad (Activo-Activo)",
  "sidebar.settings.system.certificate": "Certificados",
  "sidebar.settings.system.custom.branding": "Marca Personalizada",
  "sidebar.settings.network": "Red",
  "sidebar.settings.network.general": "General",
  "sidebar.settings.network.interfaces": "Interfaces",
  "sidebar.settings.network.email": "Correo Electrónico",
  "sidebar.settings.administration": "Gestión",
  "sidebar.settings.administration.users": "Usuarios",
  "sidebar.settings.administration.profiles": "Perfiles",
  "sidebar.settings.administration.audit": "Auditar",
  "sidebar.settings.administration.servers": "Servidores",
  "sidebar.settings.administration.provider": "Proveedor de Identidad",
  "sidebar.settings.administration.control": "Access Control",
  "sidebar.settings.deploys": "Deploys",
  "sidebar.settings.deploys.panel": "Panel de Deploy",

  "sidebar.networkTraffic": "Tráfico de Red",
  "sidebar.contentFiltering": "Content Filtering",
  "sidebar.applicationControl": "Application Control",
  "sidebar.intrusionPrevetion": "Intrusion Prevention",
  "sidebar.threatProtection": "Threat Protection",
  "sidebar.emailProtection": "Correo Electrónico Protection",
  "sidebar.userBehavior": "User Behavior",

  "policy.title": "Políticas",
  "policy.manager.group.delete.error":
    "No se puede eliminar un grupo que contiene reglas",
  "policy.manager.group.delete.title": "confirme eliminación del grupo",
  "policy.manager.group.header.user": "Usuario",
  "policy.manager.group.header.group": "Grupo",
  "policy.form.title": "Formulario de Política",
  "policy.form.tabs.properties": "Propriedades",
  "policy.form.tabs.conditions": "Condiciones",
  "policy.form.tabs.inspection": "Inspección",
  "policy.form.tabs.routing": "Enrutamiento",
  "policy.form.properties.policyGroup": "Grupo de Política",
  "policy.form.properties.loggingOptions": "Registro de Tráfico",
  "policy.form.connection.geolocation": "País",
  "policy.form.connection.destination.mac.address": "MAC Address",
  "policy.form.inspection.sslInspection": "Inspección SSL",
  "policy.form.inspection.proxyServices": "Servicios de Proxy",
  "policy.form.inspection.intrusionPrevention": "Prevención de Intrusiones",
  "policy.form.inspection.threatProtection": "Protección contra Amenazas",
  "policy.form.inspection.applicationControl": "Control de Aplicaciones",
  "policy.form.inspection.webFilter": "Filtro Web",

  "settings.auth.platform": "Plataforma",
  "settings.auth.remoteAddr": "Dirección Remoto",
  "settings.auth.concurrentSessions": "Sesiones Concurrentes",
  "settings.auth.loginAttempts": "Intentos de Inicio de Sesión",
  "settings.auth.lockoutTimeout": "Timeout de Bloqueo (min)",
  "settings.auth.sessionTimeout": "Tiempo de Sesión (min)",
  "settings.auth.minutes": "minutos",
  "settings.auth.conditions.error":
    "¡Por favor, seleccione al menos un elemento!",

  "settings.system.logging.logRotationBySize": "Rotación de log por tamaño",
  "settings.system.logging.logRotationBySize.error":
    "Rotación de log por tamaño es de un máximo 90% y al menos 20%",
  "settings.system.logging.logRotationByAge": "Rotación de log por tiempo",
  "settings.system.logging.logRotationBySession": "Limite de log por sesión",
  "settings.system.logging.rotation": "Rotación",
  "settings.system.logging.persistency": "Persistencia",
  "settings.system.logging.logForwarding": "Enrutamiento",
  "settings.system.logging.remoteSyslog": "Syslog",
  "settings.system.logging.warning":
    "¿Desea cambiar las configuraciones?\n Los servicios del Firewall se reiniciarán.",
  "settings.system.logging.netflow.serverIP":
    "Dirección IP del Servidor Netflow",
  "settings.system.logging.netflow.serverPort": "Puerto del Servidor Netflow",
  "settings.system.logging.netflow.server.exists": "Está combinación ya existe",

  "settings.system.logging.syslog.mode.auth": "Modo de Autenticación",
  "settings.system.logging.syslog.cert.service": "Certificado de Servicio",
  "settings.system.logging.syslog.certificate": "CA Remota",
  "settings.system.logging.syslog.cert.invalid": "CA remota no valida!",

  "settings.system.highAvailability.limitHA": "Limite de Heartbeat",
  "settings.system.highAvailability.removeAll":
    "Eliminar todas las Configuraciones",
  "settings.system.highAvailability.idKey": "Clave de identificación",
  "settings.system.highAvailability.monitoredInterfaces":
    "Interfaces Monitoreadas",
  "settings.system.highAvailability.secondaryDevice": "Dispositivo secundario",
  "settings.system.highAvailability.networkInterface": "Interface de Rede",
  "settings.system.highAvailability.lastSyncDate":
    "Data del último sincronismo",
  "settings.system.highAvailability.secondaryServerAddr":
    "Dirección del servidor secundario",
  "settings.system.highAvailability.filesTransferred": "Archivos transferidos",
  "settings.system.highAvailability.primaryServerStatus":
    "Estatus del servidor primario",
  "settings.system.highAvailability.errors": "Errores",
  "settings.system.highAvailability.editSecondaryServer":
    "Editar servidor secundario",
  "settings.system.highAvailability.slaveWarning":
    "Dispositivo secundario activo, guardar la interfaz hará que sea el dispositivo primario",
  "settings.system.highAvailability.waiting":
    "Espera, los servidores se están sincronizando",
  "settings.system.highAvailability.error.logger.integrated":
    "No se puede configurar la Alta Disponibilidad porque la Logger integrada está activada",

  "wizard.title": "Asistente de Instalación",
  "wizard.tabs.license": "Aceptar licencia",
  "wizard.tabs.system": "Configuraciones del Sistema",
  "wizard.tabs.network": "Configuraciones da Rede",
  "wizard.tabs.admin": "Administración",
  "wizard.license.accepted": "Aceptar términos de uso",
  "wizard.system.hostname": "Nombre del Host",
  "wizard.system.domain": "Dominio",
  "wizard.system.timezone": "Zona horaria",
  "wizard.system.language": "Idioma",
  "wizard.network.deviceKey": "Interfaz",
  "wizard.network.ip": "Dirección IP",
  "wizard.network.mask": "Máscara de Red",
  "wizard.network.gateway": "Gateway",
  "wizard.network.dns": "Servidor DNS",
  "wizard.network.ntp": "Servidor NTP",
  "wizard.admin.name": "Nombre",
  "wizard.admin.email": "Correo Electrónico",
  "wizard.admin.pass": "Contraseña",
  "wizard.admin.repass": "Confirmar la contraseña",
  "wizard.license.accepted.error":
    "Para seguir, los términos de uso deben ser aceptados",
  "wizard.system.hostname.error": "Nombre del Host es obligatorio",
  "wizard.system.domain.error": "Dominio es obligatorio",
  "wizard.system.timezone.error": "Zona horaria es obligatorio",
  "wizard.system.language.error": "Idioma es obligatorio",
  "wizard.network.deviceKey.error": "Interfaz es obligatoria",
  "wizard.network.ip.error": "DirecciónIP es obligatorio",
  "wizard.network.mask.error": "Máscara de red es obligatoria",
  "wizard.network.gateway.error": "Gateway es obligatorio",
  "wizard.network.dns.error": "Servidor DNS es obligatorio",
  "wizard.network.ntp.error": "Servidor NTP es obligatorio",
  "wizard.admin.name.error": "Nombre es obligatorio",
  "wizard.admin.email.error": "Correo Electrónico es obligatorio",
  "wizard.admin.email.invalid": "Dirección de Correo Electrónico no válido",
  "wizard.admin.pass.error": "Contraseña es obligatoria",
  "wizard.admin.repass.error":
    "La confirmación de la contraseña es obligatoria",
  "wizard.admin.repass.mismatch":
    "La contraseña del campo de confirmación no corresponde a la contraseña digitada en lo campo previo",
  "wizard.progress.step1": "Crear Base de datos",

  "wizard.agreement": `BLOCKBIT

  CONTRATO DE LICENCIA DE USUARIO FINAL

AL HACER CLIC EN "CONTINUAR", USTED O LA ENTIDAD QUE REPRESENTA ("LICENCIADO") CONSIDERA PLENAMENTE QUE SEA LIMITADO Y SE CONVIERTE EN PARTE DE ESTE CONTRATO DE LICENCIA DE USUARIO FINAL ("CONTRATO") CON LA BLOCKBIT TECNOLOGIA LTDA. ("BLOCKBIT"). SI TALES CONDICIONES SON CONSIDERADAS UNA OFERTA, LA ACEPTACIÓN ES EXPRESAMENTE LIMITADA A TALES CONDICIONES. SÍ EL LICENCIADO NO CONCORDAR PLENAMENTE CON LO QUE ANTECEDE, HAGA CLIC EN EL BOTÓN “CANCELAR” Y EL PROCESO DE INSTALACIÓN NO SEGUIRÁ. SI HAGA CLIC EN EL BOTÓN “ACEPTAR” PARA PROSEGUIR CON LA INSTALACIÓN, USTED ESTÁ REPRESENTANDO Y GARANTIZANDO QUE ESTÁ PERMITIDO PARA ACTIVAR LA LICENCIA.

1. Concesión de licencias y Restricciones. Sujeto a las conficiones de este contrato, pago de todas las tasas y cualesquiera limitaciones aplicables de usuario/utilización, la BLOCKBIT otorga al licenciado un derecho personal, no sublicenciable y no exclusivo, de utilizar el software que es directamente accesible por este proceso de instalación, pero solo: (I) solo en formato de código del objecto (“Software”); (II) en un equipo autorizado específicamente, ubicada en un lugar con licencia autorizado por la BLOCKBIT; y (III) según la lista de precios de la BLOCKBIT. La BLOCKBIT mantiene la propiedad del Software y el Licenciado mantendrá el aviso de derecho de autor y cualquier otro aviso que aparezcan en el Software o en cualquier medio que contengan el Software.
2. Actualizaciones, contenido y servicio de soporte. Actualizaciones, contenido y/o servicios de soporte no es necesariamente suministrada con el Software y pueden requerir costo adicional o incluir términos y condiciones complementarias. Sin embargos, a medida que se proporciona una actualización para el Software y/o contenido, esta actualización/contenido se considerará “Software” proporcionado sujeto a este Acuerdo y deberás ser licenciado para utilización solo en equipos específicos para la cual fue licenciada. Si el servicio de contenido/soporte se proporcionan, la BLOCKBIT se reserva el derecho de cambiar el ámbito o el tiempo de tales servicios a cualquier momento y de tener acceso, utilizar y repartir libremente los datos recogidos del Licenciado a través de estos servicios. Si tales servicios se dispusieran, el Licenciado puede ser obligado a pagar tasas o otros gastos por lo uso o acceso a algúnos o todos estos servicios, tasas y términos especificados en la factura o en el formulario de solicitud para este tipo de servicio.
3. Restricciones. El Licenciado no (y no permitirá que terceras partes): (I) hacer ingeniería inversa, tratar de averiguar cualquier código fuente, ideas o algoritmo subyacente del Software; (II) ofrecer, rentar, prestar, difundir, usarlo con fines de compartir tiempo, agencia de servicio o de otra manera usarlo o dejar que otros usen para el beneficio de terceras partes, el Software (excepto en función expresamente y específicamente aprobado por el BLOCKBIT); (III) sin el previo consentimiento y expreso por escrito de la BLOCKBIT, realizar cualquier estudio, avaluación comparativa o análisis que implican el Software (“Benchmarking”) por cualquier razón o fin, excepto en la extensión limitada absolutamente necesaria, para determinar la conveniencia del software para interoperar con los sistemas informáticos internos del Licenciado; (IV) difundir a terceras partes cualquier Benchmarking o cualquier otra información relacionadas con estos; (V) utilizar el Software o cualquier Benchmarking en relación con el desarrollo de productos que compelemento con el Software, o; (VI) reproducir, cambiar o modificar el Software. Antes de eliminar cualquier medios o dispositivos que contienen cualquier parte del Software, el Licenciado debe destruir completamente el Software contenidos en el mismo. Todas las limitaciones y restricciones del Software licenciado sin cargos o por un cargo nominal se considerará una licencia de evaluación gratis y solo podrá ser utilizado para fines de evaluación de la obtención de una licencia pagada y no para cualquier utilización productiva. EL LICENCIADO RECONOCE QUE EL SOFTWARE PUEDE INCLUIR RECURSOS PARA EVITAR LA UTILIZACION DESPUES DE UN PERIODO DE LICENCIA APLICABLE Y/O USO INCONSISTENTE DE ESTE. El Licenciado reconoces que el Software se puede distribuir junto, contener o utilizar cierto Software de código abierto u otro software de tercera parte (“Third Part Software”). EL SOFTWARE DE TERCERA PARTE ESTA (ADEMAS DE LOS TERMINOS Y REQUISITOS DE ESTE CONTRACTO), SUJETOS Y REGIDOS (Y EL LICENCIADO ESTA DE ACUEDO Y DEBERÁ INDEMNIZAR LA BLOCKBIT POR INCUMPLIMIENTO) SUS LICENCIAS PARA EL SOFTWARE DE TERCERA PARTE. No son concedida derechos o licencias que no sean expresamente y sin ambigüedad establecidos aquí.
4. Confidencialidad. El Software en la forma de código fuente permanece en secreto comercial confidencial de la BLOCKBIT y/o de sus proveedores. El Software está protegido por las leyes de derecho de autor y otras leyes de propiedad intelectual de los Estados Unidos y tratados internacionales. El Licenciado reconoces que, durante la utilización del Software, el Licenciado puede obtener o aprender informaciones relacionadas con el Software, las cuales puede contener, sin limitación, informaciones relacionadas con el rendimiento, confiabilidad o estabilidad del Software, operación, conocimiento, técnicas, procesos, ideas, algoritmos, diseño y arquitectura del software (“Informaciones Propietarias”). Por las partes, estas informaciones propietarias pertenecerán exclusivamente de la BLOCKBIT. Durante y después de la efectividad de este Contracto, el Licenciado debe mantener la confianza y proteger, y no debe utilizar (excepción expresamente de la autorización por este Contacto) o revelar informaciones de Propiedad a terceras partes.
5. Rescisión. Este Contracto estará en vigor hasta su rescisión. El Licenciado puede terminar este Contracto en cualquier momento, eliminando todas las copias del Software y documentación relacionada. Este Contracto se rescindirá de forma automática si el Licenciado no pagar el valor total facturado por el Software cuando debido o no cumplido con cualquier termino o condición de este Contracto, incluso cualquier intensión de descargar una copia del Software para otra parte, excepto con arreglo a lo dispuesto en este documento. El Licenciado acepta que, con este término, el Licenciado eliminará todas las copias del Software y documentación relacionada. Excepto cuando expresamente dispuesto aquí, los términos de este instrumento si mantendrán independiente de cualquier rescisión. La rescisión no es un recurso exclusivo y todas las otras soluciones quedarán disponibles, independientemente de la rescisión ocurrir o no.
6. GARANTÍA LIMITADA Y EXENCIÓN DE RESPONSABILIDAD. EL LICENCIADO RECONOCES Y COMPRENDE QUE EL SOFTWARE LICENCIADO DE ACUERDO CON ESTE CONTRACTO ES PROPORCIONADO ‘TAL Y COMO ESTÁ’ SIN CUALQUIER GARANTÍA RELACIONADA CON LA INSTALACIÓN, UTILIZACIÓN O RENDIMIENTO DEL SOFTWARE. LA BLOCKBIT EXPRESAMENTE EXENTA Y EL LICENCIADO OTORGA EXPRESAMENTE TODAS LAS OTRAS GARANTÍAS, EXPRESAS O IMPLÍCITAS, INCLUSO GARANTÍAS DE COMERCIALIZACIÓN, ADECUACIÓN A UN FIN ESPECÍFICO, INCUMPLIMIENTO, INTEGRACIÓN DEL SISTEMA, NO INTERFERENCIA, PRECISIÓN, CONFIABILIDAD Y CUALIDAD DEL SOFTWARE, INCLUYENDO Y SIN DEROGAR DEL ARRIBA, CUALQUIER GARANTÍAS Y DERECHOS IMPLÍCITOS CON ARREGLO AL CÓDIGO COMERCIAL UNIFORME DE LOS EUA, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) Y LEY COMÚN. LA BLOCKBIT Y SUS PROVEEDORES NO GARANTIZAN QUE EL SOFTWARE CUMPLE CON LOS REQUISITOS DE LO LICENCIADO O QUE LO FUNCIONAMIENTO DEL SOFTWARE SE INTERRUMPIDA O SIN ERROR. LA BLOCKBIT SE EXIME AUN DE RESPONSABILIDADES Y EL LICENCIADO RECONOCE EXPRESAMENTE TODAS LAS GARANTÍAS RELACIONADAS A LOS RESULTADOS, INFORMACIONES, DATOS Y CUALQUIER CONSEJO PROVISTO POR EL SOFTWARE. ALGUNAS JURISDICCIONES NO PERMelemento LA ELIMINACIÓN DE GARANTÍAS IMPLÍCITAS, POR ESO LA ELIMINACIÓN ARRIBA PUEDE NO SE APLICAR A ESTAS. LA BLOCKBIT NO TENDRÁ NINGUNA RESPONSABILIDAD EN CAMBIAR EL MEDIO SI LA FALLA DEL MEDIO DERIVARSE DE ACCIDENTE, MALTRATO O USO INCORRECTO DEL MEDIO. EL SOFTWARE ES PROPORCIONADO AL LICENCIADO SIN GARANTÍA DE CUALQUIER TIPO, EXPRESA O IMPLÍCITA, INCLUSO SIN LIMITACIÓN, CUALQUIER GARANTÍA IMPLÍCITA DE COMERCIALIZACIÓN, ADECUACIÓN A UN FIN ESPECIFICO Y NO INFRACCIÓN.
7. Restricción de Responsabilidad. EN NINGÚN, LA BLOCKBIT O CUALQUIER OTRA PARTE INTERESADA EN LA CREACIÓN, PRODUCCIÓN O ENTREGA, INCIDENTAL O CONSECUENTE, INCLUYENDO SIN LIMITACIONES, BENEFICIOS O DATOS PERDIDOS, MISMO QUE HAYAN SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES DAÑOS.
8. Ley Anticorrupción. Lo Licenciado reconoce que está familiarizado y comprende lo dispuesto en la Ley Anticorrupción del Brasil n 12.846/2013, Ley contra Prácticas de Corrupción en el Exterior de los EUA (“FCPA”) y la Ley contra Soborno del Reino Unido de 2010 (“UKBA”) y está de acuerdo en cumplir con sus términos, así como cualquier disposición de la Ley local o de las policitas y procedimientos corporativos de la Blockbit en relación con estos. El Licenciado comprende también las disposiciones relacionadas las prohibiciones de la Ley Anticorrupción del Brasil, FCPA y UKBA en relación con el pago o donación de cualquier cosa de valor, incluyendo, entre otros, pago, regalos, viajes, entretenimiento y comidas, directa o indirectamente, a un oficinista de un gobierno extranjero o partido político esfuerzo por influir en un acto o decisión en su capacidad oficial o inducir el oficinista utilizar la influencia de su partido con este gobierno, para obtener o mantener negocios involucionando el Software. El Licenciado está de acuerdo en no violar o deliberadamente permitir que alguien viole la Ley Anticorrupción del Brasil, FCPA o UKBA, e el Licenciado está de acuerdo que ningún pago efectuado constituye soborno, inducir el pago, reembolso u otro pago que viole la Ley Anticorrupción del Brasil, FCPA, UKBA, o cualquier otra ley aplicable anticorrupción o antisoborno.
9. Avaluación. No obstante cualquier cosa es contraria a este documento, si el Licenciado esta usando el Software con fines evaluativos, este uso estará sujeto a los términos y condiciones de avaluación actuales de la BLOCKBIT o a otros términos mutuamente acordados para gobernar está avaluación.
10. Diversos. Ni este acuerdo ni las licencias concedidas en este documento son atribuibles o transferibles por el Licenciado (y cualquier intento de hacerlo se anulará). La BLOCKBIT puede ceder, delegar, licenciar y/o transferir libremente este Contracto, en lo todo o en parte, sin consentimiento. Este Contracto se considerará como hubiera sido hecho y debe interpretarse de acuerdo con las leyes brasileñas, sin considerar conflictos de disposiciones legales y sin considerar la Convención de las Naciones Unidas sobre la Compraventa Internacional de Mercaderías o la Ley de Operaciones Uniformes de Información de Ordenador. Sujeto a lo anterior expuesto, las disposiciones de este instrumento son únicamente para beneficio de las partes y no para cualquier otra persona o entidad. Cualquier notificación, informe, aprobación, autorización, acuerdo o consentimiento requerido o permitido en los términos de este documento debe hacerse por escrito; las notificaciones deben ser enviadas para la dirección que la parte aplicable tenga o pueda ofrecer mediante notificación por escrito o, si no hay, la dirección más reciente que la parte que enviar la notificación puede buscar usando esfuerzos razonables. Ninguna falla o tardanza en lo ejercicio parcial de cualquier derecho o poder de este instrumento se considerará como una renuncia, ni cualquier ejercicio parcial de cualquier derecho o poder de este instrumento evitará o ejercicio adicional. Si cualquier disposición sea juzgada por cualquier tribunal de jurisdicción competente con impracticable o invalida, está disposición vaya a ser limitada o eliminada extensión mínima necesaria para que este acuerdo permanezca en pleno vigor, efecto y fuerza ejecutiva. Está es la declaración completa y exclusiva de la comprensión mutua de las partes con relación a esta licencia aquí concedido y lo substituye y cancela todos los acuerdos y comúnicaciones escritos y orales anteriormente relacionados a esa licencia y cualquier renuncias o cambio será efectiva solo si ejecutada por escrito por la BLOCKBIT; Sin embargo, cualquier términos preimpresos estándar de cualquier solicitud de compra, confirmación o formulario similar a menos que sean firmados por la BLOCKBIT después de la vigencia de este instrumento, no va tener fuerza o efecto. La parte sustancialmente predominante en cualquier acción para aplicar este contracto tendrá derecho de recuperar los honorarios y costo de su abogados relacionados con este juicio.`,

  "settings.license": "Licencia",
  "settings.license.save": "Editar licencia",
  "settings.license.data": "Datos de la licencia",
  "settings.license.signatures": "Suscripciones",
  "settings.license.serial.number": "Número de orden",
  "settings.license.update": "Atualizar licencia",
  "settings.license.number": "Número de la licencia",
  "settings.license.status": "Estatus de la licencia",
  "settings.license.registration.date": "Fecha del registro",
  "settings.license.expiration.date": "Fecha de expiración",
  "settings.license.start.date": "Fecha inicial",
  "settings.license.end.date": "Fecha final",
  "settings.license.terms": "Terminos",

  "settings.backups.settings": "Configuraciones",
  "settings.backups.execute": "Realizar copia de seguridad",
  "settings.backups.save.settings": "Guardar Configuraciones",
  "settings.backups.system.now": "Crear archivo de copia de seguridad",
  "settings.backups.device.backups": "Copia de seguridad del Dispositivo",
  "settings.backups.storage": "Almacenamiento",
  "settings.backups.system.backup": "Copia de seguridad del sistema",
  "settings.backups.period": "Periodo",
  "settings.backups.period.weekly": "Semanal",
  "settings.backups.period.daily": "Diario",
  "settings.backups.weekday": "Día de la semana",
  "settings.backups.hour": "Hora",
  "settings.backups.automatic.cleanup": "Mantenimiento automático",
  "settings.backups.automatic.cleanup.info":
    "Número de copia de seguridad en el almacenamiento ",
  "settings.backups.snapshot": "Snapshot",
  "settings.backups.log.export": "Exportación de Logs",
  "settings.backups.error.storage":
    "Configure el Almacenamiento para realizar la copia de seguridad",
  "settings.backups.remove": "Eliminar Copia de seguridad",
  "settings.backups.remove.snapshot": "Eliminar Snapshot",
  "settings.backups.remove.confirm": "¿Seguro que desea eliminar?",
  "settings.backups.remove.success": "Copia de seguridad eliminado con éxito",
  "settings.backups.view.size": "Exibir tamaño del backup",
  "settings.backups.view.size.snapshot": "Exibir tamaño del Snapshot",
  "settings.backups.restore": "Restaurar Copia de seguridad",
  "settings.backups.restore.snapshot": "Restaurar Snapshot",
  "settings.backups.restore.success": "Copia de seguridad restaurado con éxito",
  "settings.backups.restore.snapshot.success": "Snapshot restaurado con éxito",
  "settings.backups.restore.error": "Erro al restaurar Copia de seguridad",
  "settings.backups.restore.error.server": "¡Servidor no válido!",
  "settings.backups.restore.error.backup": "¡Copia de seguridad no válido!",
  "settings.backups.restore.snapshot.error": "¡Error al restaurar Snapshot!",
  "settings.backups.restore.sys.warning":
    "El dispositivo entrará en estado de recuperación, todos los servicios se finalizarán. Después de la restauración el dispositivo se reiniciará. Se recomienda que la copia de seguridad del sistema se aplique únicamente en ambientes idénticos o similares.",
  "settings.backups.restore.device.warning": "El dispositivo entrará en modo de recuperación. Después de la restauración, el sistema se reiniciará.",
  "settings.backups.restore.snapshot.warning":
    "¿Seguro que desea restaurar el Snapshot?",
  "settings.backups.restore.log.warning":
    "¿Seguro que desea restaurar la copia de seguridad del Log?",
  "settings.backups.restore.snapshot.invalid": "¡Snapshot no válido!",
  "settings.backups.restore.snapshot.invalid.version":
    "¡Versión del Snapshot no válida!",
  "settings.backups.import": "Importar",
  "settings.backups.import.configuration": "Importar configuración",
  "settings.backups.import.success": "Importado con éxito",
  "settings.backups.import.error": "Error al importar",
  "settings.backups.import.error-duplicated-sids":
    "Error de importación duplicado SIDS: ",
  "settings.backups.import.error-rules-not-found":
    "Import error rules not found",
  "settings.backups.import.error-invalid-rules":
    "Error de importación de reglas no válidas",
  "settings.backups.import.error-file-not-found":
    "Error de importación de archivo no encontrado",
  "settings.backups.import.upload": "Haz click para cargar",
  "settings.backups.import.loading": "Cargando...",
  "settings.backups.import.in.progress": "Importando Configuraciones",
  "settings.backups.import.wait":
    "espere mientras las configuraciones se aplican",
  "settings.backups.file.configuration": "Archivo de configuración",
  "settings.backups.run": "Realizar Copia de seguridad",
  "settings.backups.run.execute": "Realizar",
  "settings.backups.run.confirm": "¿Desea hacer una copia de seguridad ahora?",
  "settings.backups.run.confirm.backup":
    "¿Desea hacer una copia de seguridad dej sistema ahora?",
  "settings.backups.run.confirm.snapshot": "¿Desea hacer o Snapshot ahora?",
  "settings.backups.run.confirm.logs":
    "¿Desea hacer la exportación de logs ahora?",
  "settings.backups.run.success": "Ejecución realiza con éxito",
  "settings.backups.select.time": "Seleccione la hora",
  "settings.backups.confirm.delete":
    "¿Confirmas eliminar la(s) copia de seguridad(es) ahora?",
  "settings.backups.confirm.stop":
    "¿Confirmas parar la copia de seguridad ahora?",
  "settings.backups.confirm.restore":
    "¿Confirmas restaurar la(s) copia de seguridad(es) ahora?",

  "settings.notifications": "Notificaciones",
  "settings.notifications.system.notifications": "Notificaciones del sistema",
  "settings.notifications.security.notifications":
    "Notificaciones del seguridad",
  "settings.notifications.notifications.email": "Notificaciones por Email",
  "settings.notifications.notifications.snmp": "Notificaciones por SNMP",
  "settings.notifications.synchronism": "Sincronización",
  "settings.notifications.gsm.analyzer": "GSM Analyzer",
  "settings.notifications.activities.policy": "Actividades en Políticas",
  "settings.notifications.activities.intrusion":
    "Actividades en Detección de Intrusos",
  "settings.notifications.activities.application":
    "Actividades de aplicaciones",
  "settings.notifications.activities.webcategories":
    "Actividades de categorías Web",
  "settings.notifications.activities.malware": "Actividades de Virus",
  "settings.notifications.secure.connection": "Conexión segura",
  "settings.notifications.dont.use": "No utilizar",
  "settings.notifications.from.email": "Remitente",
  "settings.notifications.recipient": "Destinatario",
  "settings.notifications.communities": "Comunidades",
  "settings.notifications.authentication.protocol":
    "Protocolo de Autenticación",
  "settings.notifications.engine.id": "Engine ID",
  "settings.notifications.level.security": "Nivel de seguridad",
  "settings.notifications.encryption.algorithm": "Algoritmo de encriptación",
  "settings.notifications.private.password": "Contraseña Privada",

  "services.firewall.generalSettings": "Configuraciones Generales",
  "services.firewall.generalSettings.security.settings":
    "Configuraciones de Seguridad",
  "services.firewall.generalSettings.timeout": "Timeout",
  "services.firewall.generalSettings.dos.protection": "Protección DoS",
  "services.firewall.generalSettings.ipSpoofing.protection":
    "Protección IP Spoofing",
  "services.firewall.generalSettings.portScan.protection":
    "Protección PortScan ",
  "services.firewall.generalSettings.invalidPacket.protection":
    "Protección de paquetes no válidos",
  "services.firewall.generalSettings.allow.ping": "Permitir Ping",
  "services.firewall.generalSettings.allow.imcpRedirect":
    "Permitir Redireccionamiento de ICMP",
  "services.firewall.generalSettings.ignore.icmp.broadcast":
    "Ignorar broadcast de ICMP",
  "services.firewall.generalSettings.source.routing": "Enrutamiento de Origen",
  "services.firewall.generalSettings.checksum": "Checksum",
  "services.firewall.generalSettings.fec": "Corrección de Error",
  "services.firewall.generalSettings.invalid.log": "Log no válido",
  "services.firewall.generalSettings.generic.timeout": "Tiempo límite Genérico",
  "services.firewall.generalSettings.icmp.timeout": "Tiempo límite ICMP",
  "services.firewall.generalSettings.tcp.loose": "TCP suelto",
  "services.firewall.generalSettings.tcp.max.retrans": "TCP Max Retrans",
  "services.firewall.generalSettings.tcp.timeout.close":
    "Tiempo límite de cerradura TCP",
  "services.firewall.generalSettings.tcp.timeout.close.wait":
    "Tiempo límite de espera de cerradura TCP",
  "services.firewall.generalSettings.tcp.timeout.established":
    "Tiempo límite de TCP establecido",
  "services.firewall.generalSettings.timeout.tcp.fin.wait":
    "Tiempo límite de espera TCP FIN",
  "services.firewall.generalSettings.tcp.timeout.last.ack":
    "Tempo Limite del último TCP ACK",
  "services.firewall.generalSettings.timeout.max.retrans":
    "Tiempo límite TCP Max Retrans",
  "services.firewall.generalSettings.timeout.tcp.syn.recv":
    "Tiempo límite TCP SYN Recebido",
  "services.firewall.generalSettings.timeout.tcp.syn.sent":
    "Tiempo límite TCP SYN Enviado",
  "services.firewall.generalSettings.timeout.tcp.time.wait":
    "Tiempo límite TCP del tiempo de espera",
  "services.firewall.generalSettings.udp.timeout": "Tiempo límite UDP",
  "services.firewall.generalSettings.udp.timeout.stream":
    "Tiempo límite UDP corriente",
  "services.firewall.generalSettings.confirm.message":
    "No será posible utilizar el servicio SD-WAN en las zonas de red seleccionadas. ¿Desea continuar? ",
  "services.firewall.generalSettings.success.message":
    "Configuraciones generales del Firewall actualizado con éxito",

  "services.firewall.zoneProtection.delete": "Eliminar Zona de Protección",
  "services.firewall.zoneProtection.delete.success": "eliminado con éxito",
  "services.firewall.zoneProtection.delete.confirm":
    "¿Seguro que desea eliminar los siguientes elementos?",
  "services.firewall.zoneProtection.delete.selected": "Eliminar Seleccionados",
  "services.firewall.zoneProtection.clone": "Clonar Zona de Protección",
  "services.firewall.zoneProtection.clone.confirm":
    "¿Seguro que desea clonar los siguientes elementos?",
  "services.firewall.zoneProtection.clone.selected": "Clonar Seleccionados",
  "services.firewall.zoneProtection.clone.success":
    "Política de Zona de Protección clonada con éxito",
  "services.firewall.zoneProtection.clone.error":
    "Error al clonar política de Zona de Protección",
  "services.firewall.zoneProtection.create": "Crear Zona de Protección",
  "services.firewall.zoneProtection.ipAddress": "Dirección IP{version}",
  "services.firewall.zoneProtection.warning": "Está deshabilitando una regla de protección de zona que contiene un servicio que se utiliza en la configuración operativa del proxy explícito. Para que funcione correctamente, esta regla debe estar habilitada.",
  "services.firewall.portForwarding": "Port Forwarding",
  "services.firewall.portForwarding.add": "Crear Port Forwarding",
  "services.firewall.portForwarding.del": "Eliminar Port Forwarding",
  "services.firewall.portForwarding.clone.confirm":
    "¿Seguro que desea clonar el seguinte item?",
  "services.firewall.portForwarding.clone.success":
    "Política de Port Forwarding clonada con éxito",
  "services.firewall.portForwarding.clone.error":
    "Error al clonar política de Port Forwarding",
  "services.firewall.portForwarding.modal.policy": "Política",
  "services.firewall.portForwarding.modal.conditions": "Condiciones",
  "services.firewall.portForwarding.modal.inspection": "Inspección",
  "services.firewall.portForwarding.modal.advanced": "Avanzado",
  "services.firewall.portForwarding.modal.policy.portrange": "Puerto / Rango",
  "services.firewall.portForwarding.modal.policy.redirect":
    "Redireccionar Para",
  "services.firewall.portForwarding.modal.policy.snat": "SNAT",
  "services.firewall.portForwarding.modal.policy.snat.default":
    "Gateway Estándar (Masquerade)",
  "services.firewall.portForwarding.modal.policy.jump": "Reenvío de puertos entre dominios de red",
  "services.firewall.portForwarding.modal.condition.src.allowed": "Permitidas",
  "services.firewall.portForwarding.modal.condition.src.blocked": "Bloqueadas",
  "services.firewall.portForwarding.modal.condition.schedule": "Programación",
  "services.firewall.portForwarding.modal.inspection.ssl": "SSL Inspection",
  "services.firewall.portForwarding.modal.inspection.atp": "Threat Blocking",
  "services.firewall.portForwarding.modal.inspection.ips":
    "Intrusion Prevention",
  "services.firewall.portForwarding.modal.inspection.dosProtection":
    "Protección DoS",
  "services.firewall.portForwarding.modal.inspection.packetRate":
    "Tasa de paquetes (paquetes/segundos)",
  "services.firewall.portForwarding.modal.inspection.burstRate":
    "Tasa de Explosión",
  "services.firewall.portForwarding.modal.dosProtection": "DoS Protection",
  "services.firewall.portForwarding.modal.packetRate":
    "Tasa de paquetes (paquetes/segundos)",
  "services.firewall.portForwarding.modal.burstRate": "Tasa de Explosión",
  "services.firewall.portForwarding.modal.error.interface.and.protocol":
    "No se permite redireccionar todo de la interfaz que se está utilizando para acceder lo servidor",
  "services.firewall.portForwarding.modal.error.equal.redirect":
    "Existe un redireccionamiento con estas características",
  "services.firewall.portForwarding.ssl.warning":
    "Regla de redireccionamiento con Inspección SSL sólo funcionan para servicios en que el protocolo de seguridad es compatible",

  //VPN NG
  "services.vpnng.error.userOrGroup": "¡Por favor ingrese un usuario o un grupo!",
  "services.vpnng.error.startingIPRangeIsReserved": "El intervalo de IP inicial está reservado.",
  "services.vpnng.error.startingIPRangeIsInvalid": "¡El intervalo de IP inicial no es válido!",
  "services.vpnng.error.endIPRangeIsReserved": "El rango de IP final está reservado.",
  "services.vpnng.error.endIPRangeIsInvalid": "El intervalo de IP final no es válido.",
  "services.vpnng.error.validLeaseLimit": "Ingrese un límite de lease válido, al menos tres caracteres",
  "services.vpnng.columns.ipInit": "IP iniciales",
  "services.vpnng.columns.ipLimit": "IP límite",
  "services.vpnng.columns.leaseLimit": "Lease límite",
  "services.vpnng.title.settings": "Configuración del servidor DHCP virtual",
  "services.vpnng.name": "Nome da VPN",
  "services.vpnng.sameName": "No se permiten los mismos nombres",
  "services.vpnng.virtual.host.ip": "Dirección IP del host virtual",
  "services.vpnng.start.ip": "Distribuye/Comienzo de dirección IP distribuida",
  "services.vpnng.limit.ip": "Distribui/Distribuiu Endereço IP límite",
  "services.vpnng.settings.title.optional": "Opciones aplicadas a los clientes (opcional)",
  "services.vpnng.title.add.users.groups": "Agregar usuarios y grupos de usuarios",


  "common.spanish": "Español",
  "system.general.message.disclaimer.es": "Mesage - Español",

  "common.disabled.success": "Desactivado con éxito",
  "settings.auth.keySsh": "Clave SSH",
  "settings.auth.keySsh.copySuccess": "¡Clave SSH copiada con éxito!",
  "settings.auth.keySsh.copy": "Copiar clave SSH",
  "settings.auth.filial.settings": "Configuraciones del Sucursal",
  "settings.auth.master.ip": "Dirección IP de la Master",
  "settings.auth.filial.tymeSync": "Tiempo de sincronización (segundos)",
  "settings.auth.action.import": "Importar Sucursales",
  "settings.auth.name.import": "Archivo del Sucursales",
  "settings.auth.action.copySSH": "Copiar clave SSH",
  "settings.auth.action.enabledFilial": "Activar sucursal",
  "settings.auth.keySsh.disable.confirm":
    "¿Está seguro de que desea desactivar las siguientes sucursales?",
  "settings.auth.change.confirm":
    "¿Está seguro de que desea cambiar el modo de sincronización del sesión?",

  "system.settings.certificate.nameInvalid": "Nombre inválido",
  "system.settings.certificate.nameExists":
    "El nombre del certificado ya existe",
  "system.settings.certificate.import": "Certificado importado",
  "system.settings.certificate.invalid": "Certificado inválido",
  "system.settings.certificate.importSucces": "Certificado importado con éxito",
  "system.settings.certificate.deleteErrorRemoteCAareUsedInProxy": "Este certificado está en uso en el módulo proxy y/o perfil ssl",
  "system.settings.certificate.input.certificateRequired":
    "El certificado es obligatorio",
  "system.settings.certificate.input.privateKeyRequired":
    "Se requiere clave privada",
  "system.settings.certificate.input.nameRequired": "Se requiere el nombre",
  "system.settings.certificate.deleteRemoteCA":
    "Certificado eliminado con éxito",
  "system.settings.certificate.deleteErrorRemoteCA":
    "No se puede eliminar el certificado",
  "system.settings.certificate.title.name": "Nombre",
  "system.settings.certificate.title.type": "Escribe",
  "system.settings.certificate.title.action": "Acción",
  "system.settings.certificate.tooltip.upload": "Certificado de importación",
  "system.settings.certificate.tooltip.trash": "Eliminar certificado",
  "system.settings.certificate.modal.title": "Importar CA",
  "system.settings.certificate.modal.labelCertificate": "Certificado",
  "system.settings.certificate.modal.labelPrivateKey": "Llave privada",
  "applicationControl.add.custom": "Agregar grupo de aplicaciones",
  "applicationControl.add.custom.smart": "Control Inteligente de Aplicaciones",
  "applicationControl.add.custom.group": "Agregar grupo personalizado",
  "applicationControl.add.custom.category": "Crear grupo de suscripción personalizado",
  "applicationControl.add.category": "Categorías de aplicaciones",
  "applicationControl.add.group": "Grupos de categorías",
  "applicationControl.delete.group": "¿Desea eliminar este elemento?",
  "settings.system.updates.Type": "Escribe",
  "settings.system.updates.Product": "Producto",
  "settings.system.updates.Version": "Versión",
  "settings.system.updates.Date": "Fecha",
  "settings.system.updates.Description": "Descripción",
  "settings.system.updates.Action": "Acción",
  "settings.system.updates.UninstallMessage": "¿Quieres eliminar este paquete?",
  "settings.system.updates.Uninstall": "Desistalar",
  "settings.system.updates.InstallMesage": "Paquete de instalación",
  "settings.system.updates.bbValidation": "este archivo no es de tipo bb",
  "settings.system.updates.bbModalTextUpload": "El archivo se está cargando, por favor espere...",
  "settings.system.updates.bbModalTextremoved": "El paquete se está eliminando, por favor espere...",
  "settings.system.updates.bbModalTextInstalled": "El paquete se está instalando, por favor espere...",
  "service.notifications.vpn.monitor.enable": "Supervisión de VPN Habilitada",
  "service.notifications.vpn.monitor.disable": "Supervisión de VPN Desabilitado",
  "profiles.title.dnscontentfilter": "DNS Content Filter",
  "common.profile.dnscontent": "Perfiles de DNS Content Filter",
  "profiles.default.dnscontentfilter": "Acción por defecto",
  "common.modal.form.error.redirect": "El campo Redireccionar es obligatorio",
  "system.settings.title.cardfilter": "Configuraciones avanzadas",
  "system.settings.title.input.processos": "Procesos simultáneos",
  "system.settings.title.input.theads": "Hilos por procesos",
  "system.settings.title.input.webproxy.transparente": "Solicitudes simultáneas de proxy transparente",
  "system.settings.title.input.webproxy": "Procesos WebProxy",
  "system.settings.title.input.webproxy.ativo": "Solicitudes de proxy activas simultáneas",
  "dhcp.allinterfacesv4.inuser": "Opción Todas las interfaces IPV4 registradas, por favor selecciona otra interfaz.",
  "dhcp.interfacesv4.inuser": "Ya tiene una interfaz con servidores IPV4 registrados, por favor, seleccione otra opción.",
  "common.allip": "Todas las interfaces IPV4",
  //MFA
  "system.mfa.portal": "Portal",
  "system.mfa.enable.admin": "Habilitar MFA Administradores",
  "system.mfa.enable.portal": "Habilitar MFA Captive Portal",
  "system.mfa.title.modal": "Generar token",
  "system.mfa.message.token.success": "¡Token generado exitosamente!",
  "system.mfa.message.token.error": "Error al generar token:",
  "system.mfa.message.token.alreadyExists.error": "Token Ya hay.",
  "system.mfa.message.token.copy": "El token fue copiado.",
  "system.mfa.message.delete.error": "No se puede eliminar el token.",
  "system.mfa.settings.title": "Controles MFA",
  "system.mfa.title": "Multi Factor Authentication",
  "cluster_popup.title1": "Deshabilitar el Protocolo Spanning Tree (STP):",
  "cluster_popup.paragraph1": "- Deshabilite el Protocolo Spanning Tree (STP) en las interfaces del switch para evitar conflictos con UCARP. Esto es necesario para garantizar una comunicación eficiente entre los nodos del clúster sin la interferencia de bucles de red gestionados por el STP.",
  "cluster_popup.title2": "Soporte para el Protocolo VRRP:",
  "cluster_popup.paragraph2": "- El switch debe soportar el protocolo VRRP (Protocolo de Redundancia de Router Virtual) según las especificaciones de las RFC 3768, 2787 y 5798. El VRRP es esencial para la redundancia de enrutamiento, permitiendo que una IP virtual sea compartida entre varios routers para aumentar la disponibilidad.",
  "cluster_popup.title3": "Configuración Correcta de las Interfaces de Red:",
  "cluster_popup.paragraph3": "- Asegúrese de que todas las interfaces de red involucradas en el Clúster estén configuradas correctamente y operativas. Preste especial atención a las interfaces LAN y DMZ, que son cruciales para la comunicación interna y externa del clúster.",
  "cluster_popup.title4": "Configuración de Direcciones IP Virtuales:",
  "cluster_popup.paragraph4": "- Configure correctamente las direcciones IP virtuales. UCARP utiliza estas direcciones para gestionar la asignación de roles de Master y Backup entre los servidores. La correcta configuración de las IPs virtuales es fundamental para la funcionalidad de failover.",
  "cluster_popup.titleButton": "Para más información, consulte el manual de Blockbit NGFW:",
  "cluster_popup.linkButton": "https://docs.blockbit.com/display/RCE/System+-+High+Availability+Tab",
  "kibana.service.down": "Para acceder a informes personalizados, configure el registrador en el dispositivo.",
  "kibana.loading": "Cargando...",
  "kibana.select.logger": "Seleccionar registrador",
  "common.selectAll": "Seleccionar Todos",
  "common.deselectAll": "Deseleccionar Todos",
};
export default enMessages;
